
import { defineComponent, onMounted, onUnmounted, ref, computed } from "vue";
// import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { ErrorMessage, Field, Form } from "vee-validate";
import Multiselect from "@vueform/multiselect";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import studiedEnglish from "@/components/gapTimeActivities/studied_english.vue";
import beingEmployed from "@/components/gapTimeActivities/being_employed.vue";
import workOnProject from "@/components/gapTimeActivities/work_on_project.vue";
import other from "@/components/gapTimeActivities/other.vue";
import policy from "@/components/modals/policy.vue";
import tableSize from "@/components/modals/tableSize.vue";
import guidePicture from "@/components/modals/guidePicture.vue";
import Dropzone from "dropzone";
import moment from "moment";
import axios from "@/axios-instance";
import { emitter } from "@/main";
import * as Yup from "yup";
import Permission from "@/core/config/Permission";
import { checkRoleIsAdmin } from "@/router";

import EnglishExemptionRefTable from "@/components/customers/EnglishExemptionRefTable.vue"; //bảng miễn giảm TA đọc từ Cài đặt (thay tableEng hardcode)


interface ProfileDetails {
  givenName: string;
  middleName: string;
  familyName: string;
  dateOfBirth: string;
  placeOfBirth: string;
  religion: string;
  gender: string;
  nationality: string;
  ethnic: string;
  idNumber: string;
  issuedDate: string;
  issuedBy: string;
  enrolledUmt: string;
  avatar: string;
  programtype: string
}
interface IContactInfo {
  permanentWard: string;
  permanentDistrict: string;
  permanentProvince: string;
  permanentWardId: string;
  permanentDistrictId: string;
  permanentProvinceId: string;
  permanentAddress: string;
  postalWardId: string;
  postalDistrictId: string;
  postalProvinceId: string;
  postalWard: string;
  postalDistrict: string;
  postalProvince: string;
  postalAddress: string;
  newPermanentProvinceCode: string;
  newPermanentWardCode: string;
  newPostalProvinceCode: string;
  newPostalWardCode: string;
  contactEmail: string;
  contactMobile: string;
  father: {
    fullName: string;
    currentAddress: string;
    dateOfBirth: string;
    occupation: string;
    mobile: string;
    email: string;
    relationship: string;
    agreeToReleaseOfStudyProgress: boolean;
    agreeToContactInEmergency: boolean;
  };
  mother: {
    fullName: string;
    currentAddress: string;
    dateOfBirth: string;
    occupation: string;
    mobile: string;
    email: string;
    relationship: string;
    agreeToReleaseOfStudyProgress: boolean;
    agreeToContactInEmergency: boolean;
  };
  guardian: {
    fullName: string;
    currentAddress: string;
    dateOfBirth: string;
    occupation: string;
    mobile: string;
    email: string;
    relationship: string;
    agreeToReleaseOfStudyProgress: boolean;
    agreeToContactInEmergency: boolean;
  };
}
interface ILearningProcess {
  highschoolName: string;
  highschoolProvince: string;
  highschoolDistrict: string;
  highschoolId: string;
  highschoolProvinceId: string;
  highschoolDistrictId: string;
  certificateNumber: string;
  yearOfGraduation: string;
}
interface ICollegesUniversities {
  programName: string;
  programLevel: string;
  studyLocation: string;
  from: string;
  to: string;
  ranktime: string[];
  status: string;
  awarded: string;
  id: string;
}

interface IPagination {
  currentPage: number;
  total: number;
  limit: number;
}
interface ISocialHealthcare {
  code: string;
  type: string;
  startedDate: string;
  expiredDate: string;
  hospital: string;
  premium: string;
  reason: string;
}
interface IEnglishCer {
  ielts: string;
  toeflIbt: string;
  toeic: string;
  aptis: string;
  pes: string;
  subjects: string;
}
interface IEnglishClassPlacementTest {
  registrationType: string;
  testdate?: string
  englishCertificate: {
    certificateName: string;
    examDate: string;
    expiredDate: string;
    score: string;
  };
  freeSubjects: string;
}

interface IUniform {
  defaultSize: string;
  purchaseQuality: number;
  purchaseSize: string;
  price: string;
  total: string;
}
interface IFreeTuitionRegistration {
  registrationTypeSiblings: boolean;
  registrationTypeForScholarships: boolean;
  scholarships: {
    type: string;
    value: string;
    releasedIn: string;
    calRate: string;
    discount: string;
  };
  siblings: {
    studentId: string;
    fullName: string;
  };
}
interface ITuitionRegistration {
  name: string;
  major: string;
  fee: string;
}
interface IOrderDetails {
  paymentMethod: string;
  promotion: {
    value?: string;
    endedDate?: string;
    promotionName?: string;
    promotionCode?: string;
    name?: string;
    type?: string;
    appliedType?: string;
    id?: number;
    amount?: number;
  };
  promotionAddition: {
    value?: string
    endedDate?: string;
    promotionName?: string;
    promotionCode?: string;
    name?: string;
    type?: string;
    appliedType?: string;
    id?: number;
    amount?: number;
    semester?: string
  }
  promotionMulti?: any
  otherPromotions?: Array<any>;
  otherPromotionsVip?: any;
  otherPromotionsVipPro?: any;
}
interface IFinancialSupportRegistration {
  bankName: string;
  description: string;
  isFinancialSupport: boolean;
}
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

function base64Mime(encoded) {
  var result = null as any;
  if (typeof encoded !== "string") {
    return result;
  }
  var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

  if (mime && mime.length) {
    result = mime[1];
  }
  return result;
}
export default defineComponent({
  name: "account-settings",
  components: {
    Multiselect,
    Datatable,
    studiedEnglish,
    beingEmployed,
    workOnProject,
    other,
    policy,
    guidePicture,
    tableSize,
    ErrorMessage,
    Field,
    Form,
    EnglishExemptionRefTable,
  },
  data() {
    return {
      current: "",
      isEditSchool: false,
      isEditStudies: false,
      isEditActivities: false,
      isEditProjects: false,
      isEditOthers: false,
    };
  },
  emits: ["callBackFunction"],
  props: {
    dataInitial: Object,
    dataReceipt: Object as any,
  },
  watch: {
    // whenever question changes, this function will run
    expiredPromotion(newData, olData) {
      // console.log('expiredPromotion',this.expiredPromotion)
      if(this.orderDetails && this.orderDetails.promotion?.value && this.orderDetails.promotion.value!='' && (!this.dataReceipt || !this.dataReceipt?.locked)) {
        emitter.emit("checkExpiredPromotion",this.expiredPromotion);
      }
    },
  },
  methods: {
    //Đóng drawer khi focus còn kẹt bên trong -> Element Plus set aria-hidden lên overlay đang chứa focus
    //(console warning "Blocked aria-hidden..."). Blur trước khi overlay ẩn để focus không bị giấu với screen reader.
    blurActiveEl() {
      const el = document.activeElement as HTMLElement | null;
      if (el && typeof el.blur === "function") { el.blur(); }
    },
    scholarshippromotionmultiChange(e) {
      this.firstLoad = false
      let nameinput = e.target.name
      let data = e.target._value
      data.nameinput = nameinput
      let index = this.scholarshipPromotionMultiData.findIndex(i=>i.nameinput == nameinput)
      // console.log('index',index)
      if(index > -1) {
        this.scholarshipPromotionMultiData[index] = data
      }
      else {
        this.scholarshipPromotionMultiData.push(data)
      }
      // console.log('scholarshipPromotionMultiData',this.scholarshipPromotionMultiData)
    },
    changeMultiPromotion(e) {
      this.firstLoad = false
      let nameinput = e.target.name
      let data = e.target._value
      data.nameinput = nameinput
      let index = this.promotionMultiData.findIndex(i=>i.nameinput == nameinput)
      // console.log('index',index)
      if(index > -1) {
        this.promotionMultiData[index] = data
      }
      else {
        this.promotionMultiData.push(data)
      }
    },
    changeScholaship(e) {
      this.firstLoad = false
      // console.log('this.dataScholarshipPro.scholarship',this.dataScholarshipPro.scholarship)
      if(!this.dataScholarshipPro.scholarship) {
        this.dataScholarshipPro.promotion = null
        this.dataScholarshipPro.promotionExtend = []
        // promotionExtend = []
      }
      if(this.orderDetails.otherPromotionsVipPro?.code) {
        this.orderDetails.otherPromotionsVipPro = {}
      }
      this.scholarshipPromotionMultiData = []
    },
    changePromotionExtend(e) {
      this.firstLoad = false
      // console.log('this.dataScholarshipPro.promotionExtend',this.dataScholarshipPro.promotionExtend)
      // let checked = e.target.checked
      // let promotion = e.target._value
      
      // if(checked) {
      //   this.dataScholarshipPro.promotionExtend.push(promotion)
      // }
      // else {
      //   console.log('aaaa',promotion.name)
      //   this.dataScholarshipPro.promotionExtend = this.dataScholarshipPro.promotionExtend.filter((i: any) => i.name != promotion.name)
      // }
    },
    changeTypeEnglish () {
      this.firstLoad = false
      this.englishClassPlacementTest.englishCertificate.score = ''
      this.englishClassPlacementTest.englishCertificate.certificateName = ''
      this.layoutSubject?.forEach((item) => {
        this.englishClassPlacementTest.englishCertificate[`score_${item.type}`] = ''
      })
      this.chooseCourses = {
        courseNextLevel: [],
        courseexemptions: [],
        code: '',
      }
    },
    changeChooseCourse () {
      this.firstLoad = false
      let courseNextLevel = [] as any
      let code = this.chooseCourses.code//.map((i: any) => i.code)
      let courseexemptions = [] as any

      // let a = courseexemptions[courseexemptions.length - 1]||{}
      // console.log('courseexemptions',a)
      // console.log('this.arrChooseCourseexemptions',this.arrChooseCourseexemptions)
      let records = this.arrChooseCourseexemptions.find((i: any) => i.code == code)
      // console.log('index records',records)
      if(records) {
        courseNextLevel = records.courses
        courseexemptions = records.courseExemptions
        // console.log('method courseexemptions',courseexemptions)
        // console.log('method courseNextLevel',courseNextLevel)
        this.chooseCourses.courseexemptions = courseexemptions
        this.chooseCourses.courseNextLevel = courseNextLevel
      }
      else {
        this.chooseCourses.courseexemptions = [] as any
        this.chooseCourses.courseNextLevel = [] as any
      }
      
      
      
    },
    rulesSiblings() {
      return this.freeTuitionRegistration.registrationTypeSiblings ? this.rulesDefault : {required: false}
    },
    //Người thân ĐƯỢC CHỌN nhận thông báo -> chỉ bắt buộc HỌ TÊN + DI ĐỘNG + NƠI Ở (chốt 2026-08-19);
    //ngày sinh/nghề nghiệp/email KHÔNG bắt buộc — template chỉ còn bind các rule này ở 3 field trên,
    //field khác đã gắn cứng { required: false }
    rulesFather() {
      return this.personalContacts.father.agreeToReleaseOfStudyProgress || this.personalContacts.father.agreeToContactInEmergency ? this.rulesDefault : {required: false}
    },
    rulesMother() {
      return this.personalContacts.mother.agreeToReleaseOfStudyProgress || this.personalContacts.mother.agreeToContactInEmergency ? this.rulesDefault : {required: false}
    },
    rulesGuardian() {
      return this.personalContacts.guardian.agreeToReleaseOfStudyProgress || this.personalContacts.guardian.agreeToContactInEmergency ? this.rulesDefault : {required: false}
    },
    previewFiles(event) {
      // console.log(event.target.files);
      getBase64(event.target.files[0]).then((data) => {
        // console.log(data)
        this.formData.avatar = data as any;
      });
    },
    changeDefaultSize() {
      // console.log(
      //   "this.uniformRegistration.purchaseSize",
      //   this.uniformRegistration.purchaseSize
      // );
      if (this.uniformRegistration.purchaseSize == "") {
        this.uniformRegistration.purchaseSize =
          this.uniformRegistration.defaultSize;
      }
    },
    async changeIsFinancialSupportNo() {
      if (this.financialSupportNo) {
        this.financialSupportRegistration.isFinancialSupport = false;
      }
      await this.submitFinancialSupport();
    },
    async changeBankName() {
      await this.submitFinancialSupport();
    },
    async changeIsFinancialSupport() {
      if (this.financialSupportRegistration.isFinancialSupport) {
        // this.orderDetails.paymentMethod = "cash";
        this.financialSupportNo = false;
      }
      await this.submitFinancialSupport();
    },
    changeTuitionRegistration() {
      this.freeTuitionRegistration.registrationTypeSiblings = false
      this.freeTuitionRegistration.siblings.studentId = "";
      this.freeTuitionRegistration.siblings.fullName = "";
      this.orderDetails.otherPromotions = []
      this.scholarshipPromotionMultiData = []
      // B: đổi mức học phí -> BỎ CHỌN các ưu đãi multi không còn hợp lệ ở mức mới (vd Con GV/NV đổi giá theo học kỳ),
      // GIỮ ưu đãi áp mọi mức (vd Ngày hội Nhập học). KHÔNG tự quy đổi (không có rule). Match theo (code,value) của mức mới.
      {
        const _valid = new Set();
        (this.dataPromotionListenMulti || []).forEach((p) => {
          (p.benefit || []).forEach((bnf) => { _valid.add(`${bnf.code}|${bnf.value}`); });
        });
        this.promotionMultiData = this.promotionMultiData.filter((i) => _valid.has(`${i.code}|${i.value}`));
      }
      this.firstLoad = false
      if(this.dataPromotionListenAddition) {
        if (this.dataPromotionListenAddition.benefit.length != 0 && this.orderDetails.promotionAddition) {
          this.orderDetails.promotionAddition.value = ''
          this.tempDataPromotionAddition = null
        }
      }
      else {
        this.orderDetails.promotionAddition.value = ''
        this.tempDataPromotionAddition = null
      }
      if(this.dataPromotionListen && !this.orderDetails.otherPromotionsVipPro.percent) {
        if (this.dataPromotionListen.benefit.length != 0 && this.orderDetails.promotion) {
          this.orderDetails.promotion.value =
            this.dataPromotionListen.benefit.filter(item =>!item.allowMultiPromotions)[0]?.value;
        }
      }
      else {
        // this.tempDataPromotion = null;
        this.orderDetails.otherPromotions = []
        this.tempDataPromotion = null;
      }
      this.changeChooseCourse()

    },
    changeNoneReleaseOfStudy(el) {
      if (el.target.value) {
        this.noneNotifiOfReg = false;
      }
    },
    changeAgreeToReleaseOfStudyProgress() {
      if (this.noneNotifiOfReg) {
        this.personalContacts.father.agreeToReleaseOfStudyProgress = false;
        this.personalContacts.mother.agreeToReleaseOfStudyProgress = false;
        this.personalContacts.guardian.agreeToReleaseOfStudyProgress = false;
      }
    },
    async onSelectTag(record) {
      await axios.put(`/admission/file/${record.id}`, { label: record.select });
    },
    onDeleteTag(record) {
      console.log(record);
    },
    async submitQrCode() {
      let tempData = {
        certificateBarcode: this.certificateBarcode,
        admissionRegistration: this.admissionRegistration,
      } as any
      tempData = this.funcHistories(tempData)
      await axios
        .put(`/applicant/admin/${this.id}`, tempData)
        .then(({ data }) => {
          this.isSubmitQr = false;
        })
        .catch(({ response }) => {
          this.popupMessage(response.data?.errorMessage,'error')
          console.log("err", response);
        });
    },
    //close=true chỉ khi bấm Lưu ở footer; @change auto-save giữ nguyên chế độ chỉnh sửa
    async submitFinancialSupport(close = false) {
      let tempFinancialSupport = null as any;
      if (this.financialSupportRegistration.isFinancialSupport) {
        let temp = this.dataBank.filter(
          (item) =>
            item.bankName == this.financialSupportRegistration.bankName &&
            !item.disabled
        );
        if (temp.length != 0) {
          this.financialSupportRegistration.bankName = temp[0].bankName;
          this.financialSupportRegistration.description = temp[0].description;
        } else {
          this.financialSupportRegistration.bankName = "";
          this.financialSupportRegistration.description = "";
        }
        tempFinancialSupport = {
          bankName: this.financialSupportRegistration.bankName,
          description: this.financialSupportRegistration.description,
          isFinancialSupport:
            this.financialSupportRegistration.isFinancialSupport,
        };
        await this.submitPayments();
      }
      let tempData = {
        financialSupportRegistration: tempFinancialSupport,
        admissionRegistration: this.admissionRegistration,
      };
      // console.log('tempData',tempData)
      tempData = this.funcHistories(tempData)
      await axios
        .put(`/applicant/admin/${this.id}`, tempData)
        .then(({ data }) => {
          this.dataReset = data.item;
          if (close) {
            this.isShowFinancialSupport = false;
          }
        })
        .catch(({ response }) => {
          this.popupMessage(response.data?.errorMessage,'error')
          console.log("err", response);
        });
    },

    async submitsupportServices() {
      let tempServices = JSON.parse(JSON.stringify(this.supportServices));
      if (tempServices.includes("other")) {
        let index = tempServices.findIndex((i) => i == "other");
        tempServices[index] =
          tempServices[index] + "|" + this.supportServicesOther;
      }
      let tempData = {
        supportServices: tempServices,
        // "isFinancialSupport": this.isFinancialSupport=='1',
        admissionRegistration: this.admissionRegistration,
      };
      tempData = this.funcHistories(tempData)
      await axios
        .put(`/applicant/admin/${this.id}`, tempData)
        .then(({ data }) => {
          this.dataReset = data.item;
          this.isShowFormService = false;
        })
        .catch(({ response }) => {
          this.popupMessage(response.data?.errorMessage,'error')
          console.log("err", response);
        });
    },
    addQuantity(param,index) {
      this.otherFees[index][param] = +this.otherFees[index][param] + 1;
    },
    minusQuantity(param,index) {
      if (this.otherFees[index][param] > 0)
        this.otherFees[index][param] = +this.otherFees[index][param] - 1;
    },
    async submitEnglishClass() {
      if (!this.submitButtonEng) { return }
        this.submitButtonEng.validate(async (valid) => {
          if (valid) {
            let temp = JSON.parse(JSON.stringify(this.englishClassPlacementTest)) as any
          if (
            temp.registrationType != "english_certificate" && temp.registrationType != "english_thpt"
          ) {
            delete temp.freeSubjects
            delete temp.englishCertificate
          }
          if(temp.registrationType != "umt_test") {
            delete temp.testdate
            delete temp.freeSubjects
            
          }
          // console.log('englishClassPlacementTestRegistration',temp)
          let tempData = {
            englishClassPlacementTestRegistration: temp,
            admissionRegistration: this.admissionRegistration,
          } as any
          
          if(this.submitButton4) {
            this.submitButton4.validate(async (valid) => {
              if (valid) {
                tempData = Object.assign(tempData, this.dataPayments);
              }
            })
          }
          if(this.arrCourseexemptions) {
            tempData.freeTuitionRegistration = this.formatTuitionReg()
          }
          tempData = this.funcHistories(tempData)
          await axios
            .put(`/applicant/admin/${this.id}`, tempData)
            .then(({ data }) => {
              this.dataReset = data.item;
              this.isShowEnglishClass = false;
            })
            .catch(({ response }) => {
              this.popupMessage(response.data?.errorMessage,'error')
              console.log("err", response);
            });
          }
        })
      
    },

    socialHealthcareChange() {
      // if(this.socialHealthcareInsuranceRegistration.type == 'other') {
      //   this.isHealthInsurance = '-1'
      // }
    },
    updateGaptime(data) {
      delete this.dataReset.gapTimeActivities;
      setTimeout(() => {
        this.dataReset.gapTimeActivities = data;
      }, 100);
    },
    addRowSchool() {
      this.isShowFormSchool = true;
      this.isEditSchool = false;
      this.collegesUniversities.ranktime = ["", ""];
      this.collegesUniversities.from = "";
      this.collegesUniversities.to = "";
      this.collegesUniversities.status = "";
      this.collegesUniversities.programLevel = "";
      this.collegesUniversities.programName = "";
      this.collegesUniversities.studyLocation = "";
    },
    editRow(record) {
      this.isShowFormSchool = true;
      this.isEditSchool = true;
      this.collegesUniversities = JSON.parse(JSON.stringify(record));
      this.collegesUniversities.status =
        record.status == "Đã hoàn tất" ? "true" : "false";
    },
    deleteRow(record) {
      Swal.fire({
        text: `Bạn có muốn xóa thông tin này?`,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Trở lại",
        customClass: {
          confirmButton: "btn btn-primary order-2",
          cancelButton: "btn btn-light order-1",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          let index = this.tableData.findIndex(
            (i: any) => i.id == this.collegesUniversities.id
          );
          this.tableData.splice(index, 1);
          let tempData = {
            collegesUniversities: this.tableData,
            admissionRegistration: this.admissionRegistration,
          };
          tempData = this.funcHistories(tempData)
          await axios
            .put(`/applicant/admin/${this.id}`, tempData)
            .then(({ data }) => {
              this.cancleSchool();
              this.dataReset.collegesUniversities =
                data.item.collegesUniversities;
            })
            .catch(({ response }) => {
              this.popupMessage(response.data?.errorMessage,'error')
              console.log("err", response);
            });
        }
        Swal.close();
      });
    },
    async submitForSchool() {
      if (!this.forSchool) { return }
      this.forSchool.validate(async (valid) => {
        if (valid) {
          this.collegesUniversities.from =
            this.collegesUniversities.ranktime[0] != ""
              ? moment(this.collegesUniversities.ranktime[0]).format("DD/MM/YYYY")
              : "";
          this.collegesUniversities.to =
            this.collegesUniversities.ranktime[1] != ""
              ? moment(this.collegesUniversities.ranktime[1]).format("DD/MM/YYYY")
              : "";
          this.collegesUniversities.status = this.collegesUniversities.status
            ? "Đã hoàn tất"
            : "Chưa hoàn tất";
          if (this.isEditSchool) {
            let index = this.tableData.findIndex(
              (i: any) => i.id == this.collegesUniversities.id
            );
            this.tableData[index] = this.collegesUniversities;
          } else {
            this.collegesUniversities.id = this.tableData.length.toString();
            this.tableData.push(this.collegesUniversities);
          }
          let tempData = {
            collegesUniversities: this.tableData,
            admissionRegistration: this.admissionRegistration,
          };
          tempData = this.funcHistories(tempData)
          await axios
            .put(`/applicant/admin/${this.id}`, tempData)
            .then(({ data }) => {
              this.isShowFormSchool = false;
              this.tableData = data.item.collegesUniversities
              if (!this.isEditSchool) {
                this.dataReset.collegesUniversities =
                  data.item.collegesUniversities;
              }
            })
            .catch(({ response }) => {
              this.popupMessage(response.data?.errorMessage,'error')
              console.log("err", response);
            });
        }
      })
      
    },
    moment: function (date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
    resetDataInfo() {
      this.initFormData();
      this.editProfileDetails = false;
    },
    resetPersonalContacts() {
      this.initDataPersonalContacts();
      this.editPersonalContacts = false;
    },
    resetLearningProcess() {
      this.initLearningProcess();
      this.editLearningProcess = false;
    },
    resetPartyInfo() {
      this.initMoreinfo();
      this.editPartyInfo = false;
    },
    resetRelatives() {
      this.initDataPersonalContacts();
      this.editRelatives = false;
    },
    async deleteFile(record) {
      let index = this.tableDataImg.findIndex((item) => item.id == record.id);
      this.tableDataImg.splice(index, 1);
      await axios.delete(`/admission/file/${record.fileName}`);
    },
    getTypeFile(type) {
      let dotFile = "folder-document";
      if (!type) {
        return dotFile;
      }
      if (type.indexOf("image") != -1) {
        dotFile = "image";
      } else if (type.indexOf("pdf") != -1) {
        dotFile = "pdf";
      } else if (
        type.indexOf("msword") != -1 ||
        type.indexOf("wordprocessingml.document") != -1
      ) {
        dotFile = "doc";
      } else if (
        type.indexOf("excel") != -1 ||
        type.indexOf("spreadsheetml.sheet") != -1
      ) {
        dotFile = "excel";
      } else if (
        type.indexOf("zip") != -1 ||
        type.indexOf("compressed") != -1
      ) {
        dotFile = "zip";
      } else {
        dotFile = "folder-document";
      }
      return dotFile;
    },
    resetDataFiles() {
      this.tableDataImg = [] as any;
      let this_ = this;
      Dropzone.autoDiscover = false;
      if (Dropzone.instances.length > 0) {
        Dropzone.instances.forEach((e: any) => {
          e.off();
          e.destroy();
        });
      }
      let myDropzone = new Dropzone("#id_dropzone", {
        url: `${process.env.VUE_APP_API_URL}/admission/file`,
        dictDefaultMessage: "Nhấn vào đây để tải tệp đính kèm lên",
        dictInvalidFileType: "Bạn không thể tải tệp không đúng định dạng",
        dictFileTooBig: "Kích thước tệp quá lớn. Tối đa 6MB",
        dictMaxFilesExceeded: "Bạn chỉ được upload tối đa 20 files",
        maxFilesize: 6,
        maxFiles: 20,
        addRemoveLinks: true,
        acceptedFiles: `image/*, application/pdf,
                            application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, 
                            application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, 
                            application/x-zip-compressed`,
        uploadprogress: function (file, progress, bytesSent) {
          if (file.previewElement) {
            var progressElement = document.querySelector(
              ".data-dz-uploadprogress"
            ) as any;
            progressElement.style.width = progress + "%";
          }
        },
        sending: function (file, xhr, formData) {
          let mockFile = {
            fileName: "",
            filePath: "",
            fileType: file.type,
            id: file.upload.uuid,
            label: "",
            processing: true,
          };
          this_.tableDataImg.push(mockFile as any);
        },
        init: function () {
          var startUpload = document.getElementById("uploadFiles");
          // myDropzone = this;
          // myDropzone.removeAllFiles()
          document.querySelectorAll(".dz-preview").forEach((e) => e.remove());

          startUpload?.addEventListener("click", function (file) {
            //console.log('file',file)
            //myDropzone.processQueue();
          });
          this.on("removedfile", async function (file) {
            if (file && file.fileName) {
              await axios.delete(`/admission/file/${file.fileName}`);
            }
          });
          this.on("success", function (file, response) {
            file.fileName = response.successFiles[0]?.fileName;
            this_.pushFileLocal(response, file.upload.uuid);
          });
        },
      });
    },
    pushFileLocal(response, id = null) {
      if (id) {
        let index = this.tableDataImg.findIndex((item) => item.id == id);
        this.tableDataImg.splice(index, 1);
      }
      let mockFile = {
        fileName: response.successFiles[0]?.fileName,
        filePath: response.successFiles[0]?.filePath,
        fileType: response.successFiles[0]?.fileType,
        id: response.successFiles[0]?.id,
        label: "",
      };
      // console.log('mockFile',mockFile)
      this.tableDataImg.push(mockFile);
      // console.log('tableDataImg',this.tableDataImg)
    },

    tabactiveData(active, param) {
      this.uniformRegistration[param] = active;
      if (
        param == "defaultSize" &&
        this.uniformRegistration.purchaseSize == ""
      ) {
        this.uniformRegistration.purchaseSize =
          this.uniformRegistration.defaultSize;
      }
    },
    tabactiveSaleData(active, index) {
      this.otherFees[index].size = active;
    },
    cancleSchool() {
      this.isShowFormSchool = false;
    },
    cancleStudies() {
      this.isShowFormStudies = false;
    },
    cancleActivities() {
      this.isShowFormActivities = false;
    },
    addProjects() {
      this.isShowFormProjects = true;
    },
    cancleProjects() {
      this.isShowFormProjects = false;
    },
    addOthers() {
      this.isShowFormOthers = true;
    },
    cancleOthers() {
      this.isShowFormOthers = false;
    },
  },
  mounted() {
    // console.log('arrChooseCourseexemptions',this.arrChooseCourseexemptions)

    if (document.getElementById("id_dropzone")) {
      this.resetDataFiles();
    }
  },
  setup(props, { emit }) {
    const dataPromotionSpecial = ref<any>([])
    const dataPromotionManual = ref<any>([])
    const promotionMultiData = ref<any>([])
    const scholarshipPromotionMultiData = ref<any>([])
    const userLocal = computed(() => {
        let temp = window.localStorage.getItem("user")
        return temp ? JSON.parse(temp) : null
    });
    // users.role lưu ID permission dạng CHUỖI SỐ ("1" = superadmin), không phải tên.
    // Guard optional: chưa đăng nhập / localStorage trống thì userLocal = null -> đọc .role sẽ nổ TypeError.
    const isSuperAdmin = computed(() => {
      return userLocal.value?.role == 1
    });
    // Hồ sơ ĐÃ CHUYỂN GIAO SIS (open=false) -> khoá mọi nút Chỉnh sửa. BE cũng chặn ở _verifyBeforeUpdate2,
    // để nút mở chỉ khiến NV sửa xong bấm Lưu mới báo lỗi. Superadmin giữ lối vào để xử lý sự cố.
    // (Trước đây viết `if (isSuperAdmin)` thiếu .value -> computed luôn truthy nên KHÔNG khoá được ai.)
    // Chưa có dataInitial (đang tải) thì KHÔNG khoá, tránh nháy khoá rồi mở.
    const isChuyengiao = computed(() => {
      if (isSuperAdmin.value) return false
      return props.dataInitial ? props.dataInitial.open === false : false
    });
    // Phiếu ĐÃ HỦY = bản ghi lịch sử bất biến -> khóa mọi nút Chỉnh sửa (kể cả superadmin;
    // backend cũng chặn dùng lại phiếu cancel). Chỉ xem/truy vết.
    const isCancelled = computed(() => props.dataInitial?.status === 'cancel');
    // Khóa CHỈNH SỬA các section: đã hủy HOẶC đã HOÀN TẤT (confirmed — đã sinh MSV + đẩy SIS,
    // sửa tiếp gây lệch SIS; nghiệp vụ 2026-07-16). Khối trạng thái cuối vẫn theo isCancelled
    // (confirmed cần nút "Gửi email báo phí").
    // ===== SỬA HỒ SƠ ĐÃ CHỐT (đã hoàn tất / đã chuyển giao SIS) =====
    // Hoàn tác cả hồ sơ chỉ để sửa 1 thông tin nhỏ là quá tay — mà "Hoàn tác xác nhận" còn tự chặn khi
    // hồ sơ đã chuyển giao, nên bàn giao xong là hết đường sửa. Đổi lại: Superadmin BẬT chế độ sửa,
    // nhập LÝ DO một lần -> mọi payload Lưu sau đó tự kèm editReason (funcHistories), BE ghi [TIMELINE]
    // + đẩy lại SIS. Nhóm TIỀN vẫn khoá (BE ép giữ nguyên MONEY_FIELDS) vì SIS/BC đã sinh công nợ.
    const isFinalApplicant = computed(() => !isCancelled.value
      && (props.dataInitial?.status === 'confirmed' || props.dataInitial?.open === false));
    const finalEditMode = ref(false);
    const finalEditReason = ref('');
    // Khoá các mục THÔNG TIN (cá nhân/liên lạc/học tập/người thân/tư vấn/tiếng Anh...): hồ sơ đã chốt
    // chỉ mở khi Superadmin bật chế độ sửa. Các mục TIỀN vẫn dùng isLocked -> khoá cứng.
    const isLockedInfo = computed(() => isCancelled.value
      || (isFinalApplicant.value && !(isSuperAdmin.value && finalEditMode.value)));
    // Khoá các mục TIỀN (học phí/ưu đãi/học bổng/bảo hiểm/thanh toán/hỗ trợ tài chính) trên hồ sơ đã chốt:
    // SIS/BC đã sinh công nợ - hóa đơn theo số cũ. KHÔNG mở kể cả Superadmin ở chế độ sửa (BE cũng ép giữ
    // nguyên MONEY_FIELDS) — muốn đổi tiền thì "Hoàn tác xác nhận" rồi sửa như hồ sơ chưa chốt.
    const isLocked = computed(() => isCancelled.value || isFinalApplicant.value);
    const moreinfo = ref<any>(props.dataInitial?.moreinfo||{})
      const optionsPrograms = ref([
      {
        label: "Tiếng Việt",
        value: 'TIENG_VIET'
      },
      {
        label: "Song ngữ",
        value: 'SONG_NGU'
      },
    ])
    function popupLoading() {
      Swal.fire({
        html: "<div class='custom-loading'><span>Đang xử lý. Vui lòng chờ trong giây lát!!!</span> <span class='loader'></span></div>",
        buttonsStyling: false,
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
      }).then(() => {
        //
      });
    }
    const popupMessage = (text, icon) => {
      Swal.fire({
          text: text,
          icon: icon,
          buttonsStyling: false,
          confirmButtonText: "Đóng",
          customClass: {
              confirmButton: "btn btn-primary",
          },
          })
    } 
    const completeAdmission = async () => {
      // SOFT gate: rà "vướng" TRƯỚC khi confirm (thiếu field / lệch 3 bảng / vướng học phí: ưu đãi deactivate-quá hạn).
      // Có vướng -> admin chọn Tiếp tục (bắt ghi lý do -> timeline) hoặc Quay lại. Lỗi check -> KHÔNG chặn confirm.
      try {
        const { data: pre } = await axios.get(`/applicant/preconfirm-check/${id.value}`)
        if (pre && pre.total > 0) {
          const groups: string[] = []
          if (pre.missingFields?.length) groups.push(`<b>Thiếu thông tin bắt buộc:</b> ${pre.missingFields.join(', ')}`)
          if (pre.syncDiffs?.length) groups.push(`<b>Lệch giữa Nhập học / Ứng viên / Trúng tuyển:</b> ${pre.syncDiffs.join(', ')}`)
          if (pre.tuitionIssues?.length) groups.push(`<b>Vướng học phí/ưu đãi:</b><br/>${pre.tuitionIssues.map((t: string) => '• ' + t).join('<br/>')}`)
          const confirmPre = await Swal.fire({
            title: 'Hồ sơ còn vướng trước khi hoàn tất',
            html: `${groups.join('<br/><br/>')}<br/><br/>Bạn muốn <b>Tiếp tục</b> hoàn tất (ghi nhận lý do) hay <b>Quay lại</b> để sửa?`,
            icon: 'warning',
            input: 'text',
            inputPlaceholder: 'Ghi lý do/giải trình (bắt buộc nếu tiếp tục)',
            inputValidator: (v: any) => (!v || !String(v).trim()) ? 'Vui lòng ghi lý do để tiếp tục' : null,
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: 'Tiếp tục hoàn tất',
            cancelButtonText: 'Quay lại',
            customClass: { confirmButton: 'btn btn-warning', cancelButton: 'btn btn-light' },
          })
          if (!confirmPre.isConfirmed) { return }  // Quay lại -> KHÔNG confirm
          try {
            const _u = JSON.parse(window.localStorage.getItem('user') || '{}')
            const _all = [
              ...(pre.missingFields || []).map((x: string) => 'thiếu ' + x),
              ...(pre.syncDiffs || []).map((x: string) => 'lệch ' + x),
              ...(pre.tuitionIssues || []),
            ]
            axios.post('/admission/comment', {
              idUser: _u.id,
              idStudent: pre.studentId || props.dataInitial?.studentId,
              comment: `[TIMELINE] Hoàn tất nhập học DÙ còn vướng: ${_all.join('; ')}. Lý do: ${String(confirmPre.value).trim()}`,
            }).catch(() => {})
          } catch (e) { /* timeline phụ trợ */ }
        }
      } catch (e) { /* lỗi pre-check -> không chặn confirm */ }

      let tempData = {
          admissionRegistration: admissionRegistration.value,
        };

        popupLoading();
        await axios
          .put(`/applicant/confirm/${id.value}`, tempData)
          .then(({ data }) => {
            Swal.close();
            // Tới nhánh này là ĐÃ confirmed (lỗi CHẶN thiếu field/lệch đã throw 400 -> rơi vào .catch).
            // data.errors ở đây là lỗi KHÔNG chặn (Azure/SIS...) -> báo cho NV RỒI reload để thấy hồ sơ đã confirmed.
            if(data.errors && data.errors.length != 0) {
              Swal.fire({
                text: data.errors.join('\n'),
                icon: 'warning',
                buttonsStyling: false,
                confirmButtonText: 'Đóng',
                customClass: { confirmButton: 'btn btn-primary' },
              }).then(() => location.reload())
              return
            }
            location.reload();
          })
          .catch(({ response }) => {
            // Lỗi thật khi confirm (vd chưa 'open' / học bổng mất grant / lỗi server) -> hiện lỗi, KHÔNG reload.
            Swal.close();
            popupMessage(response?.data?.errorMessage || response?.data?.message || 'Có lỗi khi xác nhận hoàn tất. Vui lòng thử lại.','error');
          });
    };
    // Bật chế độ sửa hồ sơ ĐÃ CHỐT: bắt nhập LÝ DO (BE cũng chặn <10 ký tự) rồi cảnh báo hệ quả bên SIS.
    // Hỏi SIS xem hồ sơ đã chuyển thành SINH VIÊN chưa: nếu rồi thì sửa bên này CHỈ đẩy lại adm_applicant,
    // hồ sơ sinh viên bên SIS phải nhờ PĐT đồng bộ tay (SIS không có API ghi sang bản sinh viên).
    const enableFinalEdit = async () => {
      const { value: reason } = await Swal.fire({
        title: 'Chỉnh sửa hồ sơ đã hoàn tất',
        width: 560,
        html: `<div class="text-start fs-7 text-gray-800">
              Mỗi lần Lưu sẽ ghi lý do + nội dung thay đổi vào lịch sử hồ sơ và đẩy lại SIS.
              Nhóm học phí / bảo hiểm / thanh toán vẫn khóa.
            </div>`,
        input: 'textarea',
        inputPlaceholder: 'Lý do chỉnh sửa (tối thiểu 10 ký tự)',
        inputAttributes: { 'aria-label': 'Lý do chỉnh sửa' },
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Bật chỉnh sửa',
        cancelButtonText: 'Hủy',
        customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-light' },
        inputValidator: (v) => (!v || String(v).trim().length < 10)
          ? 'Vui lòng nhập lý do chỉnh sửa (tối thiểu 10 ký tự)'
          : null,
      });
      if (!reason) return;
      finalEditReason.value = String(reason).trim();
      finalEditMode.value = true;
      //Nhắc đồng bộ SIS (fail-soft: không hỏi được SIS thì vẫn nhắc, chỉ nói rõ là chưa kiểm tra được)
      let sis: any = null;
      try {
        const { data } = await axios.get(`/applicant/sis-student-status/${id.value}`);
        sis = data;
      } catch (e) { /* SIS lỗi/timeout -> nhắc chung bên dưới */ }
      const isStudent = sis?.isStudent === true;
      const unknown = !sis || sis?.checked === false;
      if (isStudent || unknown || props.dataInitial?.open === false) {
        Swal.fire({
          title: 'Nhớ đồng bộ bên SIS',
          icon: 'warning',
          width: 560,
          html: `<div class="text-start fs-7 text-gray-800">
                <div class="mb-2">${isStudent
                  ? 'SIS đã chuyển hồ sơ này thành <b>sinh viên</b>.'
                  : (unknown ? 'Không kiểm tra được trạng thái bên SIS.' : 'Hồ sơ này đã <b>chuyển giao</b> sang SIS.')}
                  Lưu chỉ đẩy lại bản <b>applicant</b>, hồ sơ sinh viên bên SIS không tự cập nhật.</div>
                <div>Sửa xong báo Phòng Đào tạo đồng bộ applicant → sinh viên.</div>
              </div>`,
          buttonsStyling: false,
          confirmButtonText: 'Đã hiểu',
          customClass: { confirmButton: 'btn btn-warning' },
        });
      }
    };
    const disableFinalEdit = () => {
      finalEditMode.value = false;
      finalEditReason.value = '';
    };
    const reopenProfile = async () => {
      const confirm = await Swal.fire({
        title: 'Mở lại phiếu?',
        html: 'Hồ sơ sẽ chuyển về trạng thái <b>Đang xử lý</b> để ứng viên đăng nhập cập nhật lại. Bạn chắc chứ?',
        icon: 'warning',
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Mở lại phiếu',
        cancelButtonText: 'Hủy',
        customClass: { confirmButton: 'btn btn-warning', cancelButton: 'btn btn-light' },
      });
      if (!(confirm.isConfirmed || confirm.value)) return;
      popupLoading();
      await axios
        .put(`/applicant/reopen/${id.value}`)
        .then(({ data }) => {
          Swal.close();
          popupMessage(data.message || 'Đã mở lại phiếu.', 'success');
          setTimeout(() => location.reload(), 1200);
        })
        .catch(({ response }) => {
          Swal.close();
          popupMessage(response?.data?.errorMessage || 'Không mở lại được phiếu. Vui lòng thử lại.', 'error');
        });
    };
    // Chuyển ĐỢT XÉT của phiếu nhập học (applicants.phase — đợt đẩy sang SIS lúc chuyển giao).
    // KHÔNG đụng đợt gốc lúc xét tuyển trên hồ sơ ĐKXT/trúng tuyển; vết đổi BE ghi [TIMELINE].
    const changePhase = async () => {
      const inputOptions: Record<string, string> = {}
      try {
        const { data } = await axios.get('/phase')
        ;(data || []).forEach((p: any) => {
          if (p?.phaseNo) inputOptions[String(p.phaseNo)] = `Đợt ${p.phaseNo}`
        })
      } catch (e) { /* không tải được danh mục đợt -> fallback 1..11 bên dưới */ }
      if (!Object.keys(inputOptions).length) {
        for (let i = 1; i <= 11; i++) inputOptions[String(i)] = `Đợt ${i}`
      }
      const cur = props.dataInitial?.phase
      const confirm = await Swal.fire({
        title: 'Chuyển đợt xét',
        width: 560, //mặc định ~32em làm gạch đầu dòng rớt hàng
        //chú thích để fs-8 text-muted bị chê mờ khó đọc -> fs-7 + gray-800, canh trái từng dòng
        html: `<div class="fs-6 mb-3">Đợt hiện tại: <b>${cur || '(trống)'}</b></div>
            <ul class="text-start fs-7 text-gray-800 ps-5 mb-0" style="display:inline-block">
                <li class="mb-1">Đợt mới sẽ dùng khi <b>chuyển giao SIS</b>.</li>
                <li class="mb-1">Đợt lúc xét tuyển trên hồ sơ ĐKXT/trúng tuyển <b>giữ nguyên</b>.</li>
                <li>Thao tác được <b>ghi vào lịch sử hồ sơ</b>.</li>
            </ul>`,
        icon: 'question',
        input: 'select',
        inputOptions,
        inputValue: cur ? String(cur) : '',
        inputPlaceholder: '— Chọn đợt —',
        inputValidator: (v: any) => {
          if (!v) return 'Vui lòng chọn đợt'
          if (String(v) === String(cur)) return `Hồ sơ đang ở đợt ${cur} rồi — chọn đợt khác`
          return null
        },
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Chuyển đợt',
        cancelButtonText: 'Hủy',
        //select mặc định của Swal chiếm hết bề ngang + viền đen thô -> thu gọn, bo theo form-select
        customClass: {
          input: 'form-select w-200px mx-auto fs-6',
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-light',
        },
      })
      if (!confirm.isConfirmed) return
      popupLoading()
      await axios
        .put(`/applicant/phase/${id.value}`, { phase: Number(confirm.value) })
        .then(({ data }) => {
          Swal.close()
          popupMessage(data.message || 'Đã chuyển đợt.', 'success')
          setTimeout(() => location.reload(), 1200)
        })
        .catch(({ response }) => {
          Swal.close()
          popupMessage(response?.data?.errorMessage || 'Không chuyển được đợt. Vui lòng thử lại.', 'error')
        })
    }
    // Hoàn tác xác nhận hoàn tất (confirmed -> completed) để sửa tiếp hồ sơ đã chốt. CHỈ Superadmin.
    // KHÔNG thu hồi MSSV/email/tài khoản Azure/bản ghi SIS (không undo được ở hệ ngoài) — chúng được
    // ghi đè lại khi Lưu hồ sơ + Xác nhận lại. Sau khi hoàn tác, nút "Mở lại phiếu" xuất hiện nếu
    // muốn cho chính sinh viên đăng nhập sửa.
    const undoConfirmProfile = async () => {
      const confirm = await Swal.fire({
        title: 'Hoàn tác xác nhận hoàn tất?',
        html: 'Hồ sơ quay về trạng thái <b>Chờ xác nhận</b> để chỉnh sửa.<br/>'
            + 'Vẫn <b>giữ nguyên MSSV, email trường</b> và bản ghi đã đẩy SIS.<br/>'
            + 'Sửa xong phải bấm <b>"Xác nhận hoàn tất"</b> lại.',
        icon: 'warning',
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Hoàn tác xác nhận',
        cancelButtonText: 'Hủy',
        customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-light' },
      });
      if (!(confirm.isConfirmed || confirm.value)) return;
      popupLoading();
      await axios
        .put(`/applicant/undo-confirm/${id.value}`)
        .then(({ data }) => {
          Swal.close();
          popupMessage(data.message || 'Đã hoàn tác xác nhận.', 'success');
          setTimeout(() => location.reload(), 1200);
        })
        .catch(({ response }) => {
          Swal.close();
          popupMessage(response?.data?.errorMessage || 'Không hoàn tác được. Vui lòng thử lại.', 'error');
        });
    };
    const PROMOTIONSIBLING = ref<any>({
      code: 'SVSL'
    })
    const PROMOTIONENG = ref<any>({
      none: {
        value: 4500000,
        label: "Giảm 50% học phí English made easy",
      }
    })
    const reduceEnglish = computed(() => {
      if(firstLoad.value) {
        return loadReduceEnglish.value
      }
      let val = englishClassPlacementTest.value.registrationType
      if((arrCourseexemptions.value && arrCourseexemptions.value.length == 0)) {
        val = 'none'
      }
      // console.log('val',val)
      return null //PROMOTIONENG.value[val] ? PROMOTIONENG.value[val] : null
    });
    
    const optionsTypeCondition = ref<any>({
      "nghe-va-doc": "Nghe và đọc",  
      "viet": "Viết",  
      "noi": "Nói",  
    }) 
    //MIỄN GIẢM TIẾNG ANH THEO GÓI HỌC PHÍ: đóng N học kỳ -> miễn N môn ĐẦU trong danh sách môn của
    //bậc chứng chỉ (Cài đặt thủ tục nhập học > Điều kiện tiếng Anh). Gói dài hơn số môn = miễn hết.
    //=> Danh mục môn trong Cài đặt phải xếp ĐÚNG THỨ TỰ HỌC; môn chưa điền tiền thì trừ 0đ.
    //Trước đây chỗ này là whitelist mã môn hardcode (8 môn V1) -> đổi CTĐT sang mã V3/EFL108+ là
    //không trừ đồng nào mà không báo lỗi (sự cố 2026-08). Nay đọc thẳng cấu hình, không hardcode mã nữa.
    //tuitionRegistration.name = SỐ HỌC KỲ dạng chuỗi ('1'..'11', toàn khóa = 11).
    const limitByTuitionPackage = (list: any) => {
      const semesters = +tuitionRegistration.value.name || 0
      if(!semesters || !Array.isArray(list)) {
        return []
      }
      return list.slice(0, semesters)
    }
    const isPermission = computed(() => {
      return checkPermission([Permission.APPLICANT_EDIT,Permission.APPLICANT])
    });
    // Quyền vào các trang cấu hình (link trong drawer ghi chú học phí); admin luôn có quyền.
    const canViewSetting = computed(() => checkRoleIsAdmin() || checkPermission([Permission.SETTING_EDIT, Permission.SETTING]));
    const canViewScholarship = computed(() => checkRoleIsAdmin() || checkPermission([Permission.SCHOLARSHIP_VIEW, Permission.SCHOLARSHIP]));
    const dataScholarshipAddition = computed(() => {
      if(dataScholarship.value[0]['Scholarship.addition'] && dataScholarship.value[0]['Scholarship.addition'].length != 0) {
        return dataScholarship.value[0]['Scholarship.addition']?.filter((i: any) => !i.isExtend)
      }
      return []
    });
    const dataScholarshipAdditionExtend = computed(() => {
      if(dataScholarship.value[0]['Scholarship.addition'] && dataScholarship.value[0]['Scholarship.addition'].length != 0) {
        return dataScholarship.value[0]['Scholarship.addition']?.filter((i: any) => i.isExtend)
      }
      return []
    });
    // 
    function checkPermission(permission) {
      const value = permission
      const temp = window.localStorage.getItem("user")
      const user = temp?JSON.parse(temp) : undefined as any
      const listPermission = user?.permissions?.filter(item => item.name == value[1])

      if(listPermission && listPermission.length!=0) {
        const {permissions} = listPermission[0]
        if(permissions && permissions instanceof Array) {
          if (value && value instanceof Array) {
            if (value.length > 0) {
              const permissionRoles = [value[0]]
              const hasPermission = permissions.some(role => {
                return permissionRoles.includes(role)
              })
              return hasPermission //true | false
            }
          } else {
            return false
          }
        }
      }
      else {
        return false
      }
    };
    const dataPayments = computed(() => {
      let tempPromotion = JSON.parse(JSON.stringify(tempDataPromotion.value));
      if (tempPromotion ) {
        tempPromotion.amount = tempPromotion.type !='gift' ? moneyPromotion.value : 0;
        tempPromotion.promotionName = dataPromotionListen.value?.promotionName;
        tempPromotion.promotionCode = dataPromotionListen.value?.promotionCode;
        tempPromotion.id = dataPromotionListen.value?.id;
        tempPromotion.endedDate = dataPromotionListen.value?.endedDate;
      } else {
        tempPromotion = undefined;
      }
      //-------------------
      let tempPromotionAddition = JSON.parse(JSON.stringify(tempDataPromotionAddition.value));
      if (tempPromotionAddition) {
        tempPromotionAddition.amount = tempPromotionAddition.type !='gift' ? moneyPromotionAddition.value : 0;
        tempPromotionAddition.promotionName = dataPromotionListenAddition.value?.promotionName;
        tempPromotionAddition.promotionCode = dataPromotionListenAddition.value?.promotionCode;
        tempPromotionAddition.id = dataPromotionListenAddition.value?.id;
        tempPromotionAddition.endedDate = dataPromotionListenAddition.value?.endedDate;
      } else {
        tempPromotionAddition = undefined;
      }
      //-------------------
      let otherPromotions = undefined as any
      if(orderDetails.value.otherPromotions?.length != 0) {
        otherPromotions = JSON.parse(JSON.stringify(orderDetails.value.otherPromotions)) as any;
        otherPromotions?.forEach(item=>
            item.endedDate = dataPromotionListen.value?.endedDate,
        )
      }
      let tempOrderDetails = {
        promotion: tempPromotion,
        promotionAddition: tempPromotionAddition,
        promotionMulti: promotionMultiData.value.length != 0 ?promotionMultiData.value : undefined,
        otherPromotions: otherPromotions,
        paymentMethod: orderDetails.value.paymentMethod,
        paymentDescription: optionBanking.value.filter(
          (item) => item.code == orderDetails.value.paymentMethod
        )[0]?.description,
      } as any
      // let {items} = props.dataInitial?.orderDetails as any
      // console.log('items',items)
      // if(items) {
      //   tempOrderDetails.items = items
      // }
      let tempData = {
        orderDetails: tempOrderDetails,
      };
      // console.log('tempDatatempData',tempData)
      
      return tempData;
    });
    async function submitPayments() {
      let tempData = {
        admissionRegistration: admissionRegistration.value,
      };
      tempData = Object.assign(tempData, dataPayments.value);
      // console.log('tempData',tempData)
      tempData = funcHistories(tempData)
      await axios
        .put(`/applicant/admin/${id.value}`, tempData)
        .then(({ data }) => {
          dataReset.value = data.item;
          isShowPayments.value = false;
        })
        .catch(({ response }) => {
          popupMessage(response.data?.errorMessage,'error')
          console.log("err", response);
        });
    }
    const dataInsuranceRegistration = computed(() => {
      let temp = {};
      if (socialHealthcareInsuranceRegistration.value.type == "other") {
        temp = {
          reason: socialHealthcareInsuranceRegistration.value.reason,
          type: "other",
        };
      } else {
        if (socialHealthcareInsuranceRegistration.value.type == "BHYT12") {
          temp = {
            code: socialHealthcareInsuranceRegistration.value.code,
            premium: dataSettingItem.value.filter(
              (i) => i.type == socialHealthcareInsuranceRegistration.value.type
            )[0]?.price,
            expiredDate:
              socialHealthcareInsuranceRegistration.value.expiredDate,
            type: "BHYT12",
          };
        }
        if (socialHealthcareInsuranceRegistration.value.type == "BHYT15") {
          temp = {
            hospital: socialHealthcareInsuranceRegistration.value.hospital,
            premium: dataSettingItem.value.filter(
              (i) => i.type == socialHealthcareInsuranceRegistration.value.type
            )[0]?.price,
            type: "BHYT15",
          };
        }
      }
      let tempData = {
        socialHealthcareInsuranceRegistration: temp,
        accidentInsuranceRegistration: {
          type: accidentInsuranceRegistration.value ? "accident" : "none",
          amount: accidentInsuranceRegistration.value
            ? dataSettingItem.value.filter((i) => i.type == "BHTN15")[0]?.price
            : undefined,
        },
      };
      return tempData;
    });
    async function submitInsuranceRegistration() {
      if(isInsurance.value) {
        let tempData = {
          admissionRegistration: admissionRegistration.value,
        };
        tempData = Object.assign(tempData, dataInsuranceRegistration.value);
        tempData = funcHistories(tempData)
        await axios
          .put(`/applicant/admin/${id.value}`, tempData)
          .then(({ data }) => {
            dataReset.value = data.item;
            emit("callBackFunction", data.item);
            checkTotal(data)
            isShowInsurance.value = false;
          })
          .catch(({ response }) => {
            popupMessage(response.data?.errorMessage,'error')
            console.log("err", response);
          });
      }
      
    }
    async function postalProvinceChange(code: string) {
      dataPostalWard.value = newWardsOf(code);
      if (personalContacts.value.newPostalWardCode != "") personalContacts.value.newPostalWardCode = "";
    }
    //Nhập nhanh drawer Thông tin liên lạc: tick "Giống địa chỉ thường trú" -> copy tỉnh/xã (mã 2 cấp) + địa chỉ
    function autofillPostalFromPermanent(e: any) {
      if (!e?.target?.checked) return;
      const c = personalContacts.value;
      c.newPostalProvinceCode = c.newPermanentProvinceCode;
      dataPostalWard.value = newWardsOf(c.newPermanentProvinceCode);
      c.newPostalWardCode = c.newPermanentWardCode;
      c.postalAddress = c.permanentAddress;
    }
    // Tick "Giống địa chỉ cha" -> copy Nơi ở hiện tại của Cha sang Mẹ (cùng hành vi autofill ở trên: chỉ copy khi tick)
    function autofillMotherAddressFromFather(e: any) {
      if (!e?.target?.checked) return;
      const c = personalContacts.value;
      c.mother.currentAddress = c.father.currentAddress;
    }
    async function postalDistrictChange(id: string) {
      dataPostalWard.value = [];
      if (personalContacts.value.postalWardId != "") {
        personalContacts.value.postalWardId = "";
      }
      dataPostalWard.value = await getWard(id);
    }
    async function permanentProvinceChange(code: string) {
      dataWard.value = newWardsOf(code);
      if (personalContacts.value.newPermanentWardCode != "") personalContacts.value.newPermanentWardCode = "";
    }
    async function permanentDistrictChange(id: string) {
      dataWard.value = [];
      if (personalContacts.value.permanentWardId != "") {
        personalContacts.value.permanentWardId = "";
      }
      dataWard.value = await getWard(id);
    }
    async function getDistrict(id: string) {
      let arrTemp = [];
      await axios
        .get(`/res/district/?provinceId=${id}`)
        .then(({ data }) => {
          arrTemp = data;
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      return arrTemp;
    }
    async function getDistrictForSchool(code: string) {
      let arrTemp = [];
      await axios
        .get(`/district/?pvcode=${code}`)
        .then(({ data }) => {
          arrTemp = data;
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      return arrTemp;
    }
    async function highschoolProvinceChange(id: string) {
      let provinceSelect = dataProvinceForSchool.value.filter(
        (item: { id: string; name: string }) => item.id === id
      );
      if (provinceSelect.length != 0) {
        let { code } = provinceSelect[0];
        // Nạp Quận/huyện (để suy id từ trường) + TOÀN BỘ trường của tỉnh (chọn thẳng, không qua huyện)
        dataDistrictForSchool.value = await getDistrictForSchool(code);
        dataSchoolName.value = await getSchools("", code);
      } else {
        dataDistrictForSchool.value = [];
        dataSchoolName.value = [];
      }
      learningProcess.value.highschoolDistrictId = "";
      learningProcess.value.highschoolId = "";
    }
    // Chọn Trường (cả tỉnh) -> tự suy Quận/huyện từ mã huyện của trường (payload giữ nguyên id huyện)
    function highschoolSchoolChange(schoolId: string) {
      const school = dataSchoolName.value.filter((i) => i.id == schoolId)[0];
      const district = school
        ? dataDistrictForSchool.value.filter(
            (d) => String(d.code) == String(school.districtCode)
          )[0]
        : null;
      learningProcess.value.highschoolDistrictId = district ? district.id : "";
    }
    async function highschoolDistrictChange(id: string) {
      let districtSelect = dataDistrictForSchool.value.filter(
        (item: { id: string; name: string }) => item.id === id
      );
      if (districtSelect.length != 0) {
        let { code, provinceCode } = districtSelect[0];
        dataSchoolName.value = await getSchools(code, provinceCode);
      }
      learningProcess.value.highschoolId = "";
    }
    async function getWard(id: string) {
      let arrTemp = [];
      await axios
        .get(`/res/ward/?districtId=${id}`)
        .then(({ data }) => {
          arrTemp = data;
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      return arrTemp;
    }
    async function getSchools(dtcode: string, pvcode: string) {
      let arrTemp = [];
      await axios
        .get(`/school/?dtcode=${dtcode}&pvcode=${pvcode}`)
        .then(({ data }) => {
          arrTemp = data;
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      return arrTemp;
    }
    const discountScholarship = ref(undefined as any)
    const firstLoad = ref(true)
    function sortByDate(arr,field: any) {
      arr.sort(function(a: any,b:any){
        return Number(new Date(b[field])) - Number(new Date(a[field]));
      });

      return arr;
    }
    function checkCondition(item: any) {
      let date = item.date
      let amount = item.value
      let specialApplied = (item.specialApplied && item.specialApplied.length != 0) ? item.specialApplied[0]:""
      let condition = dataFindprereceipts.value.filter((i: any) => i.journaltype == item.type)
      if(['islecturerchild','isstaffchild', 'ispartnerchild'].includes(specialApplied)) {
        if(studentData.value[specialApplied]) {
          // Ưu đãi phân bậc theo đối tượng/thâm niên: CT khai báo condition.specialTier -> chỉ nhận bậc khớp students.personnelchild
          // (mỗi SV thấy ĐÚNG 1 CT của nhóm; DOITAC/CT không phân bậc -> không có specialTier -> nhận theo cờ như cũ)
          const _tier = item.specialTier
          if(_tier !== undefined && _tier !== null && _tier !== '') {
            return String(_tier) === String(studentData.value?.personnelchild ?? '')
          }
          return true
        }
      }
      if(condition && condition.length != 0) {
        let issuedDate = sortByDate(condition,'issuedDate')[0]?.issuedDate
        let con = new Date(issuedDate).getTime()
        // console.log('issuedDate',issuedDate)
        // console.log('con',con)
        // console.log('date',date)
        let a = new Date(date).getTime()
        let sum = condition.reduce(function (acc, obj) { return acc + obj.paymentConfirmation.paid; }, 0);
        if(date) {
          if(a - con < 0 || sum < amount) {//đóng tiền sau thời hạn
            return false
          }
          else {
            return true
          }
        }
        else {
          return true
        }
      }
      else {
        return false
      }
      
    }
    const checkConditionscholarship = computed(() => {
      let scholarshipNow = dataScholarship.value[0]
      // Học bổng bật "Bỏ qua điều kiện" (scholarships.bypasscondition): luôn cho chọn/áp dụng,
      // không cần đóng phí giữ suất hay học phí trước hạn.
      if(scholarshipNow?.['Scholarship.bypasscondition']) {
        return true
      }
      let item = scholarshipNow['Scholarship.condition']
      // console.log('scholarshipNow condition',item)
      if(item) {
        return checkCondition(item)
      }
      return true
    })
    const dataTuitionValueListen = computed(() => {
      let fee = JSON.parse(JSON.stringify(+dataTuition.value[tuitionRegistration.value.name]?.value))||0
      // console.log('total fee',fee)
      if(arrCourseexemptions.value) {
        fee = fee - arrCourseexemptions.value.reduce((a: any, b: any) => a + b.value, 0)
      }
      if(courseNextLevel.value && Array.isArray(courseNextLevel.value)) {
        fee = fee + courseNextLevel.value.reduce((a: any, b: any) => a + b.value, 0)
      }
      if(reduceEnglish.value) {
        fee = fee - reduceEnglish.value?.value
      }
      let scholarshipPromotion = dataScholarshipPro.value.promotion
      // console.log('dataScholarshipPro.value',dataScholarshipPro.value)
      if (dataScholarship.value.length != 0 && dataScholarshipPro.value.scholarship && scholarshipPromotion) {
        // console.log('scholarshipPromotionscholarshipPromotionscholarshipPromotionscholarshipPromotion')
        fee = fee - +scholarshipPromotion.value
      }
      // console.log('total fee scholarshipPromotion',scholarshipPromotion?.value)
      // console.log('fee -  scholarshipPromotion',fee)

      let promotionExtend = dataScholarshipPro.value.promotionExtend||[]
      if(dataScholarshipPro.value.promotionExtend && dataScholarshipPro.value.promotionExtend.length != 0) {
        fee = fee - +promotionExtend.reduce((a, b) => a + b.value, 0)
      }
      // console.log('total fee promotionExtend',promotionExtend)
      // console.log('fee -  promotionExtend',fee)


      // if(moneySiblings.value) {
      //   fee = fee - moneySiblings.value
      // }
      if(moneyPromotion.value) {
        fee = fee - moneyPromotion.value
      }
      // console.log('moneyPromotion',moneyPromotion.value)
      // console.log('fee -  moneyPromotion',fee)
      // 2026-07-29: MỞ LẠI — ưu đãi bổ sung (promotionAddition) phải kéo base xuống,
      // nếu không HB bị tính trên số tiền chưa trừ khoản này (vd 36tr −3tr −3tr: HB 25%
      // ra 8.25tr thay vì 7.5tr). totalFee đã dời khối promotionAddition lên TRƯỚC học bổng
      // nên moneyPromotionAddition luôn được cập nhật trước khi computed này được đọc.
      if(moneyPromotionAddition.value) {
        fee = fee - moneyPromotionAddition.value
      }
      if(moneyPromotionVipPro.value) {
        fee = fee - moneyPromotionVipPro.value
      }
      // console.log('moneyPromotionVipPro',moneyPromotionVipPro.value)
      // console.log('fee -  moneyPromotionVipPro',fee)

      if(promotionMultiData.value) {
        promotionMultiData.value.forEach(i=>{
          fee = fee - i.valueAmount
        })
      }
      // console.log('promotionMultiData',promotionMultiData.value)
      // console.log('fee -  promotionMultiData',fee)
      if(scholarshipPromotionMultiData.value) {
        scholarshipPromotionMultiData.value.forEach(i=>{
          fee = fee - i.valueAmount
        })
      }
      // console.log('scholarshipPromotionMultiData',scholarshipPromotionMultiData.value)
      // console.log('feefeefee',fee)
      return fee
    })
    const scholarshipValueListen = computed(() => {
      if(firstLoad.value) {
        // console.log('scholarshipDefault',scholarshipDefault.value.value)
        return +scholarshipDefault.value.value
      }
      if(!checkConditionscholarship.value) {
        return null
      }
      if (dataScholarship.value.length != 0) {
        if(dataScholarship.value[0].scholarshipType == "global") {
          return +dataTuitionValueListen.value
        }
        if (
          true || dataScholarship.value[0]?.releasedIn >
          dataTuition.value[tuitionRegistration.value.name]?.releasedIn
        ) {
          
          if(dataScholarship.value[0].rate) {
            let extraRate = 0
            // if(studentData.value?.isstaffchild || studentData.value?.ispartnerchild) {
            //   extraRate = +studentData.value?.personnelchild/100
            // }
            // console.log('studentData',studentData.value)
            // console.log('extraRate',extraRate)
            discountScholarship.value = +(+dataScholarship.value[0].rate + extraRate).toFixed(2)
            let value = ((+dataTuitionValueListen.value*discountScholarship.value))
            // console.log('extraRate',extraRate)
            return +value;
          }
          else {
            // FIX twin-rounding: làm tròn ĐỒNG như portal (trước làm tròn nghìn -> lệch tối đa 1.000đ so với SV thấy)
            let value = (+dataScholarship.value[0]?.scholarshipPerSemester * dataTuition.value[tuitionRegistration.value.name]?.releasedIn);
            return +(+value.toFixed())
          }
        } else {
          return +dataScholarship.value[0]?.scholarshipValue as any
        }
      }
      return null as any
    });
    const dataPromotionListenMulti = computed(() => {
      let promotion = JSON.parse(JSON.stringify(dataPromotionSpecial.value)).filter(
        (item) => item.appliedType.split(',').includes(tuitionRegistration.value.name)
      );
      promotion = promotion.concat(JSON.parse(JSON.stringify(dataPromotionManual.value)))
      let temp = [] as any
      promotion.forEach((item: any) => {
        if(item.ismanual) {
          // item.isDisabled = true
          temp.push(item)
          return
        }
        if(item.addition) {
          item.addition.forEach((i: any) => {
            if(i) {
              i.isDisabled = !checkPromotionInScholarship(i)
            }
          })
        }
        // `bypasscondition`: cấu hình cho phép bỏ qua điều kiện kích hoạt -> luôn cho chọn
        if(!item.condition || item.bypasscondition) {
          temp.push(item)
        }
        else {
          if(checkCondition(item.condition,)) {
            temp.push(item)
          }
        }
      })
      promotion = temp
      // console.log('promotionpromotion',promotion)
      if (promotion.length != 0) {
        promotion = promotion.sort((a, b) => {
          if (a.priority !== undefined && b.priority !== undefined) {
            return a.priority > b.priority ? 1 : -1;
          } else {
            return a.priority !== undefined ? 1 : -1;
          }
        });
        promotion.forEach(promo => {
          let benefit = promo.benefit||[]
          let benefitaddition = promo.benefitaddition||[]
          if(benefitaddition.length != 0) {
            let numSemester = dataTuition.value[tuitionRegistration.value.name]?.releasedIn||-1
            benefit = promo.benefitaddition.filter(i=> numSemester >= i.semester)
            benefit = Array.from(new Map(benefit.map(item => [item.value, item])).values());//unique promotion with percent
            const maxValue = Math.max(...benefit.map(item => Number(item.value)));
            benefit = benefit.filter(item => Number(item.value) === maxValue);

          }
          promo.benefit = benefit
          promo.benefit.forEach(item=>{
            item.endedDate = promo.endedDate
            item.amount = Number(item.value)
            item.code = promo.promotionCode+'_multi'
          })
        })
        // console.log('promotionmulti',promotion)        
        return promotion.filter(i=> i.benefit.length != 0);;
        
      }
      return null;
    });
    const dataScholarshipListenAddition = computed(() => {
      // console.log('run dataScholarshipListenAddition')
      let promotion = JSON.parse(JSON.stringify(dataScholarship.value)).filter(
        (item) => item[`Scholarship.benefitaddition`]?.length != 0
      );
      // console.log('dataScholarshipListenAddition',promotion)
      if (promotion.length != 0) {
        promotion = promotion.sort((a, b) => {
          if (a.priority !== undefined && b.priority !== undefined) {
            return a.priority > b.priority ? 1 : -1;
          } else {
            return a.priority !== undefined ? 1 : -1;
          }
        });
        promotion.forEach(pro => {
          let benefit = pro[`Scholarship.benefitaddition`]||[]
          if(benefit.length != 0) {
            let numSemester = dataTuition.value[tuitionRegistration.value.name]?.releasedIn
            // console.log('numSemester',numSemester)
            benefit = benefit.filter(i=> numSemester >= i.semester)
            benefit = Array.from(new Map(benefit.map(item => [item.value, item])).values());//unique promotion with percent
            const maxValue = Math.max(...benefit.map(item => Number(item.value)));
            benefit = benefit.filter(item => Number(item.value) === maxValue);
            // console.log('benefit',benefit)
            

            
            // console.log('benefit',benefit)
          }

          pro.benefitaddition = benefit
          pro.benefitaddition.forEach(item=>{
            pro.namepromotion = item.namepromotion
            // item.endedDate = promotion[0].endedDate
            item.amount = Number(item.value)
            item.code = pro[`Scholarship.code`]+'_additon'

          })
        })
        
        // console.log('dataScholarshipListenAddition',promotion)
        
        return promotion.filter(i=> i.benefitaddition.length != 0);
        
      }
      return null;
    })
    const dataPromotionListenAddition = computed(() => {
      // return null
      // console.log('tuitionRegistration.value.name',tuitionRegistration.value.name)
      let promotion = JSON.parse(JSON.stringify(dataPromotion.value)).filter(
        (item) => item.benefitaddition && item.benefitaddition.length != 0 && item.appliedType.split(',').includes(tuitionRegistration.value.name)
      );
      let temp = [] as any
      promotion.forEach((item: any) => {
        if(item.addition) {
          item.addition.forEach((i: any) => {
            if(i) {
              i.isDisabled = !checkPromotionInScholarship(i)
            }
          })
        }
        // `bypasscondition`: cấu hình cho phép bỏ qua điều kiện kích hoạt -> luôn cho chọn
        if(!item.condition || item.bypasscondition) {
          temp.push(item)
        }
        else {
          if(checkCondition(item.condition)) {
            temp.push(item)
          }
        }
      })
      promotion = temp
      // console.log('promotion',promotion)
      
      if (promotion.length != 0) {
        promotion = promotion.sort((a, b) => {
          if (a.priority !== undefined && b.priority !== undefined) {
            return a.priority > b.priority ? 1 : -1;
          } else {
            return a.priority !== undefined ? 1 : -1;
          }
        });
        let benefit = promotion[0].benefit||[]
        let benefitaddition = promotion[0].benefitaddition||[]
        if(benefitaddition.length != 0) {
          let numSemester = dataTuition.value[tuitionRegistration.value.name]?.releasedIn
          // console.log('numSemester',numSemester)
          benefit = promotion[0].benefitaddition.filter(i=> numSemester >= i.semester)
          benefit = Array.from(new Map(benefit.map(item => [item.value, item])).values());//unique promotion with percent
          const maxValue = Math.max(...benefit.map(item => Number(item.value)));
          benefit = benefit.filter(item => Number(item.value) === maxValue);
          // console.log('benefit',benefit)
          

          if(benefit.length == 0) {
            return null
          }
          // console.log('benefit',benefit)
        }
        promotion[0].benefit = benefit
        promotion[0].benefit.forEach(item=>{
          item.endedDate = promotion[0].endedDate
          item.amount = Number(item.value)
          item.code = promotion[0].promotionCode+'_addition'

        })
        // FIX (twin portal): bỏ side-effect ghi orderDetails.otherPromotions trong computed. Đồng bộ ở handler @change.
        // console.log('promotion[0]',promotion[0])
        if(benefit && benefit.lenght == 0) {
          return null
        }

        return promotion[0];
        
      }
      return null;
    });
    const dataPromotionListen = computed(() => {
      let promotion = dataPromotion.value.filter(
        (item) => item.benefit.length != 0 && item.appliedType.split(',').includes(tuitionRegistration.value.name)
      );
      let temp = [] as any
        //  console.log('promotionpromotionpromotion',promotion)

      promotion.forEach((item: any) => {
        if(item.addition) {
          item.addition.forEach((i: any) => {
            i.isDisabled = !checkPromotionInScholarship(i)
          })
        }
        // CHỦ ĐÍCH (khác portal): admin được quyền hiện/cấp CTKM bất chấp điều kiện đóng tiền khi condition không có hạn ngày (portal thì đánh giá checkCondition). Đừng "sửa cho giống portal".
        if(!item.condition || !item.condition?.date || item.bypasscondition) {
          temp.push(item)
        }
        else {
          // console.log('checkCondition(item.condition)',checkCondition(item.condition))
          if(checkCondition(item.condition)) {
            
            temp.push(item)
          }
        }
      })
      promotion = temp
      if (promotion.length != 0) {
        promotion = promotion.sort((a, b) => {
          if (a.priority !== undefined && b.priority !== undefined) {
            return a.priority > b.priority ? 1 : -1;
          } else {
            return a.priority !== undefined ? 1 : -1;
          }
        });
        //  console.log('promotion[0]',promotion[0])
         promotion[0].benefit.forEach(item=>{
          item.endedDate = promotion[0].endedDate
          item.code = promotion[0].promotionCode
          item.amount = Number(item.value)
         })
         // FIX (twin portal): bỏ side-effect ghi orderDetails.otherPromotions trong computed. Đồng bộ ở handler @change.
        return promotion[0] as any
      }
      return null as any
    });
    const user = computed(() => {
      let temp = window.localStorage.getItem("user");
      return temp ? JSON.parse(temp) : null;
    });
    const totalUniformReg = computed(() => {
      let total = 0
      otherFees.value.forEach(item=> {
        total += +item.price * (+item.quantity)
      })
      return total;
    });
    const totalInsurance = computed(() => {
      let a = dataSettingItem.value.filter(
        (i) => i.type == socialHealthcareInsuranceRegistration.value.type
      );
      if (a && a.length != 0) {
        a = a[0];
      } else {
        a.price = 0;
      }
      let b = dataSettingItem.value.filter((i) => i.type == "BHTN15");
      if (b && b.length != 0 && accidentInsuranceRegistration.value) {
        b = b[0];
      } else {
        b.price = 0;
      }
      return +a.price + +b.price;
    });
    const tempDataPromotion = ref(null as any);
    const tempDataPromotionAddition = ref(null as any);

    const moneySiblings = ref(0);
    const moneyPromotion = ref(0);
    const moneyPromotionAddition = ref(0);

    const moneyPromotionVipPro = ref(0);

    const totalFeeTuition = computed(() => {
      let sum = +totalFee.value
      // console.log('sum',sum)
      if(dataRegistrationfeerequest.value) {
        sum = sum - +dataRegistrationfeerequest.value?.paymentConfirmation?.paid
      }      
      return sum < 0 ? 0 : +sum.toFixed(0);
    });
    const totalFee = computed(() => {
      let siblings = 0; //+freeTuitionDiscount
      if (freeTuitionRegistration.value.registrationTypeSiblings) {
        siblings = +freeTuitionDiscount.value / 100;
      }
      /*let scholarship = 0;
      if (dataScholarship.value.length != 0 && scholarshipValueListen.value && dataScholarshipPro.value.scholarship) {
        scholarship = +scholarshipValueListen.value;
        if(dataScholarshipPro.value.promotion) {
          scholarship += +dataScholarshipPro.value.promotion.value
        }
      }
      if(dataScholarshipPro.value.promotionExtend && dataScholarshipPro.value.promotionExtend.length != 0) {
        scholarship += +dataScholarshipPro.value.promotionExtend.reduce((a, b) => a + b.value, 0)
      }*/
      // console.log('scholarship',scholarship)
      let sum = +dataTuition.value[tuitionRegistration.value.name]?.value// - scholarship;
      
      if(reduceEnglish.value) {
        sum = sum - +reduceEnglish.value.value
      }
      if(arrCourseexemptions.value) {
        sum = sum - arrCourseexemptions.value.reduce((a: any, b: any) => a + b.value, 0)
      }
      if(courseNextLevel.value && Array.isArray(courseNextLevel.value)) {
        sum = sum + courseNextLevel.value.reduce((a: any, b: any) => a + b.value, 0)
      }
      // console.log('freeTuitionUnit.value,',freeTuitionUnit.value)
      if (freeTuitionUnit.value == "%") {
        if(!firstLoad.value ) {
          moneySiblings.value = +(sum * siblings);
        }
        sum = sum - sum * siblings;
      } else {
        if(!firstLoad.value) {
          moneySiblings.value = siblings;
        }
        sum = sum - siblings;
      }
      // FIX C6: promotionMulti đã chuyển xuống SAU ưu đãi chính (đồng bộ thứ tự trừ tiền với portal)
      if(orderDetails.value.otherPromotionsVipPro && orderDetails.value.otherPromotionsVipPro.percent) {
          moneyPromotion.value = 0;
          let percent = +orderDetails.value.otherPromotionsVipPro?.percent
          let amountPercent = Number(+sum * (percent / 100))
          if(!firstLoad.value) {
            moneyPromotionVipPro.value = amountPercent;

          }
          sum = sum - amountPercent;
        }
      // console.log('dataPromotionListen',dataPromotionListen.value)
      if (
        dataPromotionListen.value && orderDetails.value.promotion?.value &&
        orderDetails.value.promotion?.value != ""
      ) {
        let temp = dataPromotionListen.value?.benefit.filter(
          (item) => item.value == orderDetails.value.promotion?.value
        );
        
        // console.log('temp totalfee',temp)
        if(orderDetails.value.otherPromotions?.length != 0) {
          sum = sum - orderDetails.value.otherPromotions?.reduce((a, b) => a + Number(b.amount), 0)
        }
        const maxvalue = +dataPromotionListen.value?.maxvalue
        if (temp.length != 0) {
          tempDataPromotion.value = temp[0];
          let extraRate = 0
          // if(studentData.value?.isstaffchild || studentData.value?.ispartnerchild) {
          //   extraRate = +studentData.value?.personnelchild
          //   tempDataPromotion.value.reExtraDiscount = +studentData.value?.personnelchild
          //   tempDataPromotion.value.discount = +(+tempDataPromotion.value.value + +studentData.value?.personnelchild).toFixed(2)
          // }
          if(orderDetails.value.otherPromotionsVip && orderDetails.value.otherPromotionsVip?.value) {
            sum = sum - orderDetails.value.otherPromotionsVip?.value;
          }
          // console.log('temp[0]',temp[0])
          if (temp[0].type == "amount") {
            if(!firstLoad.value) {
              moneyPromotion.value = +temp[0].value;
              // console.log('moneyPromotion',moneyPromotion)
            }
            sum = sum - temp[0].value;
          } else if (temp[0].type == "percent") {
            
            let percent = +temp[0].value + extraRate
            let amountPercent = Number(+sum * (percent / 100))
            if(maxvalue && maxvalue < amountPercent) {
              amountPercent = maxvalue
            }
            if(!firstLoad.value) {
              moneyPromotion.value = amountPercent;
            }
            sum = sum - amountPercent;
          }
          
          
        }
      } else {
        if(!firstLoad.value) {
          moneyPromotion.value = 0;
        }
      }
      
      
      
     
      //===========PromotionMulti (chuyển xuống đây — FIX C6 đồng bộ thứ tự với portal: vipPro -> ưu đãi chính -> multi)================
      promotionMultiData.value.forEach(i=> {
        let valueAmount = i.amount
        if(i.type == 'percent') {
          let percent = i.value
          valueAmount = Number(+sum * (percent / 100))
        }
        else if(i.type == 'amount') {
          //
        }
        i.valueAmount = valueAmount
        sum = sum - valueAmount;
      })
      //===========================================
      //===========ScholarshipPromotionMulti================
      scholarshipPromotionMultiData.value.forEach(i=> {
        let valueAmount = i.amount
        if(i.type == 'percent') {
          let percent = i.value
          valueAmount = Number(+sum * (percent / 100))
        }
        else if(i.type == 'amount') {
          //
        }
        i.valueAmount = valueAmount
        sum = sum - valueAmount;
      })
      //===========================================
      //=========== Ưu đãi bổ sung (promotionAddition) ================
      // 2026-07-29: DỜI khối này LÊN TRƯỚC học bổng (trước đây trừ sau học bổng).
      // Nghiệp vụ chốt: học bổng = % của (học phí gốc − TỔNG các ưu đãi) -> mọi ưu đãi
      // phải trừ xong mới tính %HB. Đặt trước học bổng cũng để loại `percent` tính trên
      // `sum` CHƯA trừ HB -> không tạo phụ thuộc vòng với dataTuitionValueListen.
      // console.log('dataPromotionListenAddition',dataPromotionListenAddition.value)
      if (
        dataPromotionListenAddition.value && orderDetails.value.promotionAddition?.value &&
        orderDetails.value.promotionAddition?.value != ""
      ) {
        let temp = dataPromotionListenAddition.value?.benefit.filter(
          (item) => item.value == orderDetails.value.promotionAddition?.value
        );
        
        // console.log('temp totalfee',temp)
        // if(orderDetails.value.otherPromotions?.length != 0) {
        //   sum = sum - orderDetails.value.otherPromotions?.reduce((a, b) => a + Number(b.amount), 0)
        // }
        const maxvalue = +dataPromotionListenAddition.value?.maxvalue
        if (temp.length != 0) {
          tempDataPromotionAddition.value = temp[0];
          let extraRate = 0
          if(studentData.value?.isstaffchild || studentData.value?.ispartnerchild) {
            // extraRate = +studentData.value?.personnelchild
            // tempDataPromotionAddition.value.reExtraDiscount = +studentData.value?.personnelchild
            // tempDataPromotionAddition.value.discount = +(+tempDataPromotionAddition.value.value + +studentData.value?.personnelchild).toFixed(2)
          }
          // if(orderDetails.value.otherPromotionsVip && orderDetails.value.otherPromotionsVip?.value) {
          //   sum = sum - orderDetails.value.otherPromotionsVip?.value;
          // }
          // console.log('temp[0]',temp[0])
          if (temp[0].type == "amount") {
            if(!firstLoad.value) {
              moneyPromotionAddition.value = +temp[0].value;
              // console.log('moneyPromotion',moneyPromotion)
            }
            sum = sum - temp[0].value;
          } else if (temp[0].type == "percent") {
            
            let percent = +temp[0].value + extraRate
            let amountPercent = Number(+sum * (percent / 100))
            if(maxvalue && maxvalue < amountPercent) {
              amountPercent = maxvalue
            }
            if(!firstLoad.value) {
              moneyPromotionAddition.value = amountPercent;
            }
            sum = sum - amountPercent;
          }
          
          
        }
      } else {
        if(!firstLoad.value) {
          moneyPromotionAddition.value = 0;
        }
      }
      //===========================================
      //======================= học bổng cuối ========================
      let scholarship = 0;
      if (dataScholarship.value.length != 0 && scholarshipValueListen.value && dataScholarshipPro.value.scholarship) {
        scholarship = +scholarshipValueListen.value;
        if(dataScholarshipPro.value.promotion) {
          scholarship += +dataScholarshipPro.value.promotion.value
        }
      }
      if(dataScholarshipPro.value.promotionExtend && dataScholarshipPro.value.promotionExtend.length != 0) {
        scholarship += +dataScholarshipPro.value.promotionExtend.reduce((a, b) => a + b.value, 0)
      }
      sum = sum - scholarship;
      //======================= học bổng cuối ========================
      // console.log('sum',sum)
      return sum < 0 ? 0 : +sum.toFixed(0);
    });
    const totalSum = computed(() => {
      let sum =
        totalFeeTuition.value + (isUniform.value ? totalUniformReg.value: 0) + (isInsurance.value ? totalInsurance.value : 0);
      return sum <= 0 ? 0 : sum;
    });
    const supportServices = ref([] as any);
    const supportServicesOther = ref("");
    const arrSize = ref(["XS", "S", "M", "L", "XL", "XXL", "XXXL"]);
    const tableDataImg = ref([
      {
        fileName: "",
        filePath: "",
        fileType: "",
        id: "",
        label: "",
      },
    ] as any);
    const isShowFormSchool = ref(false);
    const isShowFormStudies = ref(false);
    const isShowFormActivities = ref(false);
    const isShowFormProjects = ref(false);
    const isShowFormOthers = ref(false);
    const isShowInsurance = ref(false);
    const isShowEnglishClass = ref(false);
    const isShowUniformReg = ref(false);
    const isShowFormService = ref(false);
    const isShowFreeTuition = ref(false);
    //Drawer ghi chú khối Thông tin học phí (read-only, không đụng logic tiền)
    const showTuitionGuide = ref(false);
    const isShowPayments = ref(false);
    const isShowFinancialSupport = ref(false);
    const isShowOtherFees = ref(false);

    const financialSupportNo = ref(true);
    const isHealthInsurance = ref("-1");
    const accidentInsuranceRegistration = ref(false);
    const pagination = ref<IPagination>({
      currentPage: 1,
      total: 0,
      limit: 50,
    });

    const tableDataEnglishCer = ref<Array<IEnglishCer>>([]);
    const tableHeaderEnglishCer = ref([
      {
        name: "ielts",
        key: "ielts",
        sortable: false,
        class: "text-center",
      },
      {
        name: "TOEFL iBT",
        key: "toeflIbt",
        sortable: false,
        class: "text-center text-transform-none",
      },
      {
        name: "toeic",
        key: "toeic",
        sortable: false,
        class: "text-center",
      },
      {
        name: "aptis",
        key: "aptis",
        sortable: false,
        class: "text-center",
      },
      {
        name: "pes",
        key: "pes",
        sortable: false,
        class: "text-center",
      },
      {
        name: "Môn học được miễn giảm",
        key: "subjects",
        sortable: false,
        class: "text-start",
      },
    ]);
    const tableData = ref<Array<ICollegesUniversities>>([]);
    const tableHeader = ref([
      {
        name: "Tên ngành",
        key: "programName",
        sortable: false,
        class: "",
      },
      {
        name: "Cấp độ học",
        key: "programLevel",
        sortable: false,
        class: "",
      },
      {
        name: "Địa điểm học",
        key: "studyLocation",
        sortable: false,
      },
      {
        name: "Thời gian",
        key: "time",
        sortable: false,
        class: "",
      },
      {
        name: "Tình trạng",
        key: "status",
        sortable: false,
        class: "",
      },
      {
        name: "Hành động",
        key: "actions",
        sortable: false,
        class: "text-center",
      },
    ]);

    const submitButton1 = ref();
    const submitButton2 = ref();
    //ref el-form drawer Người thân — template gán ref="submitButtonRelatives" từ lâu nhưng CHƯA từng
    //khai báo ở setup: validate không chạy, form đang đỏ "Vui lòng điền" mà bấm Lưu vẫn đóng drawer
    const submitButtonRelatives = ref();
    const submitButton3 = ref();
    const submitButton4 = ref();
    const submitButton5 = ref();
    const submitButtonEng = ref();
    
    const forSchool = ref();
    

    const emailFormDisplay = ref(false);
    const passwordFormDisplay = ref(false);
    const isUmter = ref(false);
    const textErr = "Vui lòng điền trường này";
    
    const profileDetailsValidator = ref({
      givenName: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      familyName: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      dateOfBirth: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      placeOfBirth: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      religion: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      gender: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      nationality: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      ethnic: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      idNumber: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      issuedDate: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      issuedBy: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
    })
    const forSchoolValidator = ref({
      programName: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      studyLocation: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      programLevel: [ {
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
    })
    const insuranceRegValidator = computed(() => {
      let temp = Yup.object().shape({});
      if (socialHealthcareInsuranceRegistration.value.type == "other") {
        temp = Yup.object().shape({
          reason: Yup.string().required(textErr).nullable(),
        });
      }
      // console.log(temp)
      return temp;
    });

    const englishClassValidator = computed(() => {
      let temp = Yup.object().shape({});
      if (
        englishClassPlacementTest.value.registrationType ==
        "english_certificate"
      ) {
        temp = Yup.object().shape({
          certificateName: Yup.string().required(textErr).nullable(),
          score: Yup.string().required(textErr).nullable(),
        });
      }
      // console.log(temp)
      return temp;
    });
    const rulesDefault = ref({
        required: true,
        message: textErr,
        trigger: ['blur','change'],
      })
    const personalContactsValidatorDefault = ref({
      newPermanentProvinceCode: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      newPermanentWardCode: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      permanentAddress: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      newPostalProvinceCode: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      newPostalWardCode: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      postalAddress: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      contactMobile: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      contactEmail: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      checkAgreeToReleaseOfStudyProgress: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      checkAgreeToContactInEmergency: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
    })
    // const freeTuitionRegistrationValiSiblings = {
    //   studentId: [
    //         {
    //         required: true,
    //         message: textErr,
    //         trigger: "change",
    //         },
    //     ],
    //     siblingfullName: [
    //         {
    //         required: true,
    //         message: textErr,
    //         trigger: "change",
    //         },
    //     ],
    // }
    const uniformRegValidator = Yup.object().shape({
      defaultSize: Yup.string().required("Vui lòng chọn size").nullable(),
    });
    const freeTuitionRegistrationValidator =  computed(() => {
      let temp = {
          name: [
                {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change",
                },
            ],
            
        }
      
      // if (freeTuitionRegistration.value.registrationTypeSiblings) {
      //   temp = Object.assign (temp,freeTuitionRegistrationValiSiblings);
      // }
      return temp;
    });
    const agreeToReleaseOfStudyProgress = [
      {
        'father.fullName': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'father.dateOfBirth': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'father.occupation': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'father.mobile': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'father.currentAddress': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
      },
      {
        'mother.fullname': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'mother.dateOfBirth': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'mother.occupation': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'mother.mobile': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'mother.currentAddress': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
      },
      {
        'guardian.fullname': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'guardian.dateOfBirth': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'guardian.occupation': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'guardian.mobile': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
        'guardian.currentAddress': [{
          required: true,
          message: textErr,
          trigger: "change",
          },
        ],
      },
      
    ];
    const personalContactsValidator = computed(() => {
      let temp = personalContactsValidatorDefault.value;
      // if (
      //   personalContacts.value.father.agreeToReleaseOfStudyProgress ||
      //   personalContacts.value.father.agreeToContactInEmergency
      // ) {
      //   temp = Object.assign(temp,agreeToReleaseOfStudyProgress[0]);
      // }
      // if (
      //   personalContacts.value.mother.agreeToReleaseOfStudyProgress ||
      //   personalContacts.value.mother.agreeToContactInEmergency
      // ) {
      //   temp = Object.assign(temp,agreeToReleaseOfStudyProgress[1]);

      // }
      // if (
      //   personalContacts.value.guardian.agreeToReleaseOfStudyProgress ||
      //   personalContacts.value.guardian.agreeToContactInEmergency
      // ) {
      //   temp = Object.assign(temp,agreeToReleaseOfStudyProgress[2]);

      // }
      // console.log(temp)
      return temp;
    });
    //Helper hiển thị mã tỉnh/mã trường trong drawer Quá trình học tập
    const hsProvinceCode = computed(
      () =>
        dataProvinceForSchool.value.filter(
          (i) => i.id == learningProcess.value.highschoolProvinceId
        )[0]?.code || ""
    );
    const hsSchoolCode = computed(
      () =>
        dataSchoolName.value.filter(
          (i) => i.id == learningProcess.value.highschoolId
        )[0]?.code || ""
    );
    const learningProcessValidator = ref({
      'highschoolProvinceId': [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      'highschoolDistrictId': [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      'highschoolId': [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      'yearOfGraduation': [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
    })
    const checkAgreeToReleaseOfStudyProgress = computed(() => {
      if (
        personalContacts.value.father.agreeToReleaseOfStudyProgress ||
        personalContacts.value.mother.agreeToReleaseOfStudyProgress ||
        personalContacts.value.guardian.agreeToReleaseOfStudyProgress ||
        noneNotifiOfReg.value
      ) {
        return "true";
      }
      return "";
    });
    const checkAgreeToContactInEmergency = computed(() => {
      if (
        personalContacts.value.father.agreeToContactInEmergency ||
        personalContacts.value.mother.agreeToContactInEmergency ||
        personalContacts.value.guardian.agreeToContactInEmergency
      ) {
        return "true";
      }
      return "";
    });
    const editProfileDetails = ref(false);
    const editPartyInfo = ref(false);
    const editQrcode = ref(false);
    const editPersonalContacts = ref(false);
    const editRelatives = ref(false);
    const editLearningProcess = ref(false);

    const formData = ref<ProfileDetails>({
      givenName: "",
      middleName: "",
      familyName: "",
      dateOfBirth: "",
      placeOfBirth: "",
      religion: "",
      gender: "",
      nationality: "",
      ethnic: "",
      idNumber: "",
      issuedDate: "",
      issuedBy: "",
      enrolledUmt: "",
      avatar: "",
      programtype: "",
    });
    const _isEmpty = (v) => v === null || v === undefined || v === "";
    const missingImportant = computed(() => {
      const f = formData.value; const m: string[] = [];
      if (_isEmpty(f.familyName) && _isEmpty(f.givenName)) m.push("Họ và tên");
      if (_isEmpty(f.dateOfBirth)) m.push("Ngày sinh");
      if (_isEmpty(f.placeOfBirth)) m.push("Nơi sinh");
      if (_isEmpty(f.gender)) m.push("Giới tính");
      if (_isEmpty(f.religion)) m.push("Tôn giáo");
      if (_isEmpty(f.nationality)) m.push("Quốc tịch");
      if (_isEmpty(f.ethnic)) m.push("Dân tộc");
      if (_isEmpty(f.idNumber)) m.push("CMND/CCCD");
      if (_isEmpty(f.issuedDate)) m.push("Ngày cấp");
      if (_isEmpty(f.issuedBy)) m.push("Nơi cấp");
      return m;
    });
    const missingContact = computed(() => {
      const c = personalContacts.value; const m: string[] = [];
      if (_isEmpty(c.contactMobile)) m.push("Số di động");
      if (_isEmpty(c.contactEmail)) m.push("Email");
      if (_isEmpty(c.newPermanentProvinceCode)) m.push("Tỉnh thường trú");
      if (_isEmpty(c.newPermanentWardCode)) m.push("Phường/xã thường trú");
      if (_isEmpty(c.permanentAddress)) m.push("Địa chỉ thường trú");
      if (_isEmpty(c.newPostalProvinceCode)) m.push("Tỉnh liên lạc");
      if (_isEmpty(c.newPostalWardCode)) m.push("Phường/xã liên lạc");
      if (_isEmpty(c.postalAddress)) m.push("Địa chỉ liên lạc");
      return m;
    });
    // Ô "Họ và tên" gộp: nhập đầy đủ -> tự tách Họ / Tên đệm / Tên (từ đầu = Họ, từ cuối = Tên, giữa = đệm)
    const fullName = computed({
      get: () => {
        const f = formData.value;
        return [f.familyName, f.middleName, f.givenName].filter(Boolean).join(" ");
      },
      set: (val: string) => {
        const parts = (val || "").trim().replace(/\s+/g, " ").split(" ").filter(Boolean);
        const f = formData.value;
        f.familyName = parts.length >= 2 ? parts[0] : "";
        f.givenName = parts.length >= 1 ? parts[parts.length - 1] : "";
        f.middleName = parts.length >= 3 ? parts.slice(1, -1).join(" ") : "";
      },
    });
    const personalContacts = ref<IContactInfo>({
      permanentWard: "",
      permanentDistrict: "",
      permanentProvince: "",
      permanentWardId: "",
      permanentDistrictId: "",
      permanentProvinceId: "",
      permanentAddress: "",
      postalWardId: "",
      postalDistrictId: "",
      postalProvinceId: "",
      postalWard: "",
      postalDistrict: "",
      postalProvince: "",
      postalAddress: "",
      newPermanentProvinceCode: "",
      newPermanentWardCode: "",
      newPostalProvinceCode: "",
      newPostalWardCode: "",
      contactEmail: "",
      contactMobile: "",
      father: {
        fullName: "",
        currentAddress: "",
        dateOfBirth: "",
        occupation: "",
        mobile: "",
        email: "",
        relationship: "father",
        agreeToReleaseOfStudyProgress: false,
        agreeToContactInEmergency: false,
      },
      mother: {
        fullName: "",
        currentAddress: "",
        dateOfBirth: "",
        occupation: "",
        mobile: "",
        email: "",
        relationship: "mother",
        agreeToReleaseOfStudyProgress: false,
        agreeToContactInEmergency: false,
      },
      guardian: {
        fullName: "",
        currentAddress: "",
        dateOfBirth: "",
        occupation: "",
        mobile: "",
        email: "",
        relationship: "guardian",
        agreeToReleaseOfStudyProgress: false,
        agreeToContactInEmergency: false,
      },
    });
    const learningProcess = ref<ILearningProcess>({
      highschoolName: "",
      highschoolProvince: "",
      highschoolDistrict: "",
      highschoolId: "",
      highschoolProvinceId: "",
      highschoolDistrictId: "",
      certificateNumber: "",
      yearOfGraduation: "",
    });
    // const ICollegesUniversities = ref<Array<ICollegesUniversities>>([]);
    const collegesUniversities = ref<ICollegesUniversities>({
      programName: "",
      programLevel: "",
      studyLocation: "",
      from: "",
      to: "",
      ranktime: [],
      status: "",
      awarded: "",
      id: "",
    });

    const socialHealthcareInsuranceRegistration = ref<ISocialHealthcare>({
      code: "",
      type: "",
      startedDate: "",
      expiredDate: "",
      hospital: "",
      premium: "",
      reason: "",
    });
    const englishClassPlacementTest = ref<IEnglishClassPlacementTest>({
      registrationType: "",
      testdate: "",
      englishCertificate: {
        certificateName: "",
        examDate: "",
        expiredDate: "",
        score: "",
      },
      freeSubjects: "",
    });
    const uniformRegistration = ref<IUniform>({
      defaultSize: "",
      purchaseQuality: 0,
      purchaseSize: "",
      price: "",
      total: "",
    });
    const scholarshipName = ref("");
    const freeTuitionRegistration = ref<IFreeTuitionRegistration>({
      registrationTypeSiblings: false,
      registrationTypeForScholarships: false,
      scholarships: {
        type: "",
        value: "",
        releasedIn: "",
        calRate: "",
        discount: "",
      },
      siblings: {
        studentId: "",
        fullName: "",
      },
    });
    const tuitionRegistration = ref<ITuitionRegistration>({
      name: "",
      major: "",
      fee: "",
    });
    const orderDetails = ref<IOrderDetails>({
      paymentMethod: "",
      promotion: {
        value: "",
      },
      promotionAddition: {
        value: ""
      },
      promotionMulti: [],
      otherPromotions: [],
      otherPromotionsVip: {},
      otherPromotionsVipPro: {},
    });
    const financialSupportRegistration = ref<IFinancialSupportRegistration>({
      bankName: "",
      description: "",
      isFinancialSupport: false,
    });
    const images = {
      "SET":['/media/images/BO-QUA-TANG-SV-HINH-ANH-09.png','/media/images/BO-QUA-TANG-SV-HINH-ANH-10.png','/media/images/BO-QUA-TANG-SV-HINH-ANH-07.png'],
      "TSHIRT":['/media/images/BO-QUA-TANG-SV-HINH-ANH-04.png','/media/images/BO-QUA-TANG-SV-HINH-ANH-05.png'],
      "CAPS":['/media/images/BO-QUA-TANG-SV-HINH-ANH-11.png','/media/images/BO-QUA-TANG-SV-HINH-ANH-12.png']
    }
    const otherFees = ref([] as any);
    const completeAdm = ref(true);
    const isErrorFormProfileDetails = ref(false);
    // Mở drawer Chỉnh sửa TT cá nhân: prefill "Nơi cấp" mặc định khi trống (đa số CCCD hiện hành do
    // Cục CS QLHC về TTXH cấp) — chỉ prefill trong DRAWER, bấm Lưu mới ghi DB, Hủy thì init khôi phục.
    const openEditProfileDrawer = () => {
      if (!formData.value.issuedBy) {
        formData.value.issuedBy = 'Cục trưởng Cục cảnh sát quản lý hành chính về trật tự xã hội'
      }
      isErrorFormProfileDetails.value = false
      editProfileDetails.value = true
    }
    const isErrorFormPersonalContacts = ref(false);
    const isErrorFormLearningProcess = ref(false);
    const isErrorFormFreeTuitionReg = ref(false);
    const isErrorFormUniformReg = ref(false);

  
    const syncDataforStudent = async (formDataInfo:any) => {
      // console.log('data',formDataInfo)
      let checkChange = false
      let idCard = undefined
      let gender = undefined
      let dateOfBirth = undefined
      let fullName = undefined
      let contactEmail = undefined
      let contactMobile = undefined
      if(dataReset.value.idNumber !== formDataInfo.idNumber) {
        idCard = formDataInfo.idNumber
        checkChange = true
      }
      if(dataReset.value.gender !== formDataInfo.gender) {
        gender = formDataInfo.gender=='male'?true:formDataInfo.gender=='female'?false: undefined as any
        checkChange = true
      }
      if(dataReset.value.dateOfBirth !== formDataInfo.dateOfBirth) {
        dateOfBirth = formDataInfo.dateOfBirth
        checkChange = true
      }
      if(`${dataReset.value.familyName} ${dataReset.value.middleName} ${dataReset.value.givenName}` !== `${formDataInfo.familyName} ${formDataInfo.middleName} ${formDataInfo.givenName}`) {
        fullName = `${formDataInfo.familyName.trim()} ${formDataInfo.middleName.trim()} ${formDataInfo.givenName.trim()}` as any
        checkChange = true
      }
      if(dataReset.value.contactEmail !== formDataInfo.contactEmail) {
        contactEmail = formDataInfo.contactEmail
        checkChange = true
      }
      if(dataReset.value.contactMobile !== formDataInfo.contactMobile) {
        contactMobile = formDataInfo.contactMobile
        checkChange = true
      }
      if(!checkChange) {
        return
      }
      let data = {
            "idCard": idCard,
            "email": contactEmail,
            "phone": contactMobile,
            "gender": gender,
            "dateOfBirth": dateOfBirth,
            "fullName": fullName,
            "idStudent": formDataInfo.studentId,
          }
          console.log('data',data)
          await axios.post(`admission/mail/update`,data)
          .then(( {data} ) => {
            let temp = window.localStorage.getItem("user")
            let user =  temp?JSON.parse(temp) : null
            
            
            if(true) {
              let dataComment = {
                "idUser": user ? user.id : undefined,
                "idStudent": formDataInfo.studentId,
                "comment": `Đã cập nhật thông tin nhập học đồng thời cập nhật thông tin ứng viên và hồ sơ trúng tuyến`
              }
              axios.post(`/admission/comment`,dataComment)
            }
          })
          .catch(({ response }) => {
              console.log('err',response)
          }); 
    }
    const changeProgramtype = () => {
      let tempData = {
        "profileCode": props.dataInitial?.admissionRegistration.profileCode,
        "programtype": formData.value.programtype
      }
      axios
      .post(`/applicant/changeprogramtype`, tempData)
      .then(async ({ data }) => {
        location.reload()
      })
      .catch(({ response }) => {
        console.log("err", response);
      });
    }
    const saveChanges1 = async () => {
      // Cho phép lưu dù thiếu field bắt buộc (nhập sau) — cảnh báo qua banner missingImportant.
      formData.value.familyName =
        formData.value.familyName.charAt(0).toUpperCase() +
        formData.value.familyName.slice(1);
      formData.value.familyName = formData.value.familyName.trim()
      formData.value.middleName = formData.value.middleName
        .toLowerCase()
        .replace(/(^|\s)\S/g, (l) => l.toUpperCase());
      formData.value.middleName = formData.value.middleName.trim()
      formData.value.givenName =
        formData.value.givenName.charAt(0).toUpperCase() +
        formData.value.givenName.slice(1);
      formData.value.givenName = formData.value.givenName.trim()
      admissionRegistration.value = {
          ...admissionRegistration.value,
          fullName: `${formData.value.familyName} ${formData.value.middleName} ${formData.value.givenName}`
        }
      let tempData = {
        ...formData.value,
        admissionRegistration: admissionRegistration.value,
        moreinfo: moreinfo.value
      } as any
      delete tempData.programtype
      tempData = funcHistories(tempData)

      await axios
        .put(`/applicant/admin/${id.value}`, tempData)
        .then(async ({ data }) => {
          editProfileDetails.value = false;
          isErrorFormProfileDetails.value = false;
          await syncDataforStudent(data.item)
          if((formData.value.programtype && props.dataInitial?.programtype) && formData.value.programtype != props.dataInitial?.programtype) {
            changeProgramtype()
          }
          dataReset.value = data.item;
          emit("callBackFunction", data.item);
        })
        .catch(({ response }) => {
          popupMessage(response.data?.errorMessage,'error')
          console.log("err", response);
        });
      };

    const savePartyInfo = async () => {
      let tempData = {
        ...formData.value,
        admissionRegistration: admissionRegistration.value,
        moreinfo: moreinfo.value,
      } as any;
      delete tempData.programtype;
      tempData = funcHistories(tempData);
      await axios
        .put(`/applicant/admin/${id.value}`, tempData)
        .then(async ({ data }) => {
          editPartyInfo.value = false;
          await syncDataforStudent(data.item);
          dataReset.value = data.item;
          emit("callBackFunction", data.item);
        })
        .catch(({ response }) => {
          popupMessage(response.data?.errorMessage, "error");
          console.log("err", response);
        });
    };

    const saveChanges2 = async () => {
      // Cho phép lưu dù thiếu field bắt buộc
      let dataObject = JSON.parse(JSON.stringify(personalContacts.value));

        const _newProvName = (code: any) =>
          dataNewProvinces.value.find((p: any) => String(p.code) === String(code))?.name || "";
        dataObject.permanentProvince = _newProvName(dataObject.newPermanentProvinceCode);
        dataObject.permanentWard = dataWard.value.filter(
          (i: any) => String(i.id) === String(dataObject.newPermanentWardCode)
        )[0]?.name || "";
        dataObject.permanentDistrict = null;
        dataObject.permanentDistrictId = null;
        dataObject.postalProvince = _newProvName(dataObject.newPostalProvinceCode);
        dataObject.postalWard = dataPostalWard.value.filter(
          (i: any) => String(i.id) === String(dataObject.newPostalWardCode)
        )[0]?.name || "";
        dataObject.postalDistrict = null;
        dataObject.postalDistrictId = null;
        let tempReleaseOfStudy = [] as string[];
        if (dataObject.father.agreeToReleaseOfStudyProgress) {
          tempReleaseOfStudy.push("father");
        }
        if (dataObject.mother.agreeToReleaseOfStudyProgress) {
          tempReleaseOfStudy.push("mother");
        }
        if (dataObject.guardian.agreeToReleaseOfStudyProgress) {
          tempReleaseOfStudy.push("guardian");
        }
        if (noneNotifiOfReg.value) {
          tempReleaseOfStudy.push("none");
        }
        let tempContactInEmergency = [] as string[];
        if (dataObject.father.agreeToContactInEmergency) {
          tempContactInEmergency.push("father");
        }
        if (dataObject.mother.agreeToContactInEmergency) {
          tempContactInEmergency.push("mother");
        }
        if (dataObject.guardian.agreeToContactInEmergency) {
          tempContactInEmergency.push("guardian");
        }
        dataObject.notificationRegistration = {
          agreeToReleaseOfStudyProgress: tempReleaseOfStudy.join("|"),
          agreeToContactInEmergency: tempContactInEmergency.join("|"),
        };
        delete dataObject.father.agreeToReleaseOfStudyProgress;
        delete dataObject.mother.agreeToReleaseOfStudyProgress;
        delete dataObject.guardian.agreeToReleaseOfStudyProgress;

        delete dataObject.father.agreeToContactInEmergency;
        delete dataObject.mother.agreeToContactInEmergency;
        delete dataObject.guardian.agreeToContactInEmergency;

        // Trước đây chỉ nhận người thân đủ CẢ 3 (họ tên + di động + ngày sinh) — nhập thiếu 1 field là
        // entry bị LOẠI IM LẶNG khỏi payload: drawer báo lưu thành công mà thông tin biến mất (vụ nhập
        // mỗi họ tên Mẹ 2026-08-19). Giờ: có BẤT KỲ dữ liệu nào là lưu (chuẩn drawer cho-lưu-thiếu);
        // trống hết = không lưu entry đó (giữ hành vi xóa người thân bằng cách xoá trắng form).
        const _hasContactData = (p: any) =>
          ['fullName', 'dateOfBirth', 'occupation', 'mobile', 'email', 'currentAddress']
            .some((k) => String(p[k] ?? '').trim() !== '')
        dataObject.personalContacts = []
        if (_hasContactData(dataObject.father)) {
          dataObject.personalContacts.push(dataObject.father)
        }
        if (_hasContactData(dataObject.mother)) {
          dataObject.personalContacts.push(dataObject.mother)
        }
        if (_hasContactData(dataObject.guardian)) {
          dataObject.personalContacts.push(dataObject.guardian)
        }
        delete dataObject.father;
        delete dataObject.mother;
        delete dataObject.guardian;

        let tempData = {
          ...dataObject,
          admissionRegistration: admissionRegistration.value,
        };
        tempData = funcHistories(tempData)
        await axios
          .put(`/applicant/admin/${id.value}`, tempData)
          .then(async ({ data }) => {
            editPersonalContacts.value = false;
            isErrorFormPersonalContacts.value = false;
            //View đọc TÊN tỉnh/phường (permanentProvince/permanentWard); gán lại tên vừa resolve để view cập nhật ngay
            personalContacts.value.permanentProvince = dataObject.permanentProvince;
            personalContacts.value.permanentWard = dataObject.permanentWard;
            personalContacts.value.postalProvince = dataObject.postalProvince;
            personalContacts.value.postalWard = dataObject.postalWard;
            await syncDataforStudent(data.item)
            dataReset.value = data.item;
            emit("callBackFunction", data.item);
          })
          .catch(({ response }) => {
            popupMessage(response.data?.errorMessage,'error')
            console.log("err", response);
          });
    };

    const saveRelatives = async () => {
      // CHẶN lưu khi form còn lỗi validate: 2 mục "Đồng ý cho UMT thông báo" là BẮT BUỘC (el-form-item
      // ẩn có rule) — không chọn thì hoặc Hủy bỏ hoặc chọn đủ rồi mới lưu được. Các field người thân
      // khác không gắn rule nên vẫn theo chuẩn cho-lưu-thiếu.
      if (submitButtonRelatives.value) {
        const _valid = await new Promise((resolve) =>
          submitButtonRelatives.value.validate((v: boolean) => resolve(v)));
        if (!_valid) return;
      }
      let dataObject = JSON.parse(JSON.stringify(personalContacts.value));

        const _newProvName = (code: any) =>
          dataNewProvinces.value.find((p: any) => String(p.code) === String(code))?.name || "";
        dataObject.permanentProvince = _newProvName(dataObject.newPermanentProvinceCode);
        dataObject.permanentWard = dataWard.value.filter(
          (i: any) => String(i.id) === String(dataObject.newPermanentWardCode)
        )[0]?.name || "";
        dataObject.permanentDistrict = null;
        dataObject.permanentDistrictId = null;
        dataObject.postalProvince = _newProvName(dataObject.newPostalProvinceCode);
        dataObject.postalWard = dataPostalWard.value.filter(
          (i: any) => String(i.id) === String(dataObject.newPostalWardCode)
        )[0]?.name || "";
        dataObject.postalDistrict = null;
        dataObject.postalDistrictId = null;
        let tempReleaseOfStudy = [] as string[];
        if (dataObject.father.agreeToReleaseOfStudyProgress) {
          tempReleaseOfStudy.push("father");
        }
        if (dataObject.mother.agreeToReleaseOfStudyProgress) {
          tempReleaseOfStudy.push("mother");
        }
        if (dataObject.guardian.agreeToReleaseOfStudyProgress) {
          tempReleaseOfStudy.push("guardian");
        }
        if (noneNotifiOfReg.value) {
          tempReleaseOfStudy.push("none");
        }
        let tempContactInEmergency = [] as string[];
        if (dataObject.father.agreeToContactInEmergency) {
          tempContactInEmergency.push("father");
        }
        if (dataObject.mother.agreeToContactInEmergency) {
          tempContactInEmergency.push("mother");
        }
        if (dataObject.guardian.agreeToContactInEmergency) {
          tempContactInEmergency.push("guardian");
        }
        dataObject.notificationRegistration = {
          agreeToReleaseOfStudyProgress: tempReleaseOfStudy.join("|"),
          agreeToContactInEmergency: tempContactInEmergency.join("|"),
        };
        delete dataObject.father.agreeToReleaseOfStudyProgress;
        delete dataObject.mother.agreeToReleaseOfStudyProgress;
        delete dataObject.guardian.agreeToReleaseOfStudyProgress;

        delete dataObject.father.agreeToContactInEmergency;
        delete dataObject.mother.agreeToContactInEmergency;
        delete dataObject.guardian.agreeToContactInEmergency;

        // Trước đây chỉ nhận người thân đủ CẢ 3 (họ tên + di động + ngày sinh) — nhập thiếu 1 field là
        // entry bị LOẠI IM LẶNG khỏi payload: drawer báo lưu thành công mà thông tin biến mất (vụ nhập
        // mỗi họ tên Mẹ 2026-08-19). Giờ: có BẤT KỲ dữ liệu nào là lưu (chuẩn drawer cho-lưu-thiếu);
        // trống hết = không lưu entry đó (giữ hành vi xóa người thân bằng cách xoá trắng form).
        const _hasContactData = (p: any) =>
          ['fullName', 'dateOfBirth', 'occupation', 'mobile', 'email', 'currentAddress']
            .some((k) => String(p[k] ?? '').trim() !== '')
        dataObject.personalContacts = []
        if (_hasContactData(dataObject.father)) {
          dataObject.personalContacts.push(dataObject.father)
        }
        if (_hasContactData(dataObject.mother)) {
          dataObject.personalContacts.push(dataObject.mother)
        }
        if (_hasContactData(dataObject.guardian)) {
          dataObject.personalContacts.push(dataObject.guardian)
        }
        delete dataObject.father;
        delete dataObject.mother;
        delete dataObject.guardian;

        let tempData = {
          ...dataObject,
          admissionRegistration: admissionRegistration.value,
        };
        tempData = funcHistories(tempData)
        await axios
          .put(`/applicant/admin/${id.value}`, tempData)
          .then(async ({ data }) => {
            editRelatives.value = false;
            isErrorFormPersonalContacts.value = false;
            await syncDataforStudent(data.item)
            dataReset.value = data.item;
            emit("callBackFunction", data.item);
          })
          .catch(({ response }) => {
            popupMessage(response.data?.errorMessage,'error')
            console.log("err", response);
          });
    };

    const saveChanges3 = async () => {
      if (!submitButton3.value) { return }
        submitButton3.value.validate(async (valid) => {
          if (valid) {
            learningProcess.value.highschoolProvince =
              dataProvinceForSchool.value.filter(
                (i) => i.id == learningProcess.value.highschoolProvinceId
              )[0]?.name;
            learningProcess.value.highschoolDistrict =
              dataDistrictForSchool.value.filter(
                (i) => i.id == learningProcess.value.highschoolDistrictId
              )[0]?.name;
            learningProcess.value.highschoolName = dataSchoolName.value.filter(
              (i) => i.id == learningProcess.value.highschoolId
            )[0]?.name;
            let dataObject = JSON.parse(JSON.stringify(learningProcess.value));

            let tempData = {
              ...dataObject,
              admissionRegistration: admissionRegistration.value,
            };
            tempData = funcHistories(tempData)
            await axios
              .put(`/applicant/admin/${id.value}`, tempData)
              .then(({ data }) => {
                editLearningProcess.value = false;
                dataReset.value = data.item;
              })
              .catch(({ response }) => {
                popupMessage(response.data?.errorMessage,'error')
                console.log("err", response);
              });
          }
        })
    };
    function sendMailStudent(id: any) {
        // Email nhận báo phí mặc định = email liên lạc của hồ sơ; cho phép admin đổi (để test hoặc khi email SV chưa đúng)
        const defaultEmail = personalContacts.value?.contactEmail || "";
        Swal.fire({
            title: "Gửi báo phí",
            html: `Email ứng viên nhận báo học phí?`,
            input: "email",
            inputValue: defaultEmail,
            inputPlaceholder: "Email nhận báo phí",
            icon: "question",
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Trở lại",
            customClass: {
                confirmButton: "btn btn-primary order-2",
                cancelButton: "btn btn-light order-1",
            },
            inputValidator: (value) => {
                if (!value) return "Vui lòng nhập email nhận báo phí";
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return "Email không hợp lệ";
                return null;
            },
        }).then((result) => {
            if (result.isConfirmed) {
                let urlApi = `applicant/mail/sendmailhoantatnhaphoc`
                let tempData = {applicantids: [id], overrideEmail: result.value}

                axios.post(urlApi,tempData).then(({data}) => {
                  Swal.fire({
                    text: `Đã gửi mail ${data[0]?.status == 'success'?'thành công':'thất bại'} đến ${result.value}!`,
                    icon: data[0]?.status == 'success'?"success" : 'error',
                    buttonsStyling: false,
                    confirmButtonText: "Đóng",
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                    })
                })
            }

        });
    }
    const cacuTotal = (data: any) => {
      let dataOld = JSON.parse(JSON.stringify(data));
      const totalOld = dataOld.orderDetails.total - +dataOld.tuitionRegistration.paid
      return totalOld
    }
    const dataHistories = ref<any>([])
    function funcHistories(obj) {
      obj.lastModifiedBy = {
        fullName: userLocal.value.fullName,
        id: userLocal.value.id,
      }
      dataHistories.value.push(JSON.parse(JSON.stringify(obj)))
      obj.histories = dataHistories.value
      // Hồ sơ ĐÃ CHỐT: BE bắt buộc editReason (>=10 ký tự) mới cho lưu, và ghi lý do vào [TIMELINE].
      // Gắn ở đây để MỌI đường Lưu của trang đều kèm lý do — khỏi phải nhớ sửa từng nút.
      if (finalEditMode.value && finalEditReason.value) {
        obj.editReason = finalEditReason.value
      }
      return obj
      
    }
    function formatTuitionReg(){
      let freeTuition = [] as any
      if(orderDetails.value.otherPromotionsVip && orderDetails.value.otherPromotionsVip.value) {
        let tempromotionvip = {
          registrationType: "promotionvip",
          promotionvip: {
            description: orderDetails.value.otherPromotionsVip.description,
            name: orderDetails.value.otherPromotionsVip.name,
            value: Number((+orderDetails.value.otherPromotionsVip.value).toFixed(0)),
          }
        }
        freeTuition.push(tempromotionvip as any);
      }
      if(orderDetails.value.otherPromotionsVipPro && orderDetails.value.otherPromotionsVipPro.percent) {
        let tempromotionvippro = {
          registrationType: "promotionvippro",
          promotionvippro: {
            description: orderDetails.value.otherPromotionsVipPro.description,
            name: orderDetails.value.otherPromotionsVipPro.name,
            value: Number((+moneyPromotionVipPro.value).toFixed(0)),
            type: orderDetails.value.otherPromotionsVipPro.type,
            code: orderDetails.value.otherPromotionsVipPro.code,
            percent: orderDetails.value.otherPromotionsVipPro.percent 
          }
        }
        freeTuition.push(tempromotionvippro as any);
      }
      if(chooseCourses.value.code) {
        let temp = {
            registrationType: "chooseenglish",
            value: chooseCourses.value.code,
        }
        freeTuition.push(temp as any);
      }
      if(arrCourseexemptions.value) {
          // console.log('arrCourseexemptions',arrCourseexemptions.value)
          let temp = {
            registrationType: "courseexemptions",
            courseexemptions: arrCourseexemptions.value.map((i: any) =>{
              let temp = {
                //trim: mã/tên trong Cài đặt hay dính dấu cách thừa, lưu nguyên thì hồ sơ bẩn + khó khớp lại
                code: String(i.code ?? '').trim(),
                name: String(i.name ?? '').trim(),
                value: i.value,
                description: i.description,
                parentCode: i.parentCode,
              }
              return temp
            }),
            coursenextLevel: courseNextLevel.value 
          };
          freeTuition.push(temp as any);
        }
        if (freeTuitionRegistration.value.registrationTypeSiblings && freeTuitionRegistration.value.siblings.studentId && freeTuitionRegistration.value.siblings.fullName) {
          let temp = {
            registrationType: "siblings",
            siblings: {
              studentId: freeTuitionRegistration.value.siblings.studentId,
              fullName: freeTuitionRegistration.value.siblings.fullName,
              value: freeTuitionDiscount.value,
              amount: Number((+moneySiblings.value).toFixed(0)),
            },
          };
          freeTuition.push(temp as any);
        }
        else {
          freeTuitionRegistration.value.registrationTypeSiblings = false
        }
        // console.log('orderDetails.value.promotion',orderDetails.value.promotion)
        if (
          dataScholarship.value.length != 0 && dataScholarshipPro.value.scholarship
        ) {
          let value = scholarshipValueListen.value as any
          let temp = {
            registrationType: "scholarships",
            scholarships: {
              type: dataScholarship.value[0]?.scholarshipType,
              code: dataScholarship.value[0]?.scholarshipCode,
              value: Number((+value).toFixed(0)),
              releasedIn: dataScholarship.value[0]?.releasedIn,
              name: dataScholarship.value[0]?.description,
              discount: discountScholarship.value, //string;
            }
          } as any
          // if(studentData.value && (studentData.value?.isstaffchild || studentData.value?.ispartnerchild)) {
          //   temp.scholarships.reExtraDiscount = studentData.value?.personnelchild
          // }
          freeTuition.push(temp as any);
          if(dataScholarshipPro.value.promotion) {
            let tempromotion = {
              registrationType: "promotion",
              promotion: dataScholarshipPro.value.promotion
            }
            freeTuition.push(tempromotion as any);
          }
          if(dataScholarshipPro.value.promotionExtend && dataScholarshipPro.value.promotionExtend.length != 0) {
            let tempromotion = {
              registrationType: "promotionExtend",
              promotionExtend: dataScholarshipPro.value.promotionExtend
            }
            freeTuition.push(tempromotion as any);
          }
          if(scholarshipPromotionMultiData.value && scholarshipPromotionMultiData.value.length != 0) {
            let tempromotion = {
              registrationType: "scholarshipPromotionMultiData",
              scholarshipPromotionMultiData: scholarshipPromotionMultiData.value
            }
            freeTuition.push(tempromotion as any);
          }
        }
        if(reduceEnglish.value) {
          let tempromotion = {
              registrationType: "reduceEnglish",
              reduceEnglish: reduceEnglish.value
            }
            freeTuition.push(tempromotion as any);
        }
      return freeTuition
    }
    const submitTuitionReg = async () => {
      // if(checkIsUpdateScholarship.value && firstLoad.value) {
      //   return
      // }
      if (!submitButton4.value) { return }
      // Cấp trước - chờ điều kiện: còn khoản chưa thỏa -> xác nhận CÓ Ý THỨC trước khi lưu
      // (SV sẽ không thấy các khoản này ở cổng nhập học; tổng 2 bên lệch tới khi SV hoàn thành)
      if (pendingConditionItems.value.length) {
        const list = pendingConditionItems.value.map((p: any) => `• <b>${p.name}</b> — ${p.reason}`).join('<br/>')
        const res = await Swal.fire({
          title: 'Cấp trước khi thỏa điều kiện?',
          html: `${list}<br/><br/><span class="fs-7 text-gray-600">Ứng viên sẽ KHÔNG thấy/không được trừ các khoản trên ở cổng nhập học cho tới khi hoàn thành điều kiện.</span>`,
          icon: 'warning',
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: 'Vẫn lưu (cấp trước)',
          cancelButtonText: 'Xem lại',
          customClass: { confirmButton: 'btn btn-primary order-2', cancelButton: 'btn btn-light order-1' },
        })
        if (!res.isConfirmed) return
      }
        submitButton4.value.validate(async (valid) => {
          if (valid) {
              // Activate indicator
              // submitButton4.value.setAttribute("data-kt-indicator", "on");
              let freeTuition = formatTuitionReg() as any;
              
              let tuitionReg = {
                name: tuitionRegistration.value.name,
                value: dataTuition.value[tuitionRegistration.value.name]?.value,
                paid: +dataRegistrationfeerequest.value?.paymentConfirmation?.paid,
                programcode: dataMajor.value.programcode,
                programname: dataMajor.value.programname,
                majorshortname: dataMajor.value.majorshortname,
                tuitionid: dataMajor.value.id,
              };
              let tempData = {
                tuitionRegistration: tuitionReg,
                freeTuitionRegistration: freeTuition,
                admissionRegistration: admissionRegistration.value,
                englishClassPlacementTestRegistration: JSON.parse(JSON.stringify(englishClassPlacementTest.value)),
              } as any
              tempData = Object.assign(tempData, dataPayments.value);
              tempData = funcHistories(tempData)
              await axios
                .put(`/applicant/admin/${id.value}`, tempData)
                .then(({ data }) => {
                  isErrorFormFreeTuitionReg.value = false;
                  isShowFreeTuition.value = false;
                  // if(data.item.status == 'confirmed') {
                  //   if(cacuTotal(data.item) != cacuTotal(dataReset.value)) {
                  //     sendMailStudent(data.item.id)
                  //   }
                  // }
                  dataReset.value = data.item;
                  initfreeTuitionRegistration()
                  emit("callBackFunction", data.item);
                  checkTotal(data)
                  // Truy vết "cấp trước - chờ điều kiện" vào widget Ghi chú (admission_comments theo idStudent)
                  if (pendingConditionItems.value.length) {
                    try {
                      const _u = JSON.parse(window.localStorage.getItem('user') || '{}')
                      const _list = pendingConditionItems.value.map((p: any) => `${p.name} (${p.reason})`).join('; ')
                      axios.post(`/admission/comment`, {
                        idUser: _u.id,
                        idStudent: props.dataInitial?.studentId,
                        comment: `[TIMELINE] Lưu học phí với ${pendingConditionItems.value.length} khoản cấp TRƯỚC khi thỏa điều kiện: ${_list}`,
                      }).catch(() => {})
                    } catch (e) { /* ghi chú phụ trợ — không chặn luồng lưu */ }
                  }
                })
                .catch(({ response }) => {
                  popupMessage(response.data?.errorMessage,'error')
                  console.log("err", response);
                });
          }
        })

      };
    const submitUniform = async () => {
      if (submitButton5.value) {
        // Activate indicator
        submitButton5.value.setAttribute("data-kt-indicator", "on");
        // uniformRegistration.value.price = tshirt_trousers_price.value;
        // uniformRegistration.value.total = (+tshirt_trousers_price.value *
        //   +uniformRegistration.value.purchaseQuality) as any;
        let tempData = {
          uniformRegistration: uniformRegistration.value,
          admissionRegistration: admissionRegistration.value,
        } as any
        tempData = funcHistories(tempData)
        await axios
          .put(`/applicant/admin/${id.value}`, tempData)
          .then(({ data }) => {
            dataReset.value = data.item;
            uniformRegistration.value.purchaseQuality =
              data.item.uniformRegistration.purchaseQuality;
            // this.initUniformRegistration()
            isShowUniformReg.value = false;
            isErrorFormUniformReg.value = false;
          })
          .catch(({ response }) => {
            popupMessage(response.data?.errorMessage,'error')
            console.log("err", response);
          });
        setTimeout(() => {
          submitButton5.value?.removeAttribute("data-kt-indicator");
        }, 2000);
      }
    };
    const submitOtherFees = async () => {
        // Activate indicator
        // otherFees.value.forEach(i=>i.total = +i.price * (+i.quantity))
        let tempOtherFees = otherFees.value.filter(i=>i.quantity !=0).map(i=>{return {
            code: i.code,
            discount: i.discount,
            name: i.name,
            price: i.price,
            quantity: i.quantity,
            size: i.size,
            total: +i.price * (+i.quantity),
            type: i.type,
            unit: i.unit,
          }})
        let tempData = {
          admissionRegistration: admissionRegistration.value,
          otherFees: tempOtherFees.length != 0 ? tempOtherFees : []
        } as any
        // console.log('otherFee',otherFees.value)
        tempData = funcHistories(tempData)
        await axios
          .put(`/applicant/admin/${id.value}`, tempData)
          .then(({ data }) => {
            dataReset.value = data.item;
            emit("callBackFunction", data.item);
            checkTotal(data)
            isShowOtherFees.value = false;
          })
          .catch(({ response }) => {
            popupMessage(response.data?.errorMessage,'error')
            console.log("err", response);
          });
        
    };
    function checkTotal(data:any) {
      let total = 0
      if(data.item.otherFees) {
        total = data.item.otherFees.reduce((a, b) => a + b.total, 0)
      }
      let a = data.item.orderDetails.total+total
      let b = +props.dataReceipt?.paymentConfirmation.paid
      if(props.dataReceipt && (Number(a) - Number(b) != 0)) {
        let scrollDiv = document.getElementById("inforPayment")?.offsetTop || 0;
        window.scrollTo({ top: scrollDiv - 120, behavior: "smooth" });
      }
    }
    const arrReligion = ref<any>([]);
    const arrEthnic = ref<any>([]);
    const arrNational = ref<any>([
      {
        value: "Việt Nam",
        label: "Việt Nam",
      },
      {
        value: "Khác",
        label: "Khác",
      },
    ]);
    const dataProvince = ref([] as any);
    const dataDistrict = ref([] as any);
    const dataWard = ref([] as any);
    const dataPostalDistrict = ref([] as any);
    const dataPostalWard = ref([] as any);
    const dataNewProvinces = ref([] as any);
    const newProvinceOptions = computed(() =>
      dataNewProvinces.value.map((p: any) => ({ value: String(p.code), label: p.name }))
    );
    // Trả Phường/Xã của 1 Tỉnh mới, shape {id:code, name} để khớp v-for el-option :value="item.id"
    const newWardsOf = (provinceCode: any) => {
      if (provinceCode === null || provinceCode === undefined || provinceCode === "") return [];
      const p = dataNewProvinces.value.find((x: any) => String(x.code) === String(provinceCode));
      return p && Array.isArray(p.wards) ? p.wards.map((w: any) => ({ id: String(w.code), name: w.name })) : [];
    };
    const dataProvinceForSchool = ref([] as any);
    const dataDistrictForSchool = ref([] as any);
    const dataSchoolName = ref([] as any);
    const dataScholarship = ref([] as any);
    const arr_dataTuition = ref([] as any);
    const dataTuition = ref({} as any);
    const dataSettingItem = ref([] as any);
    const dataBank = ref([] as any);
    const dataPromotion = ref([] as any);
    const u_tshirt_price = ref("");
    const u_trousers_price = ref("");
    const tshirt_trousers_price = ref("");
    const idAdReg = ref("");
    const adCode = ref("");
    const dataReset = ref({} as any);
    const id = ref(props.dataInitial?.id);
    const studentData = ref(props.dataInitial?.Student||{})
    const certificateBarcode = ref("");
    const freeTuitionDiscount = ref("");
    const freeTuitionUnit = ref("");
    const admissionRegistration = ref({} as any);
    const optionBanking = ref([] as any);
    const isSubmitQr = ref(false);
    const noneNotifiOfReg = ref(false);
    const expiredPromotion = ref(false)
    // console.log('props?.dataInitial',props?.dataInitial)
    const dataScholarshipPro = ref<any>({})
    const checkIsUpdateScholarship = computed(() => {
      // console.log('dataScholarship.value.length',dataScholarship.value)
      // console.log('!scholarshipDefault.value.value',scholarshipDefault.value)
      // console.log('tuitionRegistration.value.name',tuitionRegistration.value.name)
      // if(dataScholarship.value.length != 0 && !scholarshipDefault.value.value && tuitionRegistration.value.name) {
      //   // console.log('checkIsUpdateScholarship',true)
      //   return true  
      // }
      return false
    });
    function checkScholarshipForPromotion(data) {
      if (data.length != 0) {
        let scholarshipNow = data[0]
        if(scholarshipNow['Scholarship.bypasscondition']) { // HB bỏ qua điều kiện -> coi như đã thỏa
          return true
        }
        let item = scholarshipNow['Scholarship.condition']
        if(item) {
          return checkCondition(item)
        }
        return true
      }
      return false
    }
    function checkPromotionInScholarship(item: any){
      let condition = item.condition
      let check = [] as any
      if(condition && condition.length != 0) {
        condition.forEach((i: any) => {
          check.push(checkCondition(i))
        })
      }
      return !check.includes(false)
    }
    // ===== Khoản ưu đãi/HB ĐANG ÁP nhưng CHƯA THỎA điều kiện (cấp trước - chờ SV đóng) =====
    // Admin được cấp bất chấp điều kiện (chủ đích nghiệp vụ) nhưng PORTAL enforce -> SV không thấy
    // cho tới khi thỏa. List này nuôi banner cảnh báo + confirm khi Lưu + timeline (2026-07-16).
    const fmtCondReason = (cond: any) => {
      if (!cond) return 'theo điều kiện chương trình'
      const d = cond.date ? new Date(cond.date).toLocaleDateString('vi-VN') : ''
      const loai = cond.type == 'Deposit' ? 'phí giữ suất' : cond.type == 'Tuition Fee' ? 'học phí' : (cond.type || 'khoản phí')
      return `cần hoàn thành ${loai}${cond.value ? ` ${(+cond.value).toLocaleString('vi-VN')}đ` : ''}${d ? ` trước ${d}` : ''}`
    }
    // "Mắt portal": admin nhìn thấy phiếu thu RỘNG hơn SV (endpoint + scope khác) nên check bằng
    // dữ liệu admin sẽ báo "ổn" trong khi PORTAL của SV báo "chưa thỏa". Fetch ĐÚNG endpoint portal
    // (/receipt/find/findprereceipts theo studentcode) + đánh giá ĐÚNG semantics portal (không nhánh
    // bỏ-qua-ngày của admin) để biết chính xác SV đang được áp gì.
    const portalEyeReceipts = ref<any[]>([])
    const loadPortalEyeReceipts = async () => {
      try {
        const code = props.dataInitial?.studentCode
        if (!code) { portalEyeReceipts.value = []; return }
        const { data } = await axios.get(`/receipt/find/findprereceipts/?studentcode=${code}`)
        portalEyeReceipts.value = data || []
      } catch (e) { portalEyeReceipts.value = [] }
    }
    // Port nguyên semantics checkCondition của PORTAL (Settings.vue): không có phiếu -> false;
    // có phiếu nhưng đóng sau hạn / thiếu tiền -> false. (KHÔNG có nhánh "không date -> true" của admin.)
    const checkConditionPortalEye = (cond: any) => {
      if (!cond) return true
      const receipts = (portalEyeReceipts.value || []).filter((i: any) => i.journaltype == cond.type)
      if (!receipts.length) return false
      const issuedDate = sortByDate(receipts, 'issuedDate')[0]?.issuedDate
      const con = new Date(issuedDate).getTime()
      const a = new Date(cond.date).getTime()
      const sum = receipts.reduce((acc: number, obj: any) => acc + (+obj.paymentConfirmation?.paid || 0), 0)
      if (a - con < 0 || sum < (+cond.value || 0)) return false
      return true
    }
    const dataScholarshipRawCond = ref<any>(null) // condition thô của HB (giữ cả khi gate fail)
    const dataPromotionRawAll = ref<any[]>([]) // catalog CTKM thô (trước filter) — tra ngược CTKM đã lưu
    const pendingConditionItems = computed(() => {
      const out: any[] = []
      try {
        // Nguồn = freeTuitionRegistration ĐÃ LƯU trên props (bất biến — không phụ thuộc ref render nào nạp)
        const saved = props.dataInitial?.freeTuitionRegistration || []
        const savedSch = saved.find((i: any) => i.registrationType == 'scholarships')?.scholarships
        const savedProKem = saved.find((i: any) => i.registrationType == 'promotion')?.promotion
        const savedExts = saved.find((i: any) => i.registrationType == 'promotionExtend')?.promotionExtend || []
        // 1) Học bổng đã gán: điều kiện lấy từ catalog thô (giữ trước gate) -> live -> saved
        const schCond = dataScholarshipRawCond.value
          || (dataScholarship.value[0] && dataScholarship.value[0]['Scholarship.condition'])
          || savedSch?.condition
        // HB bật "Bỏ qua điều kiện": portal cũng không còn gate -> không bao giờ ở trạng thái chờ
        const schBypass = !!(dataScholarship.value[0] && dataScholarship.value[0]['Scholarship.bypasscondition'])
        const schPending = !schBypass && !!savedSch && !!schCond && !checkConditionPortalEye(schCond)
        if (schPending) {
          out.push({ name: savedSch.name || 'Học bổng', value: +savedSch.value || 0, reason: fmtCondReason(schCond) })
          if (savedProKem && savedProKem.value) {
            out.push({ name: savedProKem.name || 'Ưu đãi kèm học bổng', value: +savedProKem.value || 0, reason: 'đi kèm học bổng — chờ điều kiện học bổng ở trên' })
          }
        }
        // 2) Ưu đãi đóng phí sớm (addition của HB): điều kiện riêng từng dòng qua mắt portal
        savedExts.forEach((it: any) => {
          if (!it) return
          const conds = it.condition || []
          const fail = conds.length ? conds.some((c: any) => !checkConditionPortalEye(c)) : false
          if (fail || schPending) {
            const c0 = conds[0]
            out.push({ name: it.name || 'Ưu đãi đóng phí sớm', value: +it.value || 0, reason: fail ? fmtCondReason(c0) : 'đi kèm học bổng — chờ điều kiện học bổng' })
          }
        })
        // 3) CTKM CHÍNH đã lưu (orderDetails.promotion): saved KHÔNG chứa condition — phải tra ngược
        //    CATALOG thô (dataPromotionRawAll) rồi đánh giá như portal: hết hạn/tắt? gói không thuộc
        //    appliedType? điều kiện THẬT chưa thỏa (mắt portal)? (điều kiện RỖNG = không điều kiện — đã
        //    fix cùng ngày ở portal). CTKM pending kéo theo "Ưu đãi đóng phí sớm" (promotionvip) cùng block.
        const promo = orderDetails.value?.promotion as any
        if (promo && (promo.code || promo.promotionCode)) {
          const pcode = promo.code || promo.promotionCode
          const raw = (dataPromotionRawAll.value || []).find((i: any) => i.promotionCode == pcode)
          let promoPendingReason = ''
          if (!raw) {
            promoPendingReason = 'chương trình không còn trong danh mục (đã tắt/xóa)'
          } else if (raw.bypasscondition) {
            // Cấu hình "Bỏ qua điều kiện": hết hạn/điều kiện kích hoạt đều không còn chặn ở cả 2 bên
            promoPendingReason = ''
          } else if (raw.endedDate && +new Date(raw.endedDate) < Date.now()) {
            promoPendingReason = `chương trình đã hết hạn ${new Date(raw.endedDate).toLocaleDateString('vi-VN')}`
          } else if (raw.appliedType && !String(raw.appliedType).split(',').includes(String(tuitionRegistration.value?.name))) {
            promoPendingReason = `không áp dụng cho gói ${tuitionRegistration.value?.name} học kỳ đang chọn`
          } else {
            const c = raw.condition
            const condEmpty = !c || (!c.type && !c.date && !(+c.value) && !(c.specialApplied && c.specialApplied.length))
            if (!condEmpty && !(c.specialApplied && c.specialApplied.length) && !checkConditionPortalEye(c)) {
              promoPendingReason = fmtCondReason(c)
            }
          }
          if (promoPendingReason) {
            out.push({ name: promo.promotionName || promo.name || 'Ưu đãi', value: +promo.amount || 0, reason: promoPendingReason })
            // promotionvip (Ưu đãi đóng phí sớm) nằm trong cùng block tính tiền với CTKM chính ở portal
            const vip = saved.find((i: any) => i.registrationType == 'promotionvip')?.promotionvip
            if (vip && vip.value) {
              out.push({ name: vip.name || 'Ưu đãi đóng phí sớm', value: +vip.value || 0, reason: 'đi kèm ưu đãi chính — chờ theo khoản ở trên' })
            }
          }
        }
      } catch (e) { console.warn('[pending-condition-check] lỗi đánh giá (bỏ qua, không ảnh hưởng tính tiền):', e) }
      return out
    })
    const pendingConditionSum = computed(() => pendingConditionItems.value.reduce((a: number, b: any) => a + (+b.value || 0), 0))

    // ===== S1: MỨC ưu đãi đã bị sửa sau khi ứng viên chọn =====
    // orderDetails.promotion lưu nguyên cấu hình lúc chọn (type + value + amount). Nếu admin sửa % / số tiền
    // của CTKM giữa chừng, hồ sơ chưa hoàn tất sẽ tính lại theo mức MỚI ngay khi ai đó chạm form -> giá đổi
    // âm thầm. Đối chiếu cấu hình đã lưu với catalog THÔ để nói rõ "25% -> 20%" thay vì đổi số lặng lẽ.
    const _fmtPromoCfg = (o: any) => {
      if (!o) { return '—' }
      if (String(o.type) == 'percent') { return `${o.value}%` }
      return `${(+String(o.value || 0).replaceAll('.', '') || 0).toLocaleString('vi-VN')}đ`
    }
    const promotionConfigChanged = computed(() => {
      const promo: any = orderDetails.value?.promotion
      const pcode = promo && (promo.code || promo.promotionCode)
      if (!pcode || !promo.type) { return null }
      const raw: any = (dataPromotionRawAll.value || []).find((i: any) => i.promotionCode == pcode)
      if (!raw || !Array.isArray(raw.benefit) || raw.benefit.length == 0) { return null }
      const nowCfg = raw.benefit.find((b: any) => b.name == promo.name) || raw.benefit[0]
      if (!nowCfg) { return null }
      if (String(nowCfg.type || '') == String(promo.type || '') && String(nowCfg.value || '') == String(promo.value || '')) {
        return null
      }
      return {
        name: promo.promotionName || promo.name || 'Ưu đãi',
        oldText: _fmtPromoCfg(promo),
        newText: _fmtPromoCfg(nowCfg),
        savedAmount: +promo.amount || 0,
      }
    })
    // Bỏ hẳn ưu đãi đang áp (dùng lại đúng thao tác của nút "Bỏ ưu đãi này" ở khối Học phí)
    const promoDriftDismissed = ref(false)   // người dùng chọn "Giữ mức đã chốt" -> thôi nhắc trong phiên này
    const confirmDropPromotion = async () => {
      const info: any = promotionConfigChanged.value
      const res = await Swal.fire({
        title: 'Bỏ ưu đãi đang áp?',
        html: `<b>${info?.name || 'Ưu đãi'}</b> sẽ được gỡ khỏi hồ sơ (đang giảm ${(info?.savedAmount || 0).toLocaleString('vi-VN')}đ).<br/><br/>`
          + `<span class="fs-7 text-gray-600">Chọn lại ưu đãi ở mục Học phí rồi Lưu để áp mức mới. Nhớ báo phí mới cho ứng viên.</span>`,
        icon: 'warning',
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: 'Bỏ ưu đãi',
        cancelButtonText: 'Để nguyên',
        customClass: { confirmButton: 'btn btn-danger order-2', cancelButton: 'btn btn-light order-1' },
      })
      if (!res.isConfirmed) { return }
      dropCurrentPromotion()
      promoDriftDismissed.value = true
    }
    const dropCurrentPromotion = () => {
      if (!orderDetails.value?.promotion) { return }
      orderDetails.value.promotion.value = ''
      tempDataPromotion.value = null
      tempDataPromotionAddition.value = null
      orderDetails.value.otherPromotions = []
      orderDetails.value.otherPromotionsVip = {}
      firstLoad.value = false
    }

    const checkLineFreeSubject = computed(() => {
      let a = dataFreeSubject.value.filter((i: any) =>i.appliedprograms?.includes(props?.dataInitial?.programtype) && i.certificateCode == englishClassPlacementTest.value.englishCertificate.certificateName)
      if(englishClassPlacementTest.value.registrationType == 'english_thpt') {
        a = dataFreeSubject.value.filter((i: any) =>i.appliedprograms?.includes(props?.dataInitial?.programtype) && i.certificateCode == 'DTHPT')
      }
      // console.log('checkLineFreeSubject',a)
      return a
    })
    const layoutSubject: any = computed(() => {
      let a = checkLineFreeSubject.value||[]
      if(a.length != 0) {
        if(a[0].ismulticriteria) {
          return a[0].activationcriteria
        }
      }
      return null
    })
    const chooseCourses = ref<any>({
      courseNextLevel: [],
      courseexemptions: [],
      code: [],
    })
    const objCourseexemptions = computed(()=>{
      let temp = {} as any
      //bậc IELTS cao nhất = "miễn tất cả" (dùng cho luồng thi xếp lớp UMT). reduce KHÔNG initial -> mảng rỗng là crash
      const lines = (dataFreeSubject.value||[]).filter((i: any) => i.certificateCode == 'IELTS' && i.appliedprograms?.includes(props?.dataInitial?.programtype))
      if(lines.length != 0) {
        temp = lines.reduce((max: any, curren: any) => max.activationcriteria[0]?.max > curren.activationcriteria[0]?.max ? max : curren);
      }
      return temp
    })

    const arrChooseCourseexemptions = computed(()=>{
      let temp = objCourseexemptions.value
      // console.log('temp',temp)
      temp = temp.courseexemptions?.filter((i) => temp.appliedprograms?.includes(props?.dataInitial?.programtype))||[]
      // console.log('arrChooseCourseexemptions',temp)

      let programtype = props?.dataInitial?.programtype
      let a = [
        {
          code: "eme",
          name: "LT0",
          courses: [],
          courseExemptions:[]
        },
        {
          code: "l1",
          name: "LT1",
          courses: [],
          courseExemptions:[]
        },
        {
          code: "l2",
          name: "LT2",
          courses: [],
          courseExemptions: []
        },
        {
          code: "l3",
          name: "LT3",
          courses: [],
          courseExemptions: []
        },
        {
          code: "l4",
          name: "LT4",
          courses: [],
          courseExemptions: []
        },
        {
          code: "l5",
          name: "LT5",
          courses: [],
          courseExemptions: []
        },
        {
          code: "l6",
          name: "Miễn tất cả",
          courses: [],
          //LẤY TỪ CÀI ĐẶT (bậc chứng chỉ cao nhất) thay vì hardcode danh mục môn — trước đây kẹt 8 môn V1 giá cũ
          //nên đổi CTĐT là luồng thi xếp lớp UMT miễn nhầm môn/nhầm tiền.
          courseExemptions: temp.map((i: any, idx: number) => ({
            code: String(i.code ?? '').trim(),
            name: String(i.name ?? '').trim(),
            value: +i.value || 0,
            description: i.description,
            ...(idx === 0 ? { parentCode: 'l6' } : {}),
          })),
        },
      ]
      // if(programtype != 'SONG_NGU') {
      //   a = a.filter((i: any) => i.code != 'l5' && i.code !='l6')
      // }
      return a
    })
    const conditionSubject = computed(() => {
      let a = checkLineFreeSubject.value
      let b = [] as any
      let courseexemptions = [] as any
      if(a.length != 0) {
        // console.log('a',a)
        a.forEach((item: any,index: number) => {
          let check = false
          let c = [] as any
          item.activationcriteria.forEach((i: any,ind: number) => {
            let score = +englishClassPlacementTest.value.englishCertificate[`score`]
            if(englishClassPlacementTest.value.englishCertificate.certificateName == 'TOEIC') {
              score = +englishClassPlacementTest.value.englishCertificate[`score_${i.type}`]
            }
            // console.log('englishClassPlacementTest.value',englishClassPlacementTest.value.englishCertificate)
            // console.log('score.value',score)
            if(c.includes(false)) {
              check = false
              return
            }

            if(i.min) {
              
              if(i.min <= score) {
                // console.log('in')
                check = true
                c.push(true)
              }
              else {
                // console.log('out')
                c.push(false)
              }
            }

          })
          check = c.length > 0 && !c.includes(false) // FIX C8 (twin portal): phải đạt HẾT tiêu chí
          if(check) {
            b.push(item)
          }
        })
      }
      if(b.length !=0) {
        
        b.forEach((item: any) => {

          let check = false
          let c = [] as any
          item.activationcriteria.forEach((i: any) => {
            let score = +englishClassPlacementTest.value.englishCertificate[`score`]
            if(englishClassPlacementTest.value.englishCertificate.certificateName == 'TOEIC') {
              score = +englishClassPlacementTest.value.englishCertificate[`score_${i.type}`]
            }
            if(c.includes(false)) {
              check = false
              return
            }
            if(i.max) {
              if(i.max > score) {
                // console.log('in')
                check = true
                c.push(true)
              }
              else {
                // console.log('out')
                c.push(false)
              }
            }
          })
          check = c.length > 0 && !c.includes(false) // FIX C8 (twin portal): phải đạt HẾT tiêu chí (vòng max)
          if(check) {
            courseexemptions.push(item)
          }
        })
        if(courseexemptions.length == 0) {
          let temp = b.reduce((max: any, curren: any) => max.activationcriteria[0].max > curren.activationcriteria[0].max ? max : curren);
          // console.log('temp',temp)
          courseexemptions.push(temp)
        }
      }
      console.log('courseexemptions',courseexemptions)
      return courseexemptions.length !=0 ? courseexemptions[0] : null
    })
    const courseNextLevel = computed(() => {
      let a = conditionSubject.value?.nextlevel||[]
      if(a && Array.isArray(a)) {
        a = a.filter((i: any) => i.value)
      }
      else {
        a = []
      }
      if(firstLoad.value) {
        a = loadCourseexemptions.value?.nextLevel||[]
      }
      if(chooseCourses.value.courseNextLevel && Array.isArray(chooseCourses.value.courseNextLevel) && englishClassPlacementTest.value.registrationType == 'umt_test') {
        a = chooseCourses.value.courseNextLevel
      }
      if(chooseCourses.value.code && chooseCourses.value.code.length == 1 && chooseCourses.value.code[0] == "EFL004V1") {
        a = []
      }
      // console.log('courseNextLevel',a)
      // console.log('chooseCourses.value',chooseCourses.value)
      return a
    })
    //LƯU Ý (2026-08): hồ sơ ĐÃ LƯU giữ nguyên value lúc lưu — môn lưu 0đ thì mãi 0đ, muốn áp
    //giá hiện hành phải mở hồ sơ chọn lại + Lưu. CỐ Ý không tự vá giá khi nạp: việc đó đổi
    //tiền của hồ sơ đã báo phí/đã thu mà không ai duyệt. Rà bằng scripts/audit-english-exemption-zero.js
    //(backend) rồi xử lý tay từng hồ sơ.
    const arrCourseexemptions = computed(() => {
      console.log('conditionSubject.value.courseexemptions',conditionSubject.value)
      let a = [] as any
      if(conditionSubject.value) {
        a = limitByTuitionPackage(conditionSubject.value.courseexemptions)
      }
      if(firstLoad.value) {
        a = loadCourseexemptions.value.exemptions
      }
      if(chooseCourses.value.courseexemptions && englishClassPlacementTest.value.registrationType == 'umt_test') {
        a = limitByTuitionPackage(chooseCourses.value.courseexemptions)
      }
      console.log('arrCourseexemptions',a)
      return a
    })
    //CHỈ DÙNG ĐỂ HIỂN THỊ bảng kê học phí: bỏ môn miễn giảm 0đ (môn chưa điền tiền trong
    //Cài đặt) kẻo bảng kê đầy dòng "- 0". KHÔNG lọc trên arrCourseexemptions gốc vì nó còn
    //dùng để tính tiền và để LƯU vào freeTuitionRegistration (formatTuitionReg).
    const arrCourseexemptionsShow = computed(() => {
      return (arrCourseexemptions.value || []).filter((i: any) => +i.value > 0)
    })
    const arrSubject: any = computed(() => {
      let a = [] as any //dataFreeSubject.value
      dataFreeSubject.value.filter((i) => i.certificateCode != 'DTHPT').forEach((i: any) => {
        let temp = {
          value: i.certificateCode,
          label: i.certificateName,
        }
        if(!a.find((i: any) => i.value == temp.value)) {
          a.push(temp)
        }
      })
      return a
    })
    const dataFreeSubject = ref<any>([])
    const getFreesubject = async() => {
      await axios
      .get(`/setting/freesubject`)
      .then(({ data }) => {
        if(data && data.length != 0) {
          dataFreeSubject.value = data
          // console.log('dataFreeSubject.value',dataFreeSubject.value)
        }
      })
      .catch(({ response }) => {
        console.log("err", response);
      });
    }
    const promotionChild = ref<any>([])
    // Ưu đãi đối tượng đặc biệt (con GV/NV/đối tác): DB (/setting/promotion condition.specialApplied) ưu tiên, fallback hardcode.
    // Đối tác (ispartnerchild) chỉ có qua DB. Đồng bộ với Settings.vue cổng SV.
    const dataPromotionChildDb = ref<any>({})
    function hardcodeChildFor(flag: string) {
      // Đã CHUYỂN sang ưu đãi phân bậc theo học kỳ (benefitaddition) cấu hình ở DB, chọn bậc theo personnelchild
      // (con GV/NV THPT: Đối tượng 1/2/3; con GV/NV UMT-Kiến Á: thâm niên; con đối tác: DOITAC).
      // -> KHÔNG còn fallback flat-% hardcode (tránh hiện card vipPro % TRÙNG với card multi benefitaddition).
      return null
    }
    function buildPromotionChild() {
      const out = [] as any
      for (const flag of ['isstaffchild','islecturerchild','ispartnerchild']) {
        if (!studentData.value?.[flag]) continue
        if (dataPromotionChildDb.value[flag]) { out.push(dataPromotionChildDb.value[flag]); continue }
        const h = hardcodeChildFor(flag); if (h) out.push(h)
      }
      promotionChild.value = out
    }
    // Widget "Ghi chú" (timeline) là component ANH EM ở trang cha -> nó không biết trang này vừa lưu.
    // BE ghi [TIMELINE] ngay trong các endpoint dưới đây, nên bắt ở tầng axios: lưu OK (2xx) là phát
    // "reloadComment" cho WidgetComment nạp lại. Đặt 1 chỗ để phủ CẢ 18 đường Lưu của Tab1 lẫn 4
    // component gapTimeActivities (cùng axios instance) — khỏi phải nhớ emit ở từng nút.
    const TIMELINE_WRITE_URL = /\/applicant\/(admin|articulation-enrollment|reopen|phase|undo-confirm)\//;
    let timelineInterceptorId: number | null = null;
    onMounted(() => {
      timelineInterceptorId = axios.interceptors.response.use((res: any) => {
        const cfg: any = res?.config || {};
        if (String(cfg.method).toLowerCase() === 'put' && TIMELINE_WRITE_URL.test(String(cfg.url || ''))) {
          emitter.emit('reloadComment');
        }
        return res;
      });
    });
    onUnmounted(() => {
      if (timelineInterceptorId !== null) {
        axios.interceptors.response.eject(timelineInterceptorId);
        timelineInterceptorId = null;
      }
    });
    onMounted(async () => {
      studentData.value = props.dataInitial?.Student||{}
      buildPromotionChild()

      getFreesubject()
       getReceiptStudent(props?.dataInitial?.studentId)
       loadPortalEyeReceipts() // phiếu thu "mắt portal" — nuôi cảnh báo cấp-trước-chờ-điều-kiện
       await axios
        .get("/setting/item")
        .then(({ data }) => {
          dataSettingItem.value = data;
          data.forEach((item) => {
            // if (item.type == "TSHIRT_TROUSERS") {
            //   tshirt_trousers_price.value = item.price;
            // } else if (item.type == "TROUSERS") {
            //   u_trousers_price.value = item.price;
            // }
            if (item.type == "SIBLINGS") {
              freeTuitionDiscount.value = item.price;
              freeTuitionUnit.value = item.unit;
            }
            else if(item.forSelling) {
              let temp = {
                quantity: 0,
                size: item.type != 'CAPS'?'S':'',
                price: item.price,
                name: item.name,
                type: item.type,
                unit: item.unit,
                code: item.code,
                discount: item.discount,
                images: images[item.type]?images[item.type]:[]
              }
              otherFees.value.push(temp)
            }
          });
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      //console.log('test',props.dataInitial)
      axios
        .get(
          `/scholarship/student/?studentid=${props.dataInitial?.studentId}&majorcode=${props.dataInitial?.admissionRegistration.adMajorCode}&programtype=${props.dataInitial?.programtype}`
        )
        .then(({ data }) => {
          if (data.length != 0) {
            data[0].scholarshipPerSemester = data[0].scholarshipValue / data[0].releasedIn; //.toFixed(0)
            data[0]['Scholarship.addition']?.forEach((i: any) => {
              i.isDisabled = !checkPromotionInScholarship(i)
            })
            // Giữ CONDITION thô TRƯỚC gate: gate fail thì dataScholarship=[] làm mất thông tin điều kiện,
            // banner "cấp trước - chờ điều kiện" cần nó để giải thích lý do (2026-07-16)
            dataScholarshipRawCond.value = data[0]['Scholarship.condition'] || null
            if(checkScholarshipForPromotion(data)) {
              dataScholarship.value = data;
            }

          }
          else {
            dataScholarship.value = []
          }
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      await axios
        .get("/res/province")
        .then(({ data }) => {
          dataProvince.value = data;
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      await axios
        .get("/res/newprovince/list")
        .then(({ data }) => { dataNewProvinces.value = data; })
        .catch(({ response }) => { console.log("err", response); });
      await axios
        .get("/province")
        .then(({ data }) => {
          dataProvinceForSchool.value = data;
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      dataReset.value = JSON.parse(JSON.stringify(props.dataInitial));
      // console.log('dataReset.value',dataReset.value)
      idAdReg.value = props.dataInitial?.admissionRegistration?.idAdReg;
      adCode.value = props.dataInitial?.admissionRegistration?.adCode;
      props.dataInitial?.collegesUniversities?.forEach((item, index) => {
        let temp = {
          programName: item.programName,
          programLevel: item.programLevel,
          studyLocation: item.studyLocation,
          from: item.from,
          to: item.to,
          status: item.status,
          awarded: item.awarded,
          id: index,
          ranktime:
            item.from != "" && item.to != ""
              ? [moment(item.from, "DD/MM/YYYY"), moment(item.to, "DD/MM/YYYY")]
              : [],
        };
        tableData.value.push(temp as any);
      });

      admissionRegistration.value = props.dataInitial?.admissionRegistration;
      isSubmitQr.value = props.dataInitial?.certificateBarcode == "";
      certificateBarcode.value = props.dataInitial?.certificateBarcode;
      initFormData();
      initDataPersonalContacts();
      initLearningProcess();
      initEnglishClass();
      initInsuranceReg();
      initUniformRegistration();
      initSupportServices();
      initfreeTuitionRegistration();
      initEvidenceFiles();
      initPayments();
      initFinancialSupport();
      await initPromotion()
      initPromotionAddition()
      initPromotionMulti()
      initOtherFees()
      initHistories()
      axios
        .get(`/setting/financialsupport`)
        .then(({ data }) => {
          data.forEach((item) => {
            if (item.provinceList.length != 0) {
              let index = item.provinceList.findIndex(
                (i) =>
                  i.provinceId == personalContacts.value.permanentProvinceId
              );
              if (index == -1) {
                item.disabled = true;
              }
            }
          });
          dataBank.value = data;
          if (financialSupportRegistration.value.bankName == "") {
            financialSupportRegistration.value.bankName = dataBank.value.filter(
              (item) => !item.disabled
            )[0]?.bankName;
          }
          // console.log('dataBank',dataBank.value)
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      axios
        .get(`/setting/generalsetting?type=payment`)
        .then(({ data }) => {
          if (data.length != 0) {
            data.forEach((item) => {
              item.code =
                item.code == "PAYMENT_ACCOUNTANT_INFO"
                  ? "cash"
                  : item.code == "PAYMENT_BANK_INFO"
                  ? "bank_transfers"
                  : item.code;
            });
            optionBanking.value = data;
          }
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      axios
        .get(
          `/setting/tuition?majorcode=${props.dataInitial?.admissionRegistration.adMajorCode}&programtype=${props.dataInitial?.programtype}`
        )
        .then(({ data }) => {
          let temp = data[0]; //.filter(i=>i.major = dataReset.value.major)
          dataMajor.value = data[0]
          // console.log('dataMajor',dataMajor)
          if (temp) {
            arr_dataTuition.value = (temp.tuitionfee||[]).filter(i => +i.value > 0) // FIX C9: chỉ hiện gói học phí có giá > 0 (tránh chọn gói 0đ)
            dataTuition.value = (temp.tuitionfee||[]).reduce((acc: any, curr: any) => {
              acc[curr.releasedIn] = {
                label: curr.label,
                value: curr.value,
                releasedIn: curr.releasedIn,
              };
              return acc;
            }, {});
            
          }
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      // let day = moment(new Date())
      
      axios
        .get(`/religion`)
        .then(({ data }) => {
          arrReligion.value = data.map((i) => {
            return { value: i.name, label: i.name };
          });
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      axios
        .get(`/ethnic`)
        .then(({ data }) => {
          arrEthnic.value = data.map((i) => {
            return { value: i.name, label: i.name };
          });
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      let temp3 = [];
      tableDataEnglishCer.value = temp3;
      //   setCurrentPageBreadcrumbs("Nhập học trực tuyến", ["Khởi tạo thông tin nhập học"]);
    });
    let idSchool = props.dataInitial?.highschoolId;
    const isregistrationfeerequest = ref<any>(null)
    const dataRegistrationfeerequest = ref<any>(null)
    const dataMajor = ref<any>({})
      
      const dataFindprereceipts = ref<any>([])
    const getReceiptStudent = async(id: string) => {
      let studentcode = props.dataInitial?.studentCode ? `&studentcode=${props.dataInitial?.studentCode}` : ''
      await axios
      .get(`/receipt/?receipttype=pre-receipt,bc-receipt&studentid=${id}${studentcode}`)
      .then(({ data }) => {
        if(data && data.length != 0) {
          data = data.filter((i: any) => i.items && !i.items[0].isreversed)
          dataFindprereceipts.value = JSON.parse(JSON.stringify(data))
          let total = 0 as any
          data.forEach((item: any)=> {
            total += +item.paymentConfirmation?.paid
          })
          let temp = data[0] as any
          if(temp.paymentConfirmation) {
            temp.paymentConfirmation = {
              paid: total
            }
          }
          dataRegistrationfeerequest.value = temp
        }
      })
      .catch(({ response }) => {
        console.log("err", response);
      });
    }
    // console.log('props.dataInitial',props.dataInitial)
    async function getPromotion() {
      axios
      .get(`/setting/promotion/?isactive=true`)
      .then(({ data }) => {
        expiredPromotion.value = false
        dataPromotionChildDb.value = {} // reset trước mỗi lần dựng lại từ catalog
        // console.log('data',data)
        // Giữ catalog THÔ (trước mọi filter) — banner "cấp trước - chờ điều kiện" cần tra ngược
        // CTKM đã lưu trong orderDetails về điều kiện/hạn/appliedType gốc (2026-07-16)
        dataPromotionRawAll.value = data
        // FIX C4: bỏ CT đã hết hạn khỏi danh sách CHỌN MỚI (hồ sơ đã lưu vẫn render qua nhánh loadPromotion/synthetic đọc orderDetails)
        // 2026-07-23: CT bật cờ `bypasscondition` được miễn cả 2 đầu khoảng hiệu lực — chỉ còn isactive quyết định.
        data = data.filter(i => i.bypasscondition || !i.endedDate || +new Date(i.endedDate) >= Date.now())
        // FIX 2026-07-21: lọc nốt đầu CÒN LẠI của khoảng hiệu lực — CT chưa tới ngày bắt đầu vẫn đang lộ ra
        // cho TVV chọn. Đối xứng với lọc hết hạn; dataPromotionRawAll ở trên vẫn giữ catalog THÔ để tra ngược.
        data = data.filter(i => i.bypasscondition || !i.startedDate || +new Date(i.startedDate) <= Date.now())
        let special = [] as any

        dataPromotion.value = data.filter((item) => {
          if(item.condition) {
            let arr = ['islecturerchild','isstaffchild', 'ispartnerchild']
            let specialApplied = item.condition.specialApplied ? item.condition.specialApplied[0]:''
            if(arr.includes(specialApplied)) {
              special.push(item)
              const _hasFlag = studentData.value?.[specialApplied]
              const _pct = +(item.benefit?.find(b=>b.type=='percent')?.value ?? 0)
              if(!_hasFlag) {
                item.isHidden = true // SV KHÔNG thuộc đối tượng -> ẩn (fix leak: trước đây admin hiện CT đặc biệt cho MỌI SV)
              } else if(_pct > 0) {
                // Đúng đối tượng + flat-% -> card vipPro. Ẩn khỏi multi để không double.
                dataPromotionChildDb.value[specialApplied] = { name: item.promotionName, percent: _pct, value: "", enddate: item.endedDate, code: item.promotionCode, type: 'percent' }
                item.isHidden = true
              }
              // else: đúng đối tượng + per-semester/amount (con đối tác 1.8tr/HK) -> GIỮ ở dataPromotionSpecial (multi card)
            }
          }
          let schoolId = item.appliedObject.filter((i) => i.type == "SCHOOLID");
          if (schoolId.length != 0) {
            if (schoolId[0].value.length == 0) {
              // return true;
            } else if (schoolId[0].value.includes(idSchool)) {
              // console.log('idSchool',idSchool)
              special.push(item)
              // return true;
            } else {
              return false
            }
          }
          let majorId = item.appliedObject.filter((i) => i.type == "MAJORID");
          if (majorId.length != 0) {
            if (majorId[0].value.length == 0) {
              // return true;
            } else if (majorId[0].value.includes(props.dataInitial?.admissionRegistration.adMajorCode)) {
              return true;
            } else {
              return false
            }
          }
          let studentId = item.appliedObject.filter((i) => i.type == "STUDENTID");
          if (studentId.length != 0) {
            if (studentId[0].value.length == 0) {
              // return true;
            } else if (studentId[0].value.includes(props?.dataInitial?.studentId)) {
              return true;
            } else {
              return false
            }
          }
          return true
        });
        dataPromotionManual.value = dataPromotion.value.filter((item: any) => item.ismanual)
        dataPromotionSpecial.value = special.filter(i=> !i.isHidden) // đồng bộ portal: đối tượng đặc biệt không hiện ở đây (đã vào promotionChild)
        let ids = special.map((i: any) => i.id)
        // console.log('ids',ids)
        dataPromotion.value = dataPromotion.value.filter((item:any)=>!ids.includes(item.id) && !item.ismanual && (!item.programtype || (item.programtype == props.dataInitial?.programtype)) )
        if(dataScholarship.value.length != 0) {
          dataPromotion.value = dataPromotion.value.filter((item:any)=> !item.condition?.isExclScholarship)
        }
        buildPromotionChild() // dựng card "Ưu đãi đặc biệt" (DB ưu tiên, fallback hardcode)
        // console.log('dataPromotion_getPromotion',dataPromotion.value)
        // console.log('dataPromotionSpecial_getPromotion',dataPromotionSpecial.value)
        // console.log('dataPromotionManual_getPromotion',dataPromotionManual.value)
      })
      .catch(({ response }) => {
        console.log("err", response);
      });
    }
    function loadPromotion() {
      // console.log('loadPromotion')
      let arrBenefit:any = []
      let promotionsvip = null as any
      if(orderDetails.value.otherPromotionsVip && orderDetails.value.otherPromotionsVip.value) {
        promotionsvip = JSON.parse(JSON.stringify(orderDetails.value.otherPromotionsVip));
      }
      if(orderDetails.value.otherPromotions?.length!=0) {
        arrBenefit = JSON.parse(JSON.stringify(orderDetails.value.otherPromotions));
      }
      let promotion = {
          "name": orderDetails.value.promotion.name,
          "type": orderDetails.value.promotion.type,
          "value": orderDetails.value.promotion.value,
          "allowMultiPromotions": false,
      }
      arrBenefit.unshift(promotion)
      dataPromotion.value = [
        {
          "id": orderDetails.value.promotion.id,
          "promotionName": orderDetails.value.promotion.promotionName,
          "promotionCode": orderDetails.value.promotion.promotionCode,
          "appliedType": tuitionRegistration.value.name,
          "endedDate": orderDetails.value.promotion.endedDate,
          "benefit": arrBenefit,
          "description": "",
          addition: promotionsvip?[promotionsvip]: null,
        }
      ]
    }
    function initHistories() {
      let data = JSON.parse(JSON.stringify(dataReset.value));
      dataHistories.value = data.histories||[]
    }
    function initOtherFees() {
      let data = JSON.parse(JSON.stringify(dataReset.value));
      if(data.otherFees && data.otherFees.length != 0 ) {
        otherFees.value.forEach(item => {
          item.quantity = 0
          item.size = item.type != 'CAPS'?'S':'',
          item.total = 0
          let index = data.otherFees.findIndex(i=>i.type == item.type)
          if(index >-1) {
            item.quantity = data.otherFees[index].quantity
            item.size = data.otherFees[index].size
            item.price = data.otherFees[index].price
            item.total = data.otherFees[index].total
          }
        })
        // if(props.dataReceipt) {
        //   otherFees.value = data.otherFees
        // }
      }
    }
    const updatePromotion = ref(false)
    async function initPromotion() {
      // console.log('aaaaaaaaaaaaaaaaaaa')
      // console.log('dataScholarship.value.length',dataScholarship.value.length)
      // if(dataScholarship.value.length != 0) { 
      //   return
      // }
      await getPromotion()
      // return
      if(orderDetails.value.otherPromotionsVipPro.code) {
        // console.log('bbbbbbb')
        await getPromotion()
        return
      }
      let endedDate = orderDetails.value.promotion.endedDate as any
      if(!endedDate && orderDetails.value.otherPromotions?.length!=0) {
        let temp = orderDetails.value.otherPromotions as any
        endedDate = temp[0].endedDate as any
      }
      let rankdate = new Date(endedDate) as any
      if(props.dataReceipt && props.dataReceipt.locked) {
        if((orderDetails.value.promotion && orderDetails.value.promotion.value == '') ) {// không có chương trình khuyến mãi
          // expiredPromotion.value = true // kiểm tra cập chật ctkm
          return
        }
        // console.log('dataReceipt',props.dataReceipt)
        let issuedDateReceipt = new Date(props.dataReceipt.issuedDate) as any
        let times = +issuedDateReceipt - +rankdate
        if(isNaN(times) || times > 0) { //ctkm hết hạn so với sv chuyển khoản đóng tiền
          // expiredPromotion.value = true
          if(props.dataReceipt.paymentMethod == 'bank_transfers') {
            updatePromotion.value = true
          }
        }
        // if(dataPromotionListen.value?.promotionCode != orderDetails.value.promotion?.promotionCode) {
        //   expiredPromotion.value = true
        // }
        loadPromotion()
      }
      else if((orderDetails.value && orderDetails.value.promotion?.value && orderDetails.value.promotion.value!='') || orderDetails.value.otherPromotions?.length!=0) {
        let day = new Date() as any
        let times = +rankdate - +day
        
        if( times >= 0) { 
          //ctkm hiện hữu
          // console.log('aaaaaaaaaaaaaaaaaaaa')
          await getPromotion() // load lại ctkm cho các phương thức chọn học phí
        }
        else {
          // expiredPromotion.value = true //ctmk hết hạn
          loadPromotion() // load ctkm đã chọn
        }
      }
      else if(tuitionRegistration.value.name != '' ) { // không có ctkm
        // expiredPromotion.value = true // kiểm tra cập chật ctkm
      }
      else { //first load
        await getPromotion()
      }
      if(orderDetails.value.promotion.type!='gift' && orderDetails.value.promotion.amount) {
        moneyPromotion.value = +orderDetails.value.promotion.amount
      }
      // if(dataPromotionListen.value?.promotionCode != orderDetails.value.promotion?.promotionCode) {
      //   expiredPromotion.value = true
      //   loadPromotion()
      // }
    }
    function initPromotionMulti() {
      if( (orderDetails.value && orderDetails.value.promotionMulti && orderDetails.value.promotionMulti.length != 0)) {
        promotionMultiData.value = orderDetails.value.promotionMulti
        let isCallPromotion = false
        dataPromotionSpecial.value = orderDetails.value.promotionMulti.map(i=>{
          let day = new Date() as any
          let rankdate = new Date(i.endedDate) as any
          let times = +rankdate - +day
          if( times >= 0 && !isCallPromotion) {
            isCallPromotion = true
            getPromotion()
          }
          return {
            "id": i.id,
            "promotionName": i.name,
            "promotionCode": i.promotionCode,
            "appliedType": tuitionRegistration.value.name,
            "endedDate": i.endedDate,
            "benefit": [i],
            "description": "",
            addition: null,
          }
        })
      }
    }
    function initPromotionAddition() {
      if( (orderDetails.value && orderDetails.value.promotionAddition && orderDetails.value.promotionAddition.value && orderDetails.value.promotionAddition.value!='')) {
        let endedDate = orderDetails.value.promotionAddition.endedDate as any
        if(!endedDate && orderDetails.value.otherPromotions?.length!=0) {
          let temp = orderDetails.value.otherPromotions as any
          endedDate = temp[0].endedDate as any
        }
        let day = new Date() as any
        let rankdate = new Date(endedDate) as any
        let times = +rankdate - +day
        // FIX C2 (twin portal): endedDate rỗng/hỏng -> NaN -> rơi nhầm nhánh dựng-lại; coi thiếu/hỏng = còn hạn, refetch catalog
        let validEnded = endedDate && !isNaN(+rankdate)
        if( !validEnded || times >= 0) {//promotionAddition
          getPromotion()
        }
        else {
          // console.log('aaaaaaaaaaaaaaaaaaaaaaa')
          // expiredPromotion.value = true
          let arrBenefit:any = []
          let promotionsvip = null as any
         
          let promotionAddition = {
              "name": orderDetails.value.promotionAddition.name,
              "semester": orderDetails.value.promotionAddition.semester,
              "type": orderDetails.value.promotionAddition.type,
              "value": orderDetails.value.promotionAddition.value,
          }
          arrBenefit.unshift(promotionAddition)
          // console.log('arrBenefit',arrBenefit)
          if(dataPromotion.value.length != 0) {
            // FIX C1 (twin portal): phải là MẢNG như nhánh else dưới; object trần làm dataPromotionListenAddition .filter throw -> computed đóng băng
            dataPromotion.value[0].benefitaddition = [promotionAddition]
            dataPromotion.value[0].benefit = []
          }
          else {
            dataPromotion.value = [
              {
                "id": orderDetails.value.promotion.id,
                "promotionName": orderDetails.value.promotion.promotionName,
                "promotionCode": orderDetails.value.promotion.promotionCode,
                "appliedType": tuitionRegistration.value.name,
                "endedDate": orderDetails.value.promotion.endedDate,
                "benefit": [],
                "benefitaddition": [promotionAddition],
                "description": "",
                addition: promotionsvip?[promotionsvip]: null,
              }
            ]
          }
          
        }
      }
      // else if(!props.isCompleted && tuitionRegistration.value.name != '') { // không có ctkm
      //   expiredPromotion.value = true // kiểm tra cập chật ctkm
      // }
      // else if(!props.isCompleted) { //first load
      //   getPromotion()
      // }
      
      if(orderDetails.value.promotionAddition && orderDetails.value.promotionAddition.amount) {
        moneyPromotionAddition.value = +orderDetails.value.promotionAddition.amount
      }
    }
    // const promotionExtend = ref<any>([])
    function initFinancialSupport() {
      let data = JSON.parse(JSON.stringify(dataReset.value));
      if (data.financialSupportRegistration) {
        financialSupportRegistration.value = data.financialSupportRegistration;
        if (financialSupportRegistration.value.isFinancialSupport) {
          financialSupportNo.value = false;
        }
      }
    }
    const scholarshipDefault = ref<any>({})
    const loadCourseexemptions = ref<any>({})
    const loadReduceEnglish = ref<any>(null)
      
    function resetFreeTuitionReg() {
      freeTuitionRegistration.value.registrationTypeSiblings = false
      dataScholarshipPro.value.scholarship = false
      dataScholarshipPro.value.promotion = null
      dataScholarshipPro.value.promotionExtend = []
      
      loadCourseexemptions.value.exemptions = []
      loadCourseexemptions.value.nextLevel = []
      chooseCourses.value.courseexemptions = []
      chooseCourses.value.courseNextLevel = []
      orderDetails.value.otherPromotionsVip = {}
      orderDetails.value.otherPromotionsVipPro = {}
      moneyPromotionVipPro.value = 0
      loadReduceEnglish.value = null

    }
    function initfreeTuitionRegistration(isCallInit?: any) {
      isErrorFormFreeTuitionReg.value = false;
      let data = JSON.parse(JSON.stringify(dataReset.value));
      // FIX Hủy học phí: dọn các ref HIỂN THỊ đã bị sửa nhưng không có trong dữ liệu đã lưu
      // (nếu không, dòng ưu đãi bị kẹt: hiện ưu đãi thừa / số tiền = 0 khi bấm Hủy).
      // Chỉ reset phần hiển thị rồi để computed tính lại (firstLoad=false ở cuối) — KHÔNG đổi công thức tính tiền.
      if (isCallInit) {
        resetFreeTuitionReg();
        tempDataPromotion.value = null;
        tempDataPromotionAddition.value = null;
        promotionMultiData.value = [];
        scholarshipPromotionMultiData.value = [];
      }

      if (data.orderDetails && data.orderDetails.promotion) {
        orderDetails.value.promotion = data.orderDetails.promotion;
      } else {
        orderDetails.value.promotion.value = "";
      }
      if (data.orderDetails && data.orderDetails.promotionAddition) {
        orderDetails.value.promotionAddition = data.orderDetails.promotionAddition;
      } else {
        orderDetails.value.promotionAddition.value = "";
      }
      if (data.orderDetails && data.orderDetails.promotionMulti) {
        orderDetails.value.promotionMulti = data.orderDetails.promotionMulti;
      } else {
        orderDetails.value.promotionMulti.value = [];
      }
      if (data.orderDetails && data.orderDetails.otherPromotions && data.orderDetails.otherPromotions.length !=0) {
        orderDetails.value.otherPromotions = data.orderDetails.otherPromotions;
      }
      else {
        orderDetails.value.otherPromotions = []
      }
      if (data.tuitionRegistration) {
        tuitionRegistration.value = data.tuitionRegistration;
      } else {
        tuitionRegistration.value.name = "";
      }
      if (data.freeTuitionRegistration && data.freeTuitionRegistration.length !=0) {
        resetFreeTuitionReg()

        data.freeTuitionRegistration.forEach((item) => {
          if (item.registrationType == "siblings") {
            freeTuitionRegistration.value.registrationTypeSiblings = true;
            freeTuitionRegistration.value.siblings.studentId =
              item.siblings.studentId;
            freeTuitionRegistration.value.siblings.fullName =
              item.siblings.fullName;
              moneySiblings.value = item.siblings.amount
          }
          else if(item.registrationType == "scholarships") {
            firstLoad.value = true
            scholarshipDefault.value = item.scholarships
            dataScholarshipPro.value.scholarship = true
            discountScholarship.value = item.scholarships.discount
          }
          else if(item.registrationType == "promotion") {
            firstLoad.value = true
            dataScholarshipPro.value.promotion = item.promotion
          }
          else if(item.registrationType == "promotionExtend") {
            firstLoad.value = true
            dataScholarshipPro.value.promotionExtend = item.promotionExtend
          }
          else if(item.registrationType == "scholarshipPromotionMultiData") {
            firstLoad.value = true
            scholarshipPromotionMultiData.value = item.scholarshipPromotionMultiData
          }
          
          else if(item.registrationType == 'reduceEnglish') {
            firstLoad.value = true
            loadReduceEnglish.value = item.reduceEnglish
          }
          else if(item.registrationType == "courseexemptions") {
            firstLoad.value = true
            loadCourseexemptions.value.exemptions = item.courseexemptions||[]
            loadCourseexemptions.value.nextLevel = item.coursenextLevel||[]
            if(englishClassPlacementTest.value.registrationType == "umt_test") {
              chooseCourses.value.courseexemptions = item.courseexemptions||[]
              chooseCourses.value.courseNextLevel = item.coursenextLevel||[]
              // let code = 'l1'
              // if(item.courseexemptions && item.courseexemptions.length !=0) {
              //   code = item.courseexemptions[0].parentCode
              // }
              // console.log('code',code)
              // console.log('item.courseExemptions',item)
              // chooseCourses.value.code = code
            } 
            
          }
          else if ( item.registrationType == "chooseenglish") {
              chooseCourses.value.code = item.value
          }
          else if(item.registrationType == "promotionvip") {
            firstLoad.value = true
            orderDetails.value.otherPromotionsVip = item.promotionvip||{}
          }
          else if(item.registrationType == "promotionvippro") {
            firstLoad.value = true
            orderDetails.value.otherPromotionsVipPro = item.promotionvippro||{}
            scholarshipDefault.value = item.promotionvippro||{}
            moneyPromotionVipPro.value = item.promotionvippro.value
          }
          
          else {
            freeTuitionRegistration.value.registrationTypeSiblings = false;
            freeTuitionRegistration.value.siblings.studentId = "";
            freeTuitionRegistration.value.siblings.fullName = "";
          }
        });
      } else {
        freeTuitionRegistration.value.registrationTypeSiblings = false;
        freeTuitionRegistration.value.siblings.studentId = "";
        freeTuitionRegistration.value.siblings.fullName = "";
      }
      if(isCallInit) {
        // dựng lại HIỂN THỊ ưu đãi từ orderDetails đã revert — mirror đúng chuỗi load (initPromotion + Addition + Multi)
        // để ưu đãi bị GỠ lúc sửa được phục hồi khi Hủy
        initPromotion()
        initPromotionAddition()
        initPromotionMulti()
        // ép computed tính lại số tiền TỪNG DÒNG từ dữ liệu đã revert (các gán moneyX bị chặn bởi firstLoad)
        firstLoad.value = false;
      }
    }
    async function initEvidenceFiles() {
      let data = JSON.parse(JSON.stringify(dataReset.value));
      if (data.evidenceFiles) {
        await axios
          .get(`/admission/file/${adCode.value}`)
          .then(({ data }) => {
            tableDataImg.value = data as any;
          })
          .catch(({ response }) => {
            console.log("err", response);
          });
      }
    }
    function initSupportServices() {
      let data = JSON.parse(JSON.stringify(dataReset.value));
      if (data.supportServices) {
        supportServices.value = data.supportServices;
        supportServices.value.forEach((item, index) => {
          if (item.indexOf("other") != -1) {
            supportServicesOther.value = item.split("|")[1];
            supportServices.value[index] = item.split("|")[0];
          }
        });
      }
    }
    function initUniformRegistration() {
      isErrorFormUniformReg.value = false;
      let data = JSON.parse(JSON.stringify(dataReset.value));
      // console.log('data',data)
      if (data.uniformRegistration) {
        uniformRegistration.value = data.uniformRegistration;
        // if (!uniformRegistration.value.purchaseQuality) {
        //   uniformRegistration.value.purchaseQuality = 0;
        // }
        // if(!uniformRegistration.value.defaultSize) {
        //   uniformRegistration.value.defaultSize = "M"
        // }
        // if(!uniformRegistration.value.purchaseSize) {
        //   uniformRegistration.value.purchaseSize = "M"
        // }
      }
    }
    function initEnglishClass() {
      let data = JSON.parse(JSON.stringify(dataReset.value));
      if (data.englishClassPlacementTestRegistration) {
        englishClassPlacementTest.value.registrationType =
          data.englishClassPlacementTestRegistration.registrationType;
        if (
          englishClassPlacementTest.value.registrationType ==
          "english_certificate" || englishClassPlacementTest.value.registrationType ==
          "english_thpt"
        ) {
          let tempenglishCertificate = {
            certificateName: "",
            examDate: "",
            expiredDate: "",
            score: "",
            
          }
          if(data.englishClassPlacementTestRegistration.englishCertificate) {
            tempenglishCertificate = data.englishClassPlacementTestRegistration.englishCertificate
          }
          englishClassPlacementTest.value.englishCertificate = tempenglishCertificate;
          
        }
        else if (
          englishClassPlacementTest.value.registrationType == "umt_test") {
          englishClassPlacementTest.value.testdate = data.englishClassPlacementTestRegistration.testdate;
          let tempenglishCertificate = {
            certificateName: "",
            examDate: "",
            expiredDate: "",
            score: "",
            
          }
          if(data.englishClassPlacementTestRegistration.englishCertificate) {
            tempenglishCertificate = data.englishClassPlacementTestRegistration.englishCertificate
          }
          englishClassPlacementTest.value.englishCertificate = tempenglishCertificate;
          
        }
      }
    }
    function initInsuranceReg() {
      let data = JSON.parse(JSON.stringify(dataReset.value));
      accidentInsuranceRegistration.value =
        data.accidentInsuranceRegistration?.type == "accident";
      if (data.socialHealthcareInsuranceRegistration) {
        socialHealthcareInsuranceRegistration.value =
          data.socialHealthcareInsuranceRegistration;
      }
      // if(socialHealthcareInsuranceRegistration.value.code && socialHealthcareInsuranceRegistration.value.code != '') {
      //   isHealthInsurance.value = '1'
      // }
      // else if(socialHealthcareInsuranceRegistration.value.type == 'other') {
      //   isHealthInsurance.value = '-1'
      // }
      // else {
      //   isHealthInsurance.value = '0'
      // }
    }
    async function initLearningProcess() {
      let data = JSON.parse(JSON.stringify(dataReset.value));
      learningProcess.value.highschoolProvinceId = data.highschoolProvinceId;
      await highschoolProvinceChange(
        learningProcess.value.highschoolProvinceId
      );
      // Trường đã nạp theo cả tỉnh -> set thẳng id huyện + trường đã lưu (không lọc lại theo huyện)
      learningProcess.value.highschoolDistrictId = data.highschoolDistrictId;
      learningProcess.value.highschoolId = data.highschoolId;
      learningProcess.value.certificateNumber = data.certificateNumber;
      learningProcess.value.yearOfGraduation = data.yearOfGraduation;
      learningProcess.value.highschoolName = data.highschoolName;
      learningProcess.value.highschoolProvince = data.highschoolProvince;
      learningProcess.value.highschoolDistrict = data.highschoolDistrict;
    }
    function initFormData() {
      isErrorFormProfileDetails.value = false;
      let data = JSON.parse(JSON.stringify(dataReset.value));
      formData.value.dateOfBirth = data.dateOfBirth;
      formData.value.placeOfBirth = data.placeOfBirth;
      formData.value.enrolledUmt = data.enrolledUmt;
      formData.value.ethnic = data.ethnic;
      formData.value.familyName = data.familyName.toLowerCase();
      formData.value.gender = data.gender;
      formData.value.givenName = data.givenName.toLowerCase();
      formData.value.idNumber = data.idNumber;
      formData.value.issuedBy = data.issuedBy;
      formData.value.issuedDate = data.issuedDate;
      formData.value.middleName = data.middleName.toLowerCase();
      formData.value.nationality = data.nationality;
      formData.value.religion = data.religion;
      formData.value.avatar = data.avatar;
      formData.value.programtype = data.programtype
      if (formData.value.enrolledUmt) {
        isUmter.value = true;
      }
    }
    // Khôi phục thông tin Đoàn/Đảng về giá trị đã lưu (dùng khi Hủy/đóng drawer không lưu)
    function initMoreinfo() {
      let data = JSON.parse(JSON.stringify(dataReset.value));
      moreinfo.value = data && data.moreinfo ? data.moreinfo : {};
    }
    async function _mapOldWardToNewCode(oldWardId: any, provCode: any) {
      if (oldWardId === null || oldWardId === undefined || oldWardId === "") return "";
      try {
        const { data } = await axios.get(`/res/ward/${oldWardId}`);
        const code = data && data.newWardCode;
        if (code === null || code === undefined) return "";
        const exists = newWardsOf(provCode).some((w: any) => String(w.id) === String(code));
        return exists ? String(code) : "";
      } catch (e) { return ""; }
    }
    async function _initNewAddress(kind: string, data: any) {
      const isPerm = kind === "permanent";
      const provField = isPerm ? "newPermanentProvinceCode" : "newPostalProvinceCode";
      const wardField = isPerm ? "newPermanentWardCode" : "newPostalWardCode";
      const savedProv = isPerm ? data.newPermanentProvinceCode : data.newPostalProvinceCode;
      const savedWard = isPerm ? data.newPermanentWardCode : data.newPostalWardCode;
      const oldProvId = isPerm ? data.permanentProvinceId : data.postalProvinceId;
      const oldWardId = isPerm ? data.permanentWardId : data.postalWardId;
      const setWards = (arr: any) => { if (isPerm) dataWard.value = arr; else dataPostalWard.value = arr; };
      let provCode = "";
      let wardCode = "";
      if (savedProv !== null && savedProv !== undefined && savedProv !== "") {
        provCode = String(savedProv);
        wardCode = (savedWard !== null && savedWard !== undefined && savedWard !== "") ? String(savedWard) : "";
      } else if (oldProvId !== null && oldProvId !== undefined && oldProvId !== "") {
        const oldProv = dataProvince.value.find((p: any) => String(p.id) === String(oldProvId));
        if (oldProv && oldProv.newProvinceCode !== null && oldProv.newProvinceCode !== undefined) {
          provCode = String(oldProv.newProvinceCode);
          wardCode = await _mapOldWardToNewCode(oldWardId, provCode);
        }
      }
      (personalContacts.value as any)[provField] = provCode;
      setWards(newWardsOf(provCode));
      (personalContacts.value as any)[wardField] = wardCode;
    }
    async function initDataPersonalContacts() {
      isErrorFormPersonalContacts.value = false;
      let data = JSON.parse(JSON.stringify(dataReset.value));
      personalContacts.value.permanentAddress = data.permanentAddress;
      personalContacts.value.permanentProvince = data.permanentProvince;
      personalContacts.value.permanentWard = data.permanentWard;
      personalContacts.value.permanentDistrict = data.permanentDistrict;
      personalContacts.value.permanentProvinceId = data.permanentProvinceId;
      personalContacts.value.permanentDistrictId = data.permanentDistrictId;
      personalContacts.value.permanentWardId = data.permanentWardId;
      personalContacts.value.postalAddress = data.postalAddress;
      personalContacts.value.postalProvince = data.postalProvince;
      personalContacts.value.postalWard = data.postalWard;
      personalContacts.value.postalDistrict = data.postalDistrict;
      personalContacts.value.postalProvinceId = data.postalProvinceId;
      personalContacts.value.postalDistrictId = data.postalDistrictId;
      personalContacts.value.postalWardId = data.postalWardId;
      await _initNewAddress("permanent", data);
      await _initNewAddress("postal", data);
      personalContacts.value.contactEmail = data.contactEmail;
      personalContacts.value.contactMobile = data.contactMobile;
      let arrTempReleaseOfStudy = data.notificationRegistration
        ? data.notificationRegistration.agreeToReleaseOfStudyProgress.split("|")
        : [];
      let arrTempContactInEmergency = data.notificationRegistration
        ? data.notificationRegistration.agreeToContactInEmergency.split("|")
        : [];
      noneNotifiOfReg.value = arrTempReleaseOfStudy.includes("none");
      data.personalContacts?.forEach((item) => {
        if (item.relationship == "father") {
          personalContacts.value.father.agreeToContactInEmergency =
            arrTempContactInEmergency.includes(item.relationship);
          personalContacts.value.father.agreeToReleaseOfStudyProgress =
            arrTempReleaseOfStudy.includes(item.relationship);
          personalContacts.value.father.currentAddress = item.currentAddress;
          personalContacts.value.father.dateOfBirth = item.dateOfBirth;
          personalContacts.value.father.email = item.email;
          personalContacts.value.father.fullName = item.fullName;
          personalContacts.value.father.mobile = item.mobile;
          personalContacts.value.father.occupation = item.occupation;
        }
        if (item.relationship == "mother") {
          personalContacts.value.mother.agreeToContactInEmergency =
            arrTempContactInEmergency.includes(item.relationship);
          personalContacts.value.mother.agreeToReleaseOfStudyProgress =
            arrTempReleaseOfStudy.includes(item.relationship);
          personalContacts.value.mother.currentAddress = item.currentAddress;
          personalContacts.value.mother.dateOfBirth = item.dateOfBirth;
          personalContacts.value.mother.email = item.email;
          personalContacts.value.mother.fullName = item.fullName;
          personalContacts.value.mother.mobile = item.mobile;
          personalContacts.value.mother.occupation = item.occupation;
        }
        if (item.relationship == "guardian") {
          personalContacts.value.guardian.agreeToContactInEmergency =
            arrTempContactInEmergency.includes(item.relationship);
          personalContacts.value.guardian.agreeToReleaseOfStudyProgress =
            arrTempReleaseOfStudy.includes(item.relationship);
          personalContacts.value.guardian.currentAddress = item.currentAddress;
          personalContacts.value.guardian.dateOfBirth = item.dateOfBirth;
          personalContacts.value.guardian.email = item.email;
          personalContacts.value.guardian.fullName = item.fullName;
          personalContacts.value.guardian.mobile = item.mobile;
          personalContacts.value.guardian.occupation = item.occupation;
        }
      });
      // console.log('personalContacts',personalContacts)
    }
    function initPayments() {
      let data = JSON.parse(JSON.stringify(dataReset.value));
      if (data.orderDetails) {
        orderDetails.value.paymentMethod = data.orderDetails.paymentMethod;
        if(data.orderDetails.promotion) {
          orderDetails.value.promotion = data.orderDetails.promotion
        }
        else {
          orderDetails.value.promotion.value = ''
        }
        if (data.orderDetails.otherPromotions && data.orderDetails.otherPromotions.length !=0) {
          orderDetails.value.otherPromotions = data.orderDetails.otherPromotions;
        }
        else {
          orderDetails.value.otherPromotions = []
        }
      }
    }
    const isMobile = ref(false);
    function checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) &&
        window.screen.width < 980
      ) {
        return true;
      } else {
        return false;
      }
    }
    window.addEventListener("resize", () => {
      isMobile.value = checkMobile();
    });
    isMobile.value = checkMobile();
    const isInsurance = ref(false)
    const isUniform = ref(false)
    //Số thứ tự section ĐỘNG: card Bảo hiểm/Đồng phục ẩn theo cấu hình (isInsurance/isUniform)
    //nên số phải trượt theo section đang hiển thị, tránh nhảy 7 -> 10
    const sectionNo = computed(() => {
      const keys = [
        "personal", "party", "contact", "relatives", "learning", "service", "english",
        ...(isInsurance.value ? ["insurance"] : []),
        ...(isUniform.value ? ["uniform"] : []),
        "tuition", "payment", "finsupport",
      ];
      const map: any = {};
      keys.forEach((k, i) => { map[k] = i + 1; });
      return map;
    });
    // Trạng thái "đã điền" từng mục (badge Đã điền/Chưa điền, đồng bộ portal). CHỈ ĐỌC state, không đụng logic tiền.
    const isPersonalFilled = computed(() => !!(formData.value.idNumber && formData.value.familyName && formData.value.givenName && formData.value.dateOfBirth));
    const isContactFilled = computed(() => !!(personalContacts.value.permanentAddress && personalContacts.value.newPermanentProvinceCode && personalContacts.value.contactMobile));
    const isLearningFilled = computed(() => !!((learningProcess.value.highschoolId || learningProcess.value.highschoolName) && learningProcess.value.yearOfGraduation));
    // Hồ sơ LIÊN THÔNG (idAdMethod=9): bằng Trung cấp/Cao đẳng lấy từ hồ sơ xét tuyển (backend gắn articulationprogram vào GET /applicant/:id),
    // chỉ hiển thị read-only ở mục Quá trình học tập; muốn sửa phải mở hồ sơ xét tuyển liên thông. Snapshot cũ chỉ có tên adMethod → fallback regex.
    const isArticulation = computed(() => {
      const _adreg: any = props.dataInitial?.admissionRegistration || {};
      if (_adreg.idAdMethod !== undefined && _adreg.idAdMethod !== null) {
        return Number(_adreg.idAdMethod) === 9;
      }
      return /li[êe]n th[ôo]ng/i.test(String(_adreg.adMethod || ""));
    });
    const arproView = computed(() => (props.dataInitial as any)?.articulationprogram || null);
    // ===== Bằng TC/CĐ dùng RIÊNG cho nhập học (cơ chế "2 bản", CHỈ admin sửa) =====
    // Bản gốc articulationprogram (hồ sơ xét tuyển LT) đã khóa sau trúng tuyển -> sửa ở đây,
    // đối chiếu lệch với bản gốc + cho "Ghi đè từ hồ sơ LT". KHÔNG đụng articulationprograms gốc.
    const _arproClone = (o: any) => (o ? JSON.parse(JSON.stringify(o)) : {});
    const arproEnrollment = ref<any>(_arproClone((props.dataInitial as any)?.articulationEnrollment || (props.dataInitial as any)?.articulationprogram));
    const arproEdit = ref<any>(_arproClone(arproEnrollment.value));
    const editArpro = ref(false);
    const arproSaving = ref(false);
    const arproSysLabel = (v: any) => (({ trungcap: 'Trung cấp', caodang: 'Cao đẳng' } as any)[v] || v || '—');
    const arproFormLabel = (v: any) => (({ chinhquy: 'Chính quy', nghe: 'Nghề' } as any)[v] || v || '—');
    const arproScaleLabel = (v: any) => (({ gpa4: 'thang 4', gpa10: 'thang 10' } as any)[v] || v);
    const ARPRO_CMP: [string, string][] = [
      ['graduationschool', 'Trường tốt nghiệp'], ['graduationsys', 'Hệ đào tạo'], ['trainingform', 'Hình thức'],
      ['gpa', 'Điểm TB'], ['gpafor', 'Thang điểm'], ['graduationnumber', 'Số hiệu bằng'],
      ['graduationentrynumber', 'Số vào sổ'], ['graduationyear', 'Năm tốt nghiệp'], ['graduationday', 'Ngày cấp bằng'],
    ];
    const arproHasData = computed(() => {
      const o = arproEnrollment.value || {};
      return ARPRO_CMP.some(([k]) => o[k] !== undefined && o[k] !== null && String(o[k]).trim() !== '');
    });
    // Danh sách field lệch giữa bản nhập-học và bản gốc (chỉ so khi có bản gốc để đối chiếu).
    const arproMismatch = computed(() => {
      const src = arproView.value; const loc = arproEnrollment.value;
      if (!src || !loc) return [] as string[];
      return ARPRO_CMP.filter(([k]) => String((src as any)[k] ?? '') !== String((loc as any)[k] ?? '')).map(([, label]) => label);
    });
    const openEditArpro = () => {
      const c = _arproClone(arproEnrollment.value);
      if (!c.intermediate || typeof c.intermediate !== 'object') c.intermediate = {}; // bind an toàn field trường TC nguồn
      arproEdit.value = c;
      editArpro.value = true;
    };
    const saveArpro = async () => {
      if (arproSaving.value) return;
      arproSaving.value = true;
      try {
        const payload = _arproClone(arproEdit.value);
        await axios.put(`/applicant/articulation-enrollment/${id.value}`, { articulationEnrollment: payload, editReason: finalEditMode.value ? finalEditReason.value : undefined });
        arproEnrollment.value = payload;
        editArpro.value = false;
        Swal.fire({ icon: 'success', title: 'Đã lưu bằng Trung cấp/Cao đẳng (nhập học)', timer: 1500, showConfirmButton: false });
      } catch (e: any) {
        Swal.fire({ icon: 'error', title: 'Lưu thất bại', text: (e && e.message) || '' });
      } finally { arproSaving.value = false; }
    };
    const overwriteArproFromSource = async () => {
      if (!arproView.value || arproSaving.value) return;
      const ok = await Swal.fire({ icon: 'warning', title: 'Ghi đè từ hồ sơ xét tuyển LT?', text: 'Bản bằng TC/CĐ nhập học sẽ được thay bằng dữ liệu hồ sơ xét tuyển liên thông gốc.', showCancelButton: true, confirmButtonText: 'Ghi đè', cancelButtonText: 'Hủy' });
      if (!ok.isConfirmed) return;
      const src = _arproClone(arproView.value);
      arproSaving.value = true;
      try {
        await axios.put(`/applicant/articulation-enrollment/${id.value}`, { articulationEnrollment: src, editReason: finalEditMode.value ? finalEditReason.value : undefined });
        arproEnrollment.value = src;
        Swal.fire({ icon: 'success', title: 'Đã ghi đè từ hồ sơ xét tuyển LT', timer: 1500, showConfirmButton: false });
      } catch (e: any) {
        Swal.fire({ icon: 'error', title: 'Ghi đè thất bại', text: (e && e.message) || '' });
      } finally { arproSaving.value = false; }
    };
    // Chiều NGƯỢC: ghi bản nhập học SANG hồ sơ xét tuyển LT gốc (articulationprograms).
    const pushArproToSource = async () => {
      if (!arproView.value || arproSaving.value) return;
      const ok = await Swal.fire({ icon: 'warning', title: 'Ghi sang hồ sơ xét tuyển LT?', text: 'Dữ liệu bằng TC/CĐ của hồ sơ xét tuyển liên thông GỐC sẽ bị thay bằng bản nhập học.', showCancelButton: true, confirmButtonText: 'Ghi đè', cancelButtonText: 'Hủy' });
      if (!ok.isConfirmed) return;
      arproSaving.value = true;
      try {
        await axios.put(`/applicant/articulation-enrollment/${id.value}/push`);
        (props.dataInitial as any).articulationprogram = _arproClone(arproEnrollment.value); // bản gốc giờ == bản nhập học -> hết lệch
        Swal.fire({ icon: 'success', title: 'Đã ghi sang hồ sơ xét tuyển LT', timer: 1500, showConfirmButton: false });
      } catch (e: any) {
        Swal.fire({ icon: 'error', title: 'Ghi sang hồ sơ LT thất bại', text: (e && e.message) || '' });
      } finally { arproSaving.value = false; }
    };
    const isPartyFilled = computed(() => !!(moreinfo.value.dateOfParty || moreinfo.value.placeOfParty || moreinfo.value.dateOfGroup || moreinfo.value.placeOfGroup || moreinfo.value.isReserveParty || moreinfo.value.isParty));
    // Badge Người thân 3 trạng thái: bản cũ CHỈ nhìn 2 lựa chọn "Đồng ý cho UMT thông báo" nên cha/mẹ
    // đã điền vẫn bị "Chưa điền" (đọc như mất dữ liệu). Giờ: Đã điền = có người thân + đủ 2 lựa chọn;
    // có một phần -> "Còn thiếu" (tooltip nói thiếu gì); trống hết -> "Chưa điền".
    const relativesHasData = computed(() => {
      const _has = (p: any) => p && ['fullName', 'dateOfBirth', 'occupation', 'mobile', 'email', 'currentAddress']
        .some((k) => String(p[k] ?? '').trim() !== '');
      return _has(personalContacts.value.father) || _has(personalContacts.value.mother) || _has(personalContacts.value.guardian);
    });
    const relativesMissing = computed(() => {
      const m: string[] = [];
      if (!relativesHasData.value) m.push('thông tin cha/mẹ/người khác');
      if (checkAgreeToReleaseOfStudyProgress.value !== 'true') m.push('chọn Thông báo học tập');
      if (checkAgreeToContactInEmergency.value !== 'true') m.push('chọn Liên hệ khẩn cấp');
      return m;
    });
    const isRelativesFilled = computed(() => relativesMissing.value.length === 0);
    const isEnglishFilled = computed(() => !!englishClassPlacementTest.value?.registrationType);
    const isTuitionFilled = computed(() => !!tuitionRegistration.value?.name);
    const selectedPaymentName = computed(() => (optionBanking.value.find((i: any) => i.code == orderDetails.value.paymentMethod) || {}).name || "");
    return {
      isPersonalFilled, isContactFilled, isLearningFilled, isPartyFilled, isRelativesFilled, relativesHasData, relativesMissing, isEnglishFilled, isTuitionFilled, selectedPaymentName,
      isArticulation, arproView,
      arproEnrollment, arproEdit, editArpro, arproSaving,
      arproSysLabel, arproFormLabel, arproScaleLabel, arproHasData, arproMismatch,
      openEditArpro, saveArpro, overwriteArproFromSource, pushArproToSource,
      isInsurance,
      isUniform,
      sectionNo,
      isMobile,
      freeTuitionDiscount,
      scholarshipName,
      submitButton1,
      submitButton2,
      submitButtonRelatives,
      submitButton3,
      submitButton4,
      submitButton5,
      submitButtonEng,
      forSchool,
      saveChanges1,
      savePartyInfo,
      saveChanges2,
      saveRelatives,
      saveChanges3,
      formData,
      emailFormDisplay,
      passwordFormDisplay,
      profileDetailsValidator,
      personalContactsValidator,
      missingImportant,
      missingContact,
      fullName,
      isUmter,
      personalContacts,
      learningProcess,
      tableHeader,
      tableData,
      pagination,
      collegesUniversities,
      isShowFormSchool,
      isShowFormActivities,
      isShowFormStudies,
      isShowFormProjects,
      isShowFormOthers,
      socialHealthcareInsuranceRegistration,
      isHealthInsurance,
      tableDataEnglishCer,
      tableHeaderEnglishCer,
      tableDataImg,
      arrReligion,
      arrEthnic,
      arrNational,
      editProfileDetails,
      editPartyInfo,
      editQrcode,
      initFormData,
      dataProvince,
      dataDistrict,
      dataWard,
      dataPostalDistrict,
      dataPostalWard,
      dataNewProvinces,
      newProvinceOptions,
      dataProvinceForSchool,
      editPersonalContacts,
      editRelatives,
      initDataPersonalContacts,
      initLearningProcess,
      dataDistrictForSchool,
      dataSchoolName,
      editLearningProcess,
      admissionRegistration,
      id,
      dataReset,
      accidentInsuranceRegistration,
      isShowInsurance,
      englishClassPlacementTest,
      isShowEnglishClass,
      initEnglishClass,
      initInsuranceReg,
      isShowUniformReg,
      arrSize,
      uniformRegistration,
      initUniformRegistration,
      supportServices,
      supportServicesOther,
      isShowFormService,
      isShowFreeTuition,
      showTuitionGuide,
      isShowPayments,
      isShowFinancialSupport,
      initSupportServices,
      freeTuitionRegistration,
      tuitionRegistration,
      dataScholarship,
      initfreeTuitionRegistration,
      dataTuition,
      u_tshirt_price,
      u_trousers_price,
      totalUniformReg,
      postalProvinceChange,
      postalDistrictChange,
      autofillPostalFromPermanent,
      autofillMotherAddressFromFather,
      permanentProvinceChange,
      permanentDistrictChange,
      highschoolProvinceChange,
      highschoolDistrictChange,
      highschoolSchoolChange,
      hsProvinceCode,
      hsSchoolCode,
      learningProcessValidator,
      dataSettingItem,
      totalInsurance,
      totalSum,
      totalFeeTuition,
      certificateBarcode,
      isSubmitQr,
      user,
      idAdReg,
      adCode,
      noneNotifiOfReg,
      checkAgreeToReleaseOfStudyProgress,
      checkAgreeToContactInEmergency,
      freeTuitionUnit,
      tshirt_trousers_price,
      orderDetails,
      financialSupportRegistration,
      initPayments,
      initMoreinfo,
      dataBank,
      optionBanking,
      dataPromotionListen,
      dataPromotionListenAddition,
      submitTuitionReg,
      freeTuitionRegistrationValidator,
      uniformRegValidator,
      tempDataPromotion,
      tempDataPromotionAddition,
      moneySiblings,
      moneyPromotion,
      moneyPromotionAddition,
      scholarshipValueListen,
      completeAdm,
      isErrorFormProfileDetails,
      openEditProfileDrawer,
      isErrorFormPersonalContacts,
      isErrorFormLearningProcess,
      isErrorFormFreeTuitionReg,
      isErrorFormUniformReg,
      submitUniform,
      forSchoolValidator,
      insuranceRegValidator,
      englishClassValidator,
      initFinancialSupport,
      financialSupportNo,
      submitInsuranceRegistration,
      submitPayments,
      expiredPromotion,
      getPromotion,
      discountScholarship,
      firstLoad,
      updatePromotion,
      isShowOtherFees,
      submitOtherFees,
      initOtherFees,
      otherFees,
      Permission,
      isPermission,
      canViewSetting,
      canViewScholarship,
      dataRegistrationfeerequest,
      rulesDefault,
      checkIsUpdateScholarship,
      dataScholarshipPro,
      checkConditionscholarship,
      dataFindprereceipts,
      totalFee,
      arrCourseexemptions,
      arrCourseexemptionsShow,
      conditionSubject,
      optionsTypeCondition,
      layoutSubject,
      arrSubject,
      PROMOTIONSIBLING,
      formatTuitionReg,
      promotionChild,
      moneyPromotionVipPro,
      completeAdmission,
      reopenProfile,
      changePhase,
      undoConfirmProfile,
      isSuperAdmin, //nút "Hoàn tác xác nhận" chỉ hiện với superadmin
      sendMailStudent,
      arrChooseCourseexemptions,
      courseNextLevel,
      chooseCourses,
      objCourseexemptions,
      funcHistories,
      dataPayments,
      studentData,
      dataScholarshipAddition,
      dataScholarshipAdditionExtend,
      reduceEnglish,
      moreinfo,
      optionsPrograms,
      userLocal,
      arr_dataTuition,
      dataPromotionListenMulti,
      promotionMultiData,
      dataScholarshipListenAddition,
      scholarshipPromotionMultiData,
      popupMessage,
      isChuyengiao,
      isCancelled,
      isLocked,
      isLockedInfo,
      isFinalApplicant,
      finalEditMode,
      finalEditReason,
      enableFinalEdit,
      disableFinalEdit,
      pendingConditionItems,
      promotionConfigChanged,
      promoDriftDismissed,
      confirmDropPromotion,
      dropCurrentPromotion,
      pendingConditionSum,
      // promotionExtend
    };
  },
});
